<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="300"
    height="400"
    id="milestone-auditlogs"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 246.2 327.2"
    role="presentation"
    aria-labelledby="auditlogslaunch"
  >
    <title id="auditlogslaunch">Launch of audit logs</title>
    <g id="BlackScreen">
      <path
        id="Shadow"
        class="cls-1"
        d="M190.9,249.5l-9.6,5.3.4.6,9.5-5.2Zm1.9,1.1-9.5,5.3.3.6,9.6-5.3Zm1.8,1.2-9.5,5.3.3.6,9.6-5.3Zm2,1-9.6,5.3.4.7,9.5-5.3Zm1.7,1-9.5,5.3.3.7,9.6-5.3Zm1.9,1.1-9.5,5.3.4.7,9.5-5.3Zm1.9,1.2-9.6,5.3.4.7,9.5-5.3Zm2.1,1-9.6,5.3.4.7,9.5-5.3Zm1.8,1.2-9.6,5.3.4.7,9.6-5.3Zm1,1.5-8.6,4.8.4.6,8.6-4.8Zm11.3-4.1-18.1,10.1.3.6,18.2-10.1Zm2.1,1-18.1,10.1.3.6,18.2-10.1Zm.8,1.6-16.3,9,.4.7,16.2-9Zm1.5,1.4L208,268l.3.6,14.8-8.2ZM160.5,232l-9.6,5.3.4.6,9.5-5.3Zm2,1.2-9.5,5.3.3.6,9.6-5.3Zm1.7,1-9.5,5.3.4.7,9.5-5.3Zm2,1.1-9.5,5.3.3.7,9.6-5.3Zm1.8,1.2-9.5,5.3.3.6,9.6-5.3Zm1.9,1-9.5,5.3.4.7,9.5-5.3Zm1.8,1.1-9.5,5.3.3.6,9.6-5.3Zm2,1.1-9.6,5.3.4.6,9.5-5.3Zm1.9,1.1-9.5,5.3.3.7,9.6-5.3Zm2,1.1-9.6,5.3.4.6,9.5-5.3Zm1.8,1.2-9.5,5.3.3.6,9.6-5.3Zm2.1,1-9.6,5.3.4.7,9.5-5.3Zm1.6,1.1-9.6,5.3.4.6,9.5-5.3Zm1.9,1.1-9.5,5.2.3.7,9.6-5.3Zm1.8,1.1-9.5,5.3.4.7,9.5-5.3Zm2.1,1.1-9.5,5.2.3.7,9.6-5.3Zm1.8,1-9.6,5.3.4.7,9.5-5.3Zm-54.4-29.9-6,3.4.3.6,6-3.3Zm3,.6-8.4,4.7.4.6,8.3-4.6Zm2.2.8-9.5,5.2.3.7,9.6-5.3Zm2.1,1-9.5,5.3.3.6,9.6-5.3Zm1.8,1.2-9.5,5.3.4.6,9.5-5.3Zm2.1,1-9.5,5.3.3.6,9.6-5.3Zm1.8,1-9.6,5.3.4.7,9.5-5.3Zm1.9,1.1-9.5,5.3.4.7,9.5-5.3Zm1.7,1.2-9.5,5.3.3.7,9.6-5.3Zm2.1,1-9.6,5.3.4.7,9.5-5.3Zm1.8,1.2-9.5,5.3.3.7,9.6-5.3Zm2,1.1-9.6,5.3.4.7,9.5-5.3Zm81.9,29.8-9.6,5.3.4.6,9.5-5.3Zm1.9,1-9.5,5.3.3.7,9.6-5.3Zm1.8,1.1-9.6,5.3.4.6,9.5-5.2Zm1.9,1.1-9.5,5.3.3.6,9.6-5.3Zm1.8,1.1-9.5,5.3.3.7,9.6-5.3ZM250,266l-9.5,5.3.4.6,9.5-5.3Zm1.9,1.2-9.6,5.3.4.6,9.5-5.3Zm2.1,1-9.6,5.3.4.6,9.5-5.2Zm1.7,1.1-9.5,5.3.3.6,9.6-5.3Zm2,1.1-9.6,5.2.4.7L258,271Zm1.8,1.1-9.6,5.3.4.7,9.6-5.3Zm2.1,1.1-9.6,5.3.4.6,9.5-5.3Zm.8,1.5-7.7,4.3.4.7,7.7-4.3Zm-4.3,5.6-.3-.6,4.6-2.7.3.6ZM210.3,243l-9.6,5.3.4.7,9.5-5.3Zm1.9,1.1-9.5,5.3.3.7,9.6-5.3Zm1.9,1.2-9.6,5.3.4.7,9.5-5.3Zm1.9,1.1-9.5,5.3.3.7,9.6-5.3Zm1.7,1-9.5,5.3.3.7,9.6-5.3Zm2,1.2-9.5,5.3.4.7,9.5-5.3Zm1.8,1.1L212,255l.3.6,9.6-5.3Zm3.9,2.2-7,3.8.3.7,7.1-3.9Zm2.1,1-7,3.8.3.7,7.1-3.9Zm1.8,1.1-8.1,4.4.4.6,8-4.3Zm-6.2,6.4-.4-.6,8.5-4.7.4.6Zm9.8-4.1-9.6,5.3.4.6,9.5-5.3Zm1.9,1-9.5,5.3.3.7,9.6-5.3Zm1.8,1.2-9.5,5.3.4.7,9.5-5.3Zm2.1.9-9.6,5.3.4.6,9.5-5.2Zm1.8,1.2-9.6,5.3.4.6,9.5-5.3Zm-54.4-29.9-6,3.4.3.6,6-3.3Zm2.9.4-8.4,4.7.4.6,8.4-4.6Zm2.3.9-9.5,5.3.3.7,9.6-5.3Zm2.1,1-9.5,5.3.3.7,9.6-5.3Zm1.8,1.1-9.6,5.3.4.7,9.5-5.3Zm2.1,1-9.6,5.3.4.7,9.5-5.3Zm1.8,1.2-9.6,5.3.4.7,9.5-5.3Zm1.9,1.1-9.5,5.3.4.7,9.5-5.3Zm1.7,1.2-9.5,5.3.3.7,9.6-5.3Zm2.1,1-9.6,5.3.4.7,9.5-5.3Zm1.7,1.1L197,246l.4.6,9.5-5.3Zm2,1.1-9.6,5.3.4.6,9.5-5.3Zm-46-28.4-9.6,5.3.4.7,9.6-5.3Zm1.9,1.1-9.5,5.3.4.6,9.5-5.3Zm1.8,1-9.6,5.3.4.7,9.6-5.3Zm2.1,1-9.6,5.3.4.7,9.5-5.3Zm1.6,1.3-9.5,5.3.4.6,9.5-5.3Zm2,1-9.6,5.3.4.7,9.5-5.3Zm1.8,1.2-9.5,5.3.3.7,9.6-5.3Zm2.1,1-9.5,5.3.3.7,9.6-5.3Zm1.8,1.1-9.6,5.3.4.6,9.5-5.2Zm1.9,1.1-9.5,5.3.3.6,9.6-5.3Zm1.8,1.2-9.5,5.3.3.6,9.6-5.3Zm2.1,1-9.5,5.3.3.6,9.6-5.2Zm.9,1.6-7.7,4.3.3.6,7.8-4.3Zm-4.4,5.5-.3-.6,4.7-2.7.4.6Zm-47.8-36.6-9.5,5.3.3.6,9.6-5.3Zm2,1.1-9.6,5.2.4.7,9.5-5.3Zm1.8,1.2-9.6,5.2.4.7,9.5-5.3Zm2.1,1-9.6,5.3.4.6,9.5-5.3Zm1.6,1-9.6,5.3.4.7,9.5-5.3Zm2,1.2-9.6,5.3.4.7,9.5-5.3Zm1.7,1.1-9.5,5.3.4.7,9.5-5.3Zm2.1,1-9.5,5.3.3.7,9.6-5.3Zm1.9,1.2-9.6,5.3.4.7,9.5-5.3Zm1.9,1.1-9.5,5.3.3.6,9.6-5.2Zm1.8,1.1-9.6,5.3.4.6,9.5-5.3Zm2.1,1-9.6,5.3.4.6,9.5-5.3Zm1.6,1.2-9.5,5.3.3.6,9.6-5.3Zm2,1.1-9.6,5.3.4.6,9.5-5.3Zm1.8,1.2-9.6,5.2.4.7,9.5-5.3Zm2,.8-9.6,5.3.4.7,9.6-5.3Zm1.8,1.2-9.5,5.3.3.7,9.6-5.3Zm-54.4-29.8-6,3.3.4.7,6-3.4Zm2.9.4-8.3,4.6.3.7,8.4-4.7Zm2.5.8-9.6,5.3.4.6,9.5-5.3Zm2,1.1-9.6,5.3.4.6,9.5-5.3Zm1.7,1-9.5,5.3.3.7,9.6-5.3Zm2.1,1.1-9.6,5.3.4.6,9.5-5.3Zm1.8,1.1-9.5,5.3.3.7,9.6-5.3Zm2,1.1-9.6,5.3.4.7,9.5-5.3Zm1.6,1.2-9.5,5.3.4.7,9.5-5.3Zm2.1,1-9.5,5.3.3.7,9.6-5.3Zm1.8,1.1-9.6,5.3.4.7,9.5-5.3Zm1.9,1.1-9.5,5.3.3.6,9.6-5.3Z"
        transform="translate(-47.2 -26.7)"
      />
      <g id="Lower_Part" data-name="Lower Part">
        <path
          class="cls-1"
          d="M244.3,238v-4.8a.7.7,0,0,0-.1-.5,2.8,2.8,0,0,0-1.2-1.9l-77.4-44.7a6.1,6.1,0,0,0-6,.1l-32.1,18.6c-1.1.6-1.7,1.3-1.7,2.2s0,.3.1.4v5a2.5,2.5,0,0,0,1.2,2l77.4,44.8a23.9,23.9,0,0,0,2.9,1,6.6,6.6,0,0,0,3.3-.9l32.1-18.6A2.7,2.7,0,0,0,244.3,238Zm-114-23.2h-.9v-4.6h.9Zm77.3,44.1h-.9v-4.7h.9Zm21.5-11.7-3.7-2.1.4-.9,3.7,2.2Zm11.3-6.8h-.9v-4.6h.9Zm1.4-6.4-32.1,18.6c-1.5.7-3.6.9-4.8.1l-77.4-44.8a.9.9,0,0,1-.6-.7c0-.5.4-.9,1-1.2l32.3-18.7a5.4,5.4,0,0,1,4.6,0L242.2,232c.3.2.6.5.6.8A1.6,1.6,0,0,1,241.8,234Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M242.2,232l-77.4-44.7a5.4,5.4,0,0,0-4.6,0L127.9,206c-.6.3-1,.7-1,1.2a.9.9,0,0,0,.6.7l77.4,44.8c1.2.8,3.3.6,4.8-.1L241.8,234a1.6,1.6,0,0,0,1-1.2C242.8,232.5,242.5,232.2,242.2,232Zm-71-24.9,22.4,13-.4.8-22.4-13ZM137,211.2l-4.8-2.4a1.6,1.6,0,0,1-.9-1.5,1.6,1.6,0,0,1,.8-1.5l6.9-4,.6,1-6.9,4.1c-.2,0-.2.3-.2.3s0,.1.2.3l4.9,2.7Zm72.2,39.1a2.3,2.3,0,0,1-1.8.6,2.6,2.6,0,0,1-1.8-.6L139,212.1l.6-1,66.6,38.2a2.5,2.5,0,0,0,2.4,0l6.7-4.2.6,1Z"
          transform="translate(-47.2 -26.7)"
        />
        <rect class="cls-3" x="159.5" y="227.5" width="0.9" height="4.64" />
        <rect class="cls-3" x="192.4" y="209.1" width="0.9" height="4.64" />
        <rect class="cls-3" x="82.2" y="183.5" width="0.9" height="4.64" />
        <polygon class="cls-3" points="146.4 193.4 124 180.5 123.6 181.2 146 194.2 146.4 193.4" />
        <polygon
          class="cls-3"
          points="178.2 218.4 181.9 220.5 182.3 219.8 178.6 217.5 178.2 218.4"
        />
        <path
          class="cls-1"
          d="M208.6,249.3a2.5,2.5,0,0,1-2.4,0l-66.6-38.2-.6,1,66.6,38.2a2.6,2.6,0,0,0,1.8.6,2.3,2.3,0,0,0,1.8-.6l6.7-4.2-.6-1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M132.5,207.2s0-.3.2-.3l6.9-4.1-.6-1-6.9,4a1.6,1.6,0,0,0-.8,1.5,1.6,1.6,0,0,0,.9,1.5l4.8,2.4.6-1-4.9-2.7C132.5,207.3,132.5,207.2,132.5,207.2Z"
          transform="translate(-47.2 -26.7)"
        />
      </g>
      <g id="Blackboard">
        <path
          class="cls-2"
          d="M109.9,33.1l-8.7-5c-.2,0-.2-.2-.3-.2a.4.4,0,0,0-.3.2l-4.5,2.5,9.1,5.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="224.2 228.3 224.2 231.3 229.1 228.3 229.1 225.4 224.3 228.4 224.2 228.3"
        />
        <polygon class="cls-2" points="61.7 11.4 66.4 8.6 63.8 7.1 59.2 9.9 61.7 11.4" />
        <path
          class="cls-2"
          d="M271.2,133.4a5.9,5.9,0,0,1,.2,1.3v3.7l4.9-3v-4.1a2.8,2.8,0,0,0-.1-.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M271.4,259.9V268l4.6-2.6c.2-.1.3-.3.3-.7v-8.3l-4.9,3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M269.4,131a2.4,2.4,0,0,1,1.3,1.3l5-3a2.3,2.3,0,0,0-.7-.7L114.8,35.9l-4.7,2.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="224.2 113 224.2 227 229.1 224 229.1 110.1 224.2 113.1 224.2 113"
        />
        <path
          class="cls-1"
          d="M275.6,127.5,101.9,27a1.7,1.7,0,0,0-1.9,0l-5.7,3.2H94a2.2,2.2,0,0,0-.9,2V165.4a4.2,4.2,0,0,0,1.9,3.7L268.7,269.6a1.9,1.9,0,0,0,1,.3h.8l.5-.4,5.8-3.2a2.5,2.5,0,0,0,.7-1.8V131.3A4.3,4.3,0,0,0,275.6,127.5Zm-.6,1.1a2.3,2.3,0,0,1,.7.7l-5,3a2.4,2.4,0,0,0-1.3-1.3L110.1,38.7l4.7-2.8ZM113.6,35.2l-4.7,2.9-2.5-1.5,4.6-2.8Zm-13-7.1a.4.4,0,0,1,.3-.2c.1,0,.1.2.3.2l8.7,5-4.7,2.8-9.1-5.3ZM276.3,264.7c0,.4-.1.6-.3.7l-4.6,2.6v-8.6l4.9-3Zm0-9.7-4.9,3v-3.1h0l4.9-2.9Zm0-4.3-4.9,3V139.6h0l4.9-2.9Zm0-115.3-4.9,3v-3.7a5.9,5.9,0,0,0-.2-1.3l5-3a2.8,2.8,0,0,1,.1.9Z"
          transform="translate(-47.2 -26.7)"
        />
      </g>
      <g class="bblock" id="Block_7" data-name="Block 7">
        <polygon
          class="cls-1"
          points="33.8 164.6 33 164.2 6.6 179.5 7.3 179.9 18.1 173.8 33.8 164.6"
        />
        <polygon class="cls-1" points="35 165.4 8.7 180.7 9.4 181.1 35.7 165.8 35 165.4" />
        <polygon class="cls-1" points="37.1 166.6 10.6 181.9 11.4 182.3 37.8 167 37.1 166.6" />
        <polygon class="cls-1" points="39.2 167.8 12.7 183.1 13.5 183.5 39.8 168.2 39.2 167.8" />
        <polygon class="cls-1" points="41.1 169 14.6 184.3 15.4 184.7 41.8 169.4 41.1 169" />
        <polygon class="cls-1" points="43 170.2 16.7 185.5 17.5 185.9 43.8 170.6 43 170.2" />
        <polygon class="cls-1" points="45.1 171.4 18.7 186.7 19.4 187.1 45.9 171.8 45.1 171.4" />
        <polygon class="cls-1" points="47.1 172.6 20.8 187.9 21.5 188.3 47.8 173 47.1 172.6" />
        <path
          class="cls-1"
          d="M96.5,200.6l-.3-.2L69.8,215.7l.6.3h.1l26.3-15.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M72.5,216.6H74l23.4-13.5a1.8,1.8,0,0,0,.2-1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M71,186.8,47.3,200.4a2.8,2.8,0,0,0-.1.9l25.3-14.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M74.2,187.4,47.8,202.5c.1.2.3.2.4.3l.3.2L75,187.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon class="cls-1" points="29 161.9 2.5 177.2 3.3 177.5 29.7 162.2 29 161.9" />
        <polygon class="cls-1" points="30.9 163.1 4.6 178.4 5.2 178.7 31.7 163.4 30.9 163.1" />
      </g>
      <g class="bblock" id="Block_6" data-name="Block 6">
        <path
          class="cls-3"
          d="M71.1,202.3h-.7a4.9,4.9,0,0,1-1.4-.3l-14-8.2-.2,4.2L69.6,207a1.9,1.9,0,0,0,1.5,0Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-3"
          d="M51.2,196l2.5,1.4v-4.2l-2.7-1.5v4.1S51.1,196,51.2,196Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M91.1,190.2h0a1.7,1.7,0,0,0-.7-1.2L71.9,178.1a3.2,3.2,0,0,0-3,.2L50.6,188.8a1.6,1.6,0,0,0-.9,1.3c0,.1.1.1.1.2h-.1v5.7a1.4,1.4,0,0,0,.8,1.2L69,208.1a4.9,4.9,0,0,0,1.4.3,1.7,1.7,0,0,0,1.2-.4h.3l18.5-10.4c.6-.4.9-.7.9-1.3v-5.7A.8.8,0,0,0,91.1,190.2ZM69.6,207l-14.8-8.9.2-4.2,14,8.2a4.9,4.9,0,0,0,1.4.3h.7V207A1.9,1.9,0,0,1,69.6,207Zm1.7-27.8L89.8,190h.1l-.3.3L71.4,200.7a2.9,2.9,0,0,1-1.8.2L51.1,190.1a.4.4,0,0,0,.1-.3l18.3-10.5A2.3,2.3,0,0,1,71.3,179.2Zm13.6,20.1v-5.1h1v5.1Zm-33.8-7.6,2.7,1.5v4.2L51.2,196c-.1,0-.1-.2-.1-.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M51.2,189.8a.4.4,0,0,1-.1.3l18.5,10.8a2.9,2.9,0,0,0,1.8-.2l18.2-10.4.3-.3h-.1L71.3,179.2a2.3,2.3,0,0,0-1.8.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <rect
          class="cls-3"
          x="82.9"
          y="196.2"
          width="5.1"
          height="1.05"
          transform="translate(-159.7 252.7) rotate(-89.2)"
        />
      </g>
      <g class="bblock" id="Block_1" data-name="Block 1">
        <path
          class="cls-2"
          d="M60.8,179.2,57,181.8l3.3,2a2,2,0,0,1,.9.9l3.9-2.5a.7.7,0,0,0-.3-.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M66.5,182.3a2.1,2.1,0,0,0-1.1-1.8l-4-2.4H60.3l-4.9,3.2-.2.2c-.4.1-.5.5-.5,1v4a2,2,0,0,0,1,1.8l4.1,2.4c.1.2.4.2.5.2l.4-.2.3-.2h.2l5-3h.1a2.2,2.2,0,0,0,.3-.9v-3.8A.4.4,0,0,0,66.5,182.3Zm-5,5.9-.6-.9,4.4-2.6.5.9Zm-.3-3.5a2,2,0,0,0-.9-.9l-3.3-2,3.8-2.6,4,2.4a.7.7,0,0,1,.3.6Zm-5.3-1.9,3.7,2.2a1.1,1.1,0,0,1,.3.8v3.6h0l-3.7-2.2a1.1,1.1,0,0,1-.3-.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-3"
          d="M59.9,189.5h0v-3.6a1.1,1.1,0,0,0-.3-.8l-3.7-2.2v3.7a1.1,1.1,0,0,0,.3.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon class="cls-3" points="18.1 158 13.7 160.6 14.3 161.5 18.6 158.9 18.1 158" />
      </g>
      <g id="blackboard-words">
        <path
          class="cls-4"
          d="M122.7,144.6l-.4-.4c-.2-.1-.5-.1-.5.2a2.7,2.7,0,0,0-.2,1.3c0,.5.1.8.1,1.1l1.1-2C122.8,144.7,122.7,144.7,122.7,144.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M199.2,153.1a.8.8,0,0,0-.5-.5h-.4c-.2,0-.3.3-.3.6l1.4.7A1.9,1.9,0,0,0,199.2,153.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.9,172.4l-.4-.3c-.3-.2-.5-.1-.6.1a3.8,3.8,0,0,0-.1,1.3v1.1l1.1-2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M199.3,134.6a.8.8,0,0,0-.5-.5h-.4a.6.6,0,0,0-.3.6l1.4.7A2.4,2.4,0,0,0,199.3,134.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M198.6,180.3a.4.4,0,0,0-.5,0,2,2,0,0,0-.1.9,3.7,3.7,0,0,0,.1,1.1l.5.5c.2.2.4.2.5-.1a2.8,2.8,0,0,0,.1-.8c0-.4-.1-.8-.1-1S198.8,180.5,198.6,180.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.7,153.8c-.1-.1-.2-.3-.4-.4s-.5-.1-.5.2a2.7,2.7,0,0,0-.2,1.3c0,.5.1.8.1,1.1l1.1-2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.2,166.6h.4l.3-.4v-1.9l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.7,163.1l-.4-.4a.3.3,0,0,0-.5.2,2.7,2.7,0,0,0-.2,1.3c0,.5.1.8.1,1.1l1.1-2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.3,157.3h.4c.1,0,.2-.2.2-.4a3.7,3.7,0,0,0,.1-1.1V155l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M171.1,98.6c-.1-.1-.2-.3-.4-.4a.4.4,0,0,0-.6.2,10.9,10.9,0,0,0-.1,1.3c0,.5.1.8.1,1.1l1.1-2C171.2,98.7,171.1,98.7,171.1,98.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M259.4,206.3a.8.8,0,0,0-.5-.5c-.2-.1-.3-.1-.4,0a.6.6,0,0,0-.3.6l1.4.7A2.4,2.4,0,0,0,259.4,206.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M210.4,133.2a.3.3,0,0,0-.3.3c0,.2.1.3.2.5l.3.3c.1.1.2.2.3.1s.3-.1.3-.2v-.6l-.2-.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.5,83.5h.4l.2-.5a3.1,3.1,0,0,0,.1-1.1v-.7L122.1,83A1,1,0,0,0,122.5,83.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M206.7,169.1h.4c.1-.1.1-.4.1-.9v-.8l-.2-.5-.3-.3h-.3l-.3.2v1.7c.1.2.2.4.3.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.4,194.5h.4c.1-.1.1-.3.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8L170,194Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.5,74.3c.2.1.4.1.4,0a1.1,1.1,0,0,0,.3-.5V72l-1.1,1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.9,61.6c0-.2-.2-.3-.4-.4s-.4-.1-.5.1a3.7,3.7,0,0,0-.2,1.4c0,.4.1.8.1,1.1l1.1-2.1A.1.1,0,0,1,122.9,61.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.5,65h.4c.1,0,.2-.2.3-.4V62.7l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.5,102h.4l.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8l-1.1,1.9C122.1,101.7,122.3,101.8,122.5,102Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.9,98.5l-.4-.4c-.3-.2-.5-.1-.6.1a4.2,4.2,0,0,0-.1,1.4v1.1l1.1-2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.7,92.9h.4c.1-.1.1-.3.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M171.1,89.4c-.1-.1-.2-.3-.4-.4a.4.4,0,0,0-.6.2,10.9,10.9,0,0,0-.1,1.3c0,.5.1.8.1,1.1l1.1-2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.9,89.3l-.4-.4c-.3-.2-.5-.1-.6.1a4.2,4.2,0,0,0-.1,1.4v1.1l1.1-2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.9,80c0-.2-.2-.3-.4-.4s-.4-.1-.5.1a3.7,3.7,0,0,0-.2,1.4c0,.4.1.8.1,1.1l1.1-2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.4,111.2h.4c.1-.1.1-.2.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.5,92.8a.3.3,0,0,0,.4,0l.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8l-1.1,1.9C122.1,92.5,122.3,92.6,122.5,92.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.9,70.8c0-.2-.2-.3-.4-.4s-.4-.1-.5.1a3.7,3.7,0,0,0-.2,1.4c0,.4.1.8.1,1.1l1.1-2.1A.1.1,0,0,1,122.9,70.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.3,138.9h.4a.8.8,0,0,0,.2-.5,3.1,3.1,0,0,0,.1-1.1v-.8l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.4,129.7h.4c.1-.1.1-.3.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.8,126.1l-.4-.4a.4.4,0,0,0-.6.2c0,.2-.1.6-.1,1.3s.1.8.1,1.1l1.1-2C122.9,126.2,122.8,126.2,122.8,126.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.8,135.4l-.4-.4c-.3-.1-.5-.1-.6.2a10.9,10.9,0,0,0-.1,1.3c0,.5.1.8.1,1.1l1.1-2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.4,120.5h.4c.1-.1.1-.3.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8L122,120Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.3,148.1h.4c.1,0,.2-.2.2-.4a3.7,3.7,0,0,0,.1-1.1v-.8l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.9,107.7l-.4-.4a.4.4,0,0,0-.6.2,3.8,3.8,0,0,0-.1,1.3v1.1l1.1-2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M122.8,116.9l-.4-.4a.4.4,0,0,0-.6.2c0,.2-.1.6-.1,1.3s.1.8.1,1.1l1.1-2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M234.6,148.2c.2.1.3.2.4.1l.3-.2v-.6H235l-.6-.3c-.1,0-.2.1-.2.3a4.3,4.3,0,0,0,.1.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M226.3,161c-.1,0-.2,0-.2.3a4.3,4.3,0,0,1,.1.5l.4.3h.6v-.6l-.3-.2A.7.7,0,0,0,226.3,161Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M222.7,178.3h.5c.1-.1.1-.4.1-.9a2.8,2.8,0,0,0-.1-1c-.1-.3-.3-.4-.5-.6a.4.4,0,0,0-.5,0,7.8,7.8,0,0,0-.1.9c0,.5.1.9.1,1.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M222.8,169.1h.4c.1,0,.1-.3.1-.8v-.8a.8.8,0,0,0-.2-.5l-.3-.3h-.3l-.3.2v1.7l.3.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M239.3,204c-.1-.3-.3-.4-.5-.6h-.5a1,1,0,0,0-.2.7l1.3.7A1.7,1.7,0,0,0,239.3,204Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M226.8,196.4h-.5a1,1,0,0,0-.2.7l1.3.7c0-.3-.1-.6-.1-.8S227,196.6,226.8,196.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M242.4,161c-.1,0-.2.1-.2.4s.1.3.1.4.2.3.4.3h.6v-.7h-.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M218.7,210.3a.4.4,0,0,0-.5,0c-.1,0-.2.3-.2.6l1.3.7a2.2,2.2,0,0,0-.1-.8A1.2,1.2,0,0,0,218.7,210.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M242.9,143.7c.2.2.4,0,.5,0a5.5,5.5,0,0,0,.1-.9c0-.4-.1-.8-.1-1s-.3-.4-.5-.6h-.5a2,2,0,0,0-.1.9,3.1,3.1,0,0,0,.1,1.1A1.2,1.2,0,0,0,242.9,143.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M226.2,225.6a.3.3,0,0,0-.3.3c0,.2.1.3.2.5l.3.3h.3c.2,0,.2-.1.3-.2V226l-.2-.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M230.7,189.7c-.2-.2-.4-.2-.5,0a5.4,5.4,0,0,0-.1.8c0,.5.1.9.1,1.1s.3.4.5.6.4.1.5-.1.1-.4.1-.9a3.1,3.1,0,0,0-.1-1A.8.8,0,0,0,230.7,189.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M222.9,148h-.5c-.2.1-.2.3-.2.6l1.3.7a2.4,2.4,0,0,0-.2-.8A.7.7,0,0,0,222.9,148Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M214.7,182.9c.2.2.4.1.5-.1a5.4,5.4,0,0,0,.1-.8c0-.4-.1-.8-.1-1.1a1.2,1.2,0,0,0-.5-.5c-.2-.2-.4-.2-.5,0s-.1.4-.1.9a3.7,3.7,0,0,0,.1,1.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M258.9,190c.2.1.3.1.4-.2a1.3,1.3,0,0,0,.2-.8,1.7,1.7,0,0,0-.1-.8.8.8,0,0,0-.2-.5l-.3-.2h-.3l-.2.2v1.8c.1.1.1.3.2.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M214.8,152.7h-.5a1.7,1.7,0,0,0-.2.9,3.6,3.6,0,0,0,.2,1.1.8.8,0,0,0,.5.5c.1.1.4.1.4-.1s.2-.3.2-.8a2.5,2.5,0,0,0-.2-1C215.2,153,215,152.9,214.8,152.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M219.1,173.9l-.3-.4h-.6v1.8l.3.3c0,.1.2.2.3.3h.4c.1-.1.1-.4.1-.9v-.8C219.3,174.2,219.2,173.9,219.1,173.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M218.7,201.1h-.5c-.1,0-.2.3-.2.6l1.3.7a2.2,2.2,0,0,0-.1-.8A1.2,1.2,0,0,0,218.7,201.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.9,181.6l-.4-.3c-.3-.2-.5-.1-.6.1a3.8,3.8,0,0,0-.1,1.3v1.1l1.1-2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.5,185.2a.3.3,0,0,0,.4,0l.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8l-1.1,1.9C170.1,184.9,170.3,185,170.5,185.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M219.4,127.7a.8.8,0,0,0-.5-.5c-.2-.1-.4-.1-.4,0s-.3.3-.3.6l1.4.7A1.9,1.9,0,0,0,219.4,127.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M219.2,137l-.3-.3h-.6v1.8l.2.4.4.2h.4a5.5,5.5,0,0,0,.1-.9,1.5,1.5,0,0,0-.1-.7A.7.7,0,0,0,219.2,137Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M214.6,189.5h-.4c-.1.1-.1.2-.1.4a1.5,1.5,0,0,0,.1.7l.4.3c.2.1.3.2.4.1a.5.5,0,0,0,.2-.4,1.4,1.4,0,0,0-.2-.6A.8.8,0,0,0,214.6,189.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M250.9,173.4h-.5a.8.8,0,0,0-.2.6l1.3.7a2.2,2.2,0,0,0-.1-.8A1.2,1.2,0,0,0,250.9,173.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.8,190.9l-.4-.4a.4.4,0,0,0-.6.2,10.9,10.9,0,0,0-.1,1.3c0,.5.1.8.1,1.1l1.1-2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M250.8,228.8c-.3-.1-.4-.1-.5,0s-.3.3-.3.7l1.4.7a1.5,1.5,0,0,0-.2-.8A1.3,1.3,0,0,0,250.8,228.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M214.3,144.8c-.2,0-.2,0-.2.3a1.1,1.1,0,0,0,.1.5c.1,0,.2.2.3.3h.7v-.6l-.3-.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M246.7,198.8c-.1-.2-.3-.2-.3-.1a.5.5,0,0,0-.2.4,1.1,1.1,0,0,0,.2.6c0,.2.2.3.3.4s.4.2.4.1a.6.6,0,0,0,.2-.5,1.1,1.1,0,0,0-.2-.5C247.1,199,246.9,198.9,246.7,198.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M254.9,169.1c.3.2.4.2.5,0s.1-.4.1-.9a2.8,2.8,0,0,0-.1-1,1,1,0,0,0-.5-.6h-.5a7.8,7.8,0,0,0-.1.9c0,.5.1.9.1,1.1A1.2,1.2,0,0,0,254.9,169.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M262.4,210.3l.3.4h.4l.2-.2v-1.7l-.2-.4-.3-.3h-.5a1.4,1.4,0,0,0-.2.9,2.2,2.2,0,0,0,.1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M254.5,149.5c-.1,0-.2.1-.2.3s.1.3.1.5l.4.3h.3l.3-.2v-.6l-.2-.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M263,142.3c-.2,0-.5,0-.5.2a3.5,3.5,0,0,0-.2,1.3,5.4,5.4,0,0,0,.2,1.5c0,.4.3.6.5.8s.5.1.6-.2.1-.7.1-1.3-.1-1.1-.1-1.5A1.7,1.7,0,0,0,263,142.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M239.4,167l-.5-.5h-.5c-.1,0-.2.3-.2.6l1.3.7C239.5,167.5,239.4,167.3,239.4,167Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M206.8,147.9h-.4a.6.6,0,0,0-.3.6l1.4.7a1.4,1.4,0,0,0-.2-.7A1,1,0,0,0,206.8,147.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M234.8,157.6c.2.1.4.1.5-.1s.1-.4.1-.9a3.1,3.1,0,0,0-.1-1l-.5-.5c-.2-.2-.4-.2-.5,0a5.4,5.4,0,0,0-.1.8c0,.5.1.9.1,1.1S234.6,157.4,234.8,157.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M247,152.6h-.5a1,1,0,0,0-.2.7l1.3.7c0-.3-.1-.6-.1-.8S247.2,152.8,247,152.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M215.2,134.6l-.3-.3h-.4l-.2.2v1.7l.2.4.4.2c.1.2.3.2.3,0s.2-.3.2-.8a1.9,1.9,0,0,0-.1-.8A4.3,4.3,0,0,0,215.2,134.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M234.6,172.3l-.3-.2v1.5l.3.2c.3.1.4.2.6.1s.2-.1.2-.4,0-.6-.2-.7A1,1,0,0,0,234.6,172.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.5,176h.4l.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8l-1.1,1.9C170.1,175.7,170.3,175.7,170.5,176Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M206.6,212.5h-.5a1.2,1.2,0,0,0-.2.7l1.3.7a1.9,1.9,0,0,0-.1-.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon class="cls-4" points="199.2 108.6 200.2 109.2 199.7 106.5 199.2 108.6" />
        <path
          class="cls-4"
          d="M242.9,150.3c-.2-.1-.3-.1-.4,0s-.2.1-.2.4a1.4,1.4,0,0,0,.2.6l.4.4h.4a.7.7,0,0,0,.1-.5,1.3,1.3,0,0,0-.1-.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M250.9,155.1h-.5a5.5,5.5,0,0,0-.1.9,1.9,1.9,0,0,0,.1.8.9.9,0,0,0,.1.5l.3.3h.4l.3-.2v-1.7l-.3-.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M246.7,235.7h-.4a.8.8,0,0,0-.3.7l1.4.7a1.9,1.9,0,0,0-.2-.8A1.3,1.3,0,0,0,246.7,235.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.8,116.8c0-.2-.2-.3-.4-.4s-.4-.1-.5.1a4.4,4.4,0,0,0-.2,1.5v1.1l1.2-2.2A.1.1,0,0,1,106.8,116.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.4,120.4h.4c0-.1.1-.2.2-.5a3.1,3.1,0,0,0,.1-1.1V118l-1.1,1.9C106,120.1,106.1,120.2,106.4,120.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M191.2,139.2a1,1,0,0,0-.5-.6h-.4c-.2.1-.3.3-.3.7l1.4.7A1.9,1.9,0,0,0,191.2,139.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.3,129.7h.4c.1-.1.1-.3.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.8,126.1l-.4-.4c-.3-.2-.5-.1-.6.1a4.9,4.9,0,0,0-.1,1.4,4,4,0,0,0,0,1.1l1.1-2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M186.6,173.4c-.3-.2-.4-.2-.5,0a1.4,1.4,0,0,0-.2.9,3.6,3.6,0,0,0,.2,1.1l.5.5c.2.2.4.1.4-.1a1.3,1.3,0,0,0,.2-.8,3.6,3.6,0,0,0-.2-1.1A.7.7,0,0,0,186.6,173.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.8,98.4c0-.2-.2-.3-.4-.4s-.4-.1-.5.1a3.7,3.7,0,0,0-.2,1.4v1.1l1.2-2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.4,111.2h.4c0-.1.1-.2.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8l-1.1,1.9C106,110.9,106.2,111,106.4,111.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.8,107.8h0l-.4-.5c-.2-.2-.4-.1-.5.1a4.4,4.4,0,0,0-.2,1.5v1.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.8,135.3c-.1-.2-.3-.4-.4-.4s-.5-.1-.6.1a4.9,4.9,0,0,0-.1,1.4,4,4,0,0,0,0,1.1l1.1-2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.3,138.9h.4c.1-.1.1-.3.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.8,144.5l-.4-.4c-.3-.2-.5-.1-.6.1a4.9,4.9,0,0,0-.1,1.4,4,4,0,0,0,0,1.1l1.1-2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.6,111.3h.4c.2,0,.2-.2.2-.4a3.7,3.7,0,0,0,.1-1.1V109l-1.1,1.9C170.4,111,170.5,111.2,170.6,111.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.3,148.1h.4c.1-.1.1-.3.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8l-1.1,1.9A.9.9,0,0,0,106.3,148.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M190.7,157.3c-.3-.2-.4-.2-.5,0a1.3,1.3,0,0,0-.2.8,2.7,2.7,0,0,0,.2,1.1,1,1,0,0,0,.5.6.2.2,0,0,0,.4-.1,1.4,1.4,0,0,0,.2-.9,3.6,3.6,0,0,0-.2-1A1,1,0,0,0,190.7,157.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.7,153.7l-.4-.4a.4.4,0,0,0-.6.2c0,.2-.1.7-.1,1.4a4,4,0,0,0,0,1.1l1.2-2.1C106.8,153.8,106.7,153.8,106.7,153.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M171,107.8c-.1-.1-.2-.3-.4-.4s-.5-.1-.5.2a2.7,2.7,0,0,0-.2,1.3c0,.5.1.8.1,1.1l1.1-2C171.1,107.9,171,107.9,171,107.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.2,157.3h.4c.1,0,.2-.2.2-.4a3.7,3.7,0,0,0,.1-1.1V155l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.4,101.9h.4c.1-.1.1-.2.2-.5a3.1,3.1,0,0,0,.1-1.1v-.7l-1.1,1.8A.7.7,0,0,0,106.4,101.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.7,102.1c.2.1.3.1.4,0s.1-.2.2-.4a3.7,3.7,0,0,0,.1-1.1v-.8l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M107,61.4c-.1-.1-.2-.3-.4-.4a.4.4,0,0,0-.6.2c0,.2-.1.7-.1,1.4a4,4,0,0,0,0,1.1l1.2-2.1C107.1,61.5,107,61.5,107,61.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M107,52.2c-.1-.1-.2-.3-.4-.4a.4.4,0,0,0-.6.2c0,.2-.1.7-.1,1.4a4,4,0,0,0,0,1.1l1.2-2.1C107.1,52.3,107,52.3,107,52.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.5,65h.4c.1,0,.2-.2.2-.4a3.7,3.7,0,0,0,.1-1.1v-.8l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.5,55.8c.2.1.3.1.4,0s.2-.2.2-.4a3.7,3.7,0,0,0,.1-1.1v-.8l-1.1,1.9C106.2,55.5,106.4,55.6,106.5,55.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M186.7,108.8c-.2-.2-.4-.2-.4,0s-.2.3-.2.8a2.7,2.7,0,0,0,.2,1.1c0,.3.2.4.4.6s.4.1.5-.1a1.4,1.4,0,0,0,.2-.9,2.5,2.5,0,0,0-.2-1A.8.8,0,0,0,186.7,108.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M183,153.5l.3-.2v-1l-.3-.5-.5-.3-.4-.3v1.7l.5.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M186.8,117.9a.4.4,0,0,0-.5,0,.8.8,0,0,0-.2.6l1.3.7a2.2,2.2,0,0,0-.1-.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M186.9,99.4c-.3-.1-.4-.1-.5,0a.8.8,0,0,0-.2.6l1.3.7c0-.3-.1-.5-.1-.8S187.1,99.6,186.9,99.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.4,92.7h.4a1.1,1.1,0,0,0,.3-.5V90.4L106,92.2A1,1,0,0,0,106.4,92.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M187.2,146.1a.8.8,0,0,0-.5-.5h-.4c-.2,0-.3.3-.3.6l1.4.7A1.9,1.9,0,0,0,187.2,146.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.4,83.5h.4a1.1,1.1,0,0,0,.3-.5V81.2L106,83Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.9,89.1a.8.8,0,0,0-.4-.4.3.3,0,0,0-.5.2,3.7,3.7,0,0,0-.2,1.4,4,4,0,0,0,0,1.1l1.2-2.1C107,89.2,106.9,89.2,106.9,89.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.8,80c0-.2-.2-.3-.3-.5a.3.3,0,0,0-.5.2,3.7,3.7,0,0,0-.2,1.4,4,4,0,0,0,0,1.1l1.1-2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M187.3,127.6l-.5-.5h-.5a.8.8,0,0,0-.2.6l1.3.7A2.2,2.2,0,0,0,187.3,127.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.4,74.2h.4c.1,0,.2-.2.3-.4V71.9L106,73.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M106.9,70.6c-.1-.1-.2-.3-.4-.4s-.5-.1-.5.2a3.7,3.7,0,0,0-.2,1.4,4,4,0,0,0,0,1.1l1.2-2.1C107,70.7,106.9,70.7,106.9,70.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.5,157.5h.4a1.1,1.1,0,0,0,.3-.5v-1.9l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.9,154c0-.2-.2-.3-.4-.4s-.4-.1-.5.1a3.7,3.7,0,0,0-.2,1.4c0,.4.1.8.1,1.1l1.1-2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.9,144.8c0-.2-.2-.3-.4-.4s-.4-.1-.5.1a3.7,3.7,0,0,0-.2,1.4c0,.4.1.8.1,1.1l1.1-2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M171,117.1a.8.8,0,0,0-.4-.4.3.3,0,0,0-.5.2,2.7,2.7,0,0,0-.2,1.3c0,.5.1.8.1,1.1l1.1-2.1A.1.1,0,0,1,171,117.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.9,163.2l-.4-.3c-.3-.2-.5-.1-.6.1a3.8,3.8,0,0,0-.1,1.3v1.1l1.1-2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.6,120.5h.4c.1,0,.2-.2.2-.4a3.7,3.7,0,0,0,.1-1.1v-.8l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.5,139h.4l.3-.4v-1.9l-1.1,1.9C170.3,138.7,170.4,138.9,170.5,139Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.5,148.3h.4a1.1,1.1,0,0,0,.3-.5v-1.9l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M190.1,186.3c-.2,0-.2.1-.2.3a.9.9,0,0,0,.1.5l.3.3h.4l.3-.2v-.6l-.3-.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M171,126.3a.8.8,0,0,0-.4-.4.3.3,0,0,0-.5.2,2.7,2.7,0,0,0-.2,1.3c0,.5.1.8.1,1.1l1.1-2.1A.1.1,0,0,1,171,126.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.5,166.7a.3.3,0,0,0,.4,0l.2-.5a3.1,3.1,0,0,0,.1-1.1v-.8l-1.1,1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.6,129.8h.4a.5.5,0,0,0,.2-.4,3.7,3.7,0,0,0,.1-1.1v-.8l-1.1,1.9C170.3,129.5,170.5,129.6,170.6,129.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-4"
          d="M170.9,135.5c0-.2-.2-.3-.4-.4s-.4-.1-.5.2a2.7,2.7,0,0,0-.2,1.3c0,.5.1.8.1,1.1l1.1-2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M102,52.9l.9-.4.6-.4.3-.5V51a2.5,2.5,0,0,0-.1-.8,1.2,1.2,0,0,0-.5-.9l-.8-.7-1-.3a.7.7,0,0,0-.6.3l.6.9.4-.2a.6.6,0,0,1,.5.2c.1,0,.3.2.4.4a1.4,1.4,0,0,1,.2.6c0,.1-.1.2-.1.4l-.2.3-.4.3-.6.4-.7.4v.9l3,1.8.2-.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M107.8,52.5a2.8,2.8,0,0,0-1.3-1.5q-.7-.6-1.2,0a2.8,2.8,0,0,0-.4,1.8,5.3,5.3,0,0,0,.4,2.3,2.8,2.8,0,0,0,1.2,1.4c.6.4,1,.4,1.3,0a2.6,2.6,0,0,0,.4-1.8A4,4,0,0,0,107.8,52.5Zm-1.9.9c0-.7.1-1.2.1-1.4a.4.4,0,0,1,.6-.2c.2.1.3.3.4.4s.1.1.1.2l-1.2,2.1A4,4,0,0,1,105.9,53.4Zm1.3.9a3.7,3.7,0,0,1-.1,1.1c0,.2-.1.4-.2.4s-.2.1-.4,0-.3-.3-.4-.4l1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="63.2 26.7 61.8 26.9 62.1 28 63.1 27.8 63.1 31 62 30.4 62 31.4 65 33.1 65 32.1 64.1 31.7 64.2 27.3 63.2 26.7"
        />
        <polygon
          class="cls-2"
          points="67.1 34.4 68.9 30.8 68.9 29.9 65.8 28.2 65.8 29.1 67.8 30.3 66.1 33.5 67.1 34.4"
        />
        <polygon class="cls-2" points="72.8 34.7 69.9 33 69.9 34 72.8 35.6 72.8 34.7" />
        <path
          class="cls-2"
          d="M123.8,61.7a2.7,2.7,0,0,0-1.3-1.5q-.7-.5-1.2,0a3,3,0,0,0-.4,1.8,5.3,5.3,0,0,0,.4,2.3,3.1,3.1,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a2.6,2.6,0,0,0,.4-1.8A7.9,7.9,0,0,0,123.8,61.7Zm-2,1a3.7,3.7,0,0,1,.2-1.4c.1-.2.3-.3.5-.1s.4.2.4.4a.1.1,0,0,0,.1.1l-1.1,2.1C121.9,63.5,121.8,63.1,121.8,62.7Zm1.4.8v1.1c-.1.2-.2.4-.3.4h-.4l-.4-.4,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="79.1 41.3 80.9 37.7 80.9 36.9 77.9 35.1 77.9 36.1 79.9 37.3 78.2 40.4 79.1 41.3"
        />
        <polygon class="cls-2" points="84.8 41.7 81.9 39.9 81.9 41 84.8 42.6 84.8 41.7" />
        <polygon
          class="cls-2"
          points="89.1 46.1 88.2 45.5 88.2 41.1 87.3 40.6 85.8 40.8 86.3 41.9 87.2 41.7 87.2 45 86.1 44.3 86.1 45.2 89.1 47 89.1 46.1"
        />
        <polygon
          class="cls-2"
          points="93.1 48.3 92.2 47.9 92.2 43.5 91.3 42.9 89.8 43.1 90.3 44.2 91.2 44.1 91.2 47.2 90.1 46.6 90.1 47.6 93.1 49.3 93.1 48.3"
        />
        <polygon
          class="cls-2"
          points="101.1 53 100.2 52.5 100.2 48.1 99.3 47.6 97.8 47.7 98.3 48.8 99.2 48.7 99.2 51.9 98.1 51.3 98.1 52.2 101.1 53.9 101.1 53"
        />
        <path
          class="cls-2"
          d="M150.2,80.8l.9-.5.5-.4a1.3,1.3,0,0,0,.3-.5c.1-.1.1-.4.1-.5a2.9,2.9,0,0,0-.2-.9c0-.3-.3-.6-.5-.9a2.7,2.7,0,0,0-.8-.7,1.6,1.6,0,0,0-.9-.4.8.8,0,0,0-.7.4l.7.9c.1-.2.2-.2.4-.2h.4c.3.1.3.3.5.5a1.4,1.4,0,0,1,.2.6c0,.2,0,.3-.1.3s-.1.3-.3.4l-.3.3c-.2,0-.4.2-.6.4l-.8.4V81l3.1,1.8v-.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155.1,83.4c0-.3-.3-.5-.4-.6s-.4-.2-.5-.1-.2.3-.2.5a1,1,0,0,0,.2.7l.5.6h.4c.2,0,.3-.2.3-.4A.9.9,0,0,0,155.1,83.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155.1,80.7a.7.7,0,0,0-.4-.6h-.5c-.2,0-.2.2-.2.4a.8.8,0,0,0,.2.7l.5.6h.4a.5.5,0,0,0,.3-.5A1.1,1.1,0,0,0,155.1,80.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="113.2 58.9 112.7 58.6 112.7 57.3 111.8 56.8 111.7 58 110.9 57.5 112 55.1 111.1 54.2 109.8 57 109.8 57.8 111.7 59 111.7 60.1 112.7 60.6 112.7 59.5 113.2 59.7 113.2 58.9"
        />
        <polygon
          class="cls-2"
          points="117.1 62.3 116.3 61.8 116.4 57.4 115.4 56.8 113.9 57 114.3 58.1 115.3 57.9 115.3 61.2 114.2 60.5 114.2 61.5 117.1 63.2 117.1 62.3"
        />
        <path
          class="cls-2"
          d="M167.2,90.3c-.1-.3-.3-.4-.5-.6h-.5a.8.8,0,0,0-.2.5,1.4,1.4,0,0,0,.2.7l.5.6h.5a.8.8,0,0,0,.2-.5A1.4,1.4,0,0,0,167.2,90.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M167.2,87.6a1.2,1.2,0,0,0-.5-.5c-.2-.1-.4-.2-.5-.1a.5.5,0,0,0-.2.4,2.4,2.4,0,0,0,.2.8l.5.5c.2.1.4.2.5.1a.8.8,0,0,0,.2-.5A1.9,1.9,0,0,0,167.2,87.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M172,89.6a3.2,3.2,0,0,0-1.3-1.5c-.6-.3-.9-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,8.5,8.5,0,0,0,.4,2.3,4.7,4.7,0,0,0,1.3,1.5,1,1,0,0,0,1.3,0,3.3,3.3,0,0,0,.3-1.9A7.3,7.3,0,0,0,172,89.6Zm-2,.9a10.9,10.9,0,0,1,.1-1.3.4.4,0,0,1,.6-.2c.2.1.3.3.4.4v.2l-1.1,2C170.1,91.3,170,91,170,90.5Zm1.4.8a3.1,3.1,0,0,1-.1,1.1c-.1.2-.1.4-.2.5h-.4l-.4-.5,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="129.1 64.8 126 63 126 63.9 128.1 65.1 126.3 68.2 127.3 69.2 129.1 65.6 129.1 64.8"
        />
        <path
          class="cls-2"
          d="M181.1,94.2v5.4l1,.5V96.7a.7.7,0,0,0-.1-.5V96l1.1,4.7,1.3.8V96.2l-.9-.6v2.9a1.9,1.9,0,0,0,.1.8,3.5,3.5,0,0,0,.1.6L182.5,95Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M188.5,101.8v-.2a2.8,2.8,0,0,0-.3-1.3,3.1,3.1,0,0,0-.5-1l-.9-.7c-.4-.2-.7-.3-.9-.2a.9.9,0,0,0-.6.4,3,3,0,0,0-.2,1,4.3,4.3,0,0,0,.2,1.2,3.9,3.9,0,0,0,.6,1.1,4.4,4.4,0,0,0,1.1.9l.7.3h.7l-.4-.9h-.5l-.5-.2a.5.5,0,0,1-.4-.3l-.3-.4c0-.2-.1-.4-.1-.7l2.3,1.4Zm-2.3-1.8a.8.8,0,0,1,.2-.6c.1-.1.2-.1.5,0s.4.3.5.5.1.5.1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M189.9,99.6v.9l-.7-.4v.9l.7.4v1.8a2.3,2.3,0,0,0,.4,1.4,2.4,2.4,0,0,0,1,1c.2.2.5.2.6.3h.5l-.3-.9h-.3l-.4-.2-.4-.3c0-.2-.1-.3-.1-.5v-1.9l1,.7V102l-1.2-.6.2-1.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M194.3,107a4.7,4.7,0,0,0,1,1l.6.2h.5l-.2-1h-.3l-.2-.2q-.3-.1-.3-.3a.5.5,0,0,1-.2-.4v-4.5l-2.1-1.2v.9l1,.6v3.5A2.8,2.8,0,0,0,194.3,107Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="150.1 81.5 150.1 82.4 153.1 84.1 153.1 83.3 152.3 82.7 152.3 79.4 150.2 78.2 150.2 79.1 151.2 79.6 151.2 82.1 150.1 81.5"
        />
        <path
          class="cls-2"
          d="M198.8,105h.5l.2-.4a2.5,2.5,0,0,0-.2-.7c-.2-.2-.3-.4-.5-.4s-.3-.2-.4-.1-.2.1-.2.4l.2.6C198.4,104.7,198.6,104.8,198.8,105Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M204.2,107.1l-.7-.4-.7-.3a.6.6,0,0,0-.5.2,1.4,1.4,0,0,0-.2.7v.5l-.8-.4v.9l.8.4v3l1,.6v-3l1.1.6v-.8l-1.1-.7v-.5c0-.2,0-.3.1-.4a.6.6,0,0,1,.5.2c.2,0,.2.1.4.2l.4.3.3-.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M207.5,110.8l-.7,2.9-.7-3.7-1.1-.6,1.1,4.7.3.2a.5.5,0,0,1-.2.4h-.9l.2.9.9.3a.8.8,0,0,0,.7-.2l.4-.6,1.1-3.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M215.2,118h-.6l-.5-.4a1.5,1.5,0,0,1-.3-.7l-.7.3a3.6,3.6,0,0,0,.7,1,2.7,2.7,0,0,0,.8.7l1,.3a.9.9,0,0,0,.6-.3,2,2,0,0,0,.2-.9c0-.4-.1-.7-.1-1a4.1,4.1,0,0,0-.5-.9l-.6-.5-.3-.2h-.4v-1.2l1.8.9v-.5l-2.8-1.7v2.9l.7.3h.3l.4.2.3.2a.5.5,0,0,0,.2.4,1.1,1.1,0,0,1,.1.6C215.5,117.8,215.4,118,215.2,118Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M218.9,121.5h.4l.2-.2c.1-.1.1-.2.1-.4a1.1,1.1,0,0,0-.1-.5.8.8,0,0,1-.2-.4l-.4-.3h-.7v.9l.3.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="175.4 97 177.2 93.4 177.2 92.6 174.2 90.8 174.2 91.7 176.2 92.9 174.4 96.1 175.4 97"
        />
        <path
          class="cls-2"
          d="M226.9,126.1h.6a.6.6,0,0,0,.1-.4.7.7,0,0,0-.1-.5c-.1-.2-.2-.3-.2-.5l-.4-.3h-.4l-.3.2v.8l.3.5C226.6,126,226.7,126.1,226.9,126.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="185.4 100.6 184.9 100.3 184.9 99.1 184.1 98.5 183.9 99.8 183.1 99.3 184.2 96.9 183.3 95.9 182 98.8 182 99.5 183.9 100.6 183.9 101.8 184.9 102.4 184.9 101.3 185.4 101.5 185.4 100.6"
        />
        <path
          class="cls-2"
          d="M235.9,128.6c.2-.1.2-.3.3-.4a1.3,1.3,0,0,0,.1-.6,3.1,3.1,0,0,0-.2-.8,1.9,1.9,0,0,0-.5-.9,2,2,0,0,0-.8-.8l-.9-.3a.9.9,0,0,0-.7.3l.7,1c.1-.2.2-.2.4-.3a.4.4,0,0,1,.4.2c.3.1.3.2.5.4a1.4,1.4,0,0,1,.2.7.4.4,0,0,1-.1.3l-.3.3-.4.3-.5.4-.8.5v.8l3.1,1.9v-.9l-2-1.2.9-.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M244.8,133.3l-1.7-1v.9l.6.3v1.2h-.3l-.3-.2c-.2-.1-.4-.2-.4-.4a2,2,0,0,1-.4-.8v-2l.3-.5h.7l.5.4.4.6.5-.4-.6-.9c-.2,0-.5-.3-.8-.5l-.9-.3h-.7a6.8,6.8,0,0,0-.5.7c0,.3-.1.6-.1,1.1a7.8,7.8,0,0,0,.2,1.6,4,4,0,0,0,.7,1.3,3.5,3.5,0,0,0,1.1,1l.9.4h.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M247.6,132.7l-1.3-.8-1.4,4.5,1.1.6.3-1,1.3.7.2,1.3,1.2.7Zm-1.2,2.6.5-2.1.5,2.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="208.9 110.8 208.9 109.8 206.9 108.7 206.9 116 208.9 117.2 208.9 116.3 207.8 115.7 207.8 110.2 208.9 110.8"
        />
        <path
          class="cls-2"
          d="M259.3,143.9l-.4-.2-.7-.5-.5-.7-.6.4.7.9a4.8,4.8,0,0,0,1.1.9,2.6,2.6,0,0,0,1,.4.8.8,0,0,0,.7-.3,1,1,0,0,0,.2-.7c0-.3-.1-.6-.1-.9a2.2,2.2,0,0,0-.5-.8l-.8-.8-.6-.5-.3-.4v-.6h.3l.4.2c.1.1.4.2.5.4s.3.4.5.6l.5-.4-.7-.9-.9-.9-.9-.3h-.6c-.2.2-.2.4-.2.8a1.7,1.7,0,0,0,.1.7,1.4,1.4,0,0,0,.5.8l.8,1,.5.5.3.4v.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M264.7,143.7a6.1,6.1,0,0,0-.7-1.4,2.8,2.8,0,0,0-1-.9,1.3,1.3,0,0,0-1-.2q-.5,0-.6.6a2.5,2.5,0,0,0-.3,1.3,5.1,5.1,0,0,0,.3,1.7,3.8,3.8,0,0,0,.6,1.3,2.8,2.8,0,0,0,1,.9,1.1,1.1,0,0,0,1,.3,1.3,1.3,0,0,0,.7-.6,5.2,5.2,0,0,0,.2-1.4A8.8,8.8,0,0,0,264.7,143.7Zm-1.1,2.2c-.1.3-.4.4-.6.2s-.5-.4-.5-.8a5.4,5.4,0,0,1-.2-1.5,3.5,3.5,0,0,1,.2-1.3c0-.2.3-.2.5-.2a1.7,1.7,0,0,1,.6.8c0,.4.1.9.1,1.5S263.6,145.7,263.6,145.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M102,62.2l.9-.5.6-.4.3-.4v-.6a2.5,2.5,0,0,0-.1-.8,2.8,2.8,0,0,0-.6-.9,1.8,1.8,0,0,0-.7-.8l-1-.3a.7.7,0,0,0-.6.3l.6.9.4-.2a.6.6,0,0,1,.5.2c.1,0,.3.2.4.4a1.5,1.5,0,0,1,.1.7.4.4,0,0,1-.1.3c0,.1,0,.2-.2.3l-.4.3c-.1.2-.2.2-.5.4l-.7.5v.8l3,1.8v-.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M107.9,61.7a4.1,4.1,0,0,0-1.4-1.5q-.7-.5-1.2,0c-.4.4-.4,1-.4,1.8a5.3,5.3,0,0,0,.4,2.3,3.1,3.1,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a2.6,2.6,0,0,0,.4-1.8A8,8,0,0,0,107.9,61.7Zm-2,.9c0-.7.1-1.2.1-1.4a.4.4,0,0,1,.6-.2c.2.1.3.3.4.4s.1.1.1.2l-1.2,2.1A4,4,0,0,1,105.9,62.6Zm1.3.9a3.7,3.7,0,0,1-.1,1.1c0,.2-.1.4-.2.4h-.4l-.4-.4,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="65 41.3 64.1 40.9 64.1 36.5 63.2 35.9 61.7 36.1 62.1 37.2 63.1 37.1 63.1 40.2 62 39.6 62 40.6 65 42.3 65 41.3"
        />
        <polygon
          class="cls-2"
          points="68.9 39.2 65.8 37.4 65.8 38.4 67.8 39.5 66.1 42.7 67.1 43.6 68.9 40 68.9 39.2"
        />
        <polygon class="cls-2" points="72.8 43.9 69.9 42.2 69.9 43.2 72.8 44.9 72.8 43.9" />
        <path
          class="cls-2"
          d="M123.8,71a2.4,2.4,0,0,0-1.3-1.5q-.7-.4-1.2,0a2.8,2.8,0,0,0-.4,1.8,5.3,5.3,0,0,0,.4,2.3,3.6,3.6,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a2.6,2.6,0,0,0,.4-1.8A7.3,7.3,0,0,0,123.8,71Zm-2,.9a3.7,3.7,0,0,1,.2-1.4c.1-.2.3-.3.5-.1s.4.2.4.4a.1.1,0,0,0,.1.1L121.9,73C121.9,72.7,121.8,72.3,121.8,71.9Zm1.4.8v1.1a1.1,1.1,0,0,1-.3.5c0,.1-.2.1-.4,0l-.4-.5,1.1-1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="80.9 46.1 77.8 44.3 77.8 45.3 79.8 46.5 78.1 49.7 79.1 50.5 80.9 47 80.9 46.1"
        />
        <polygon class="cls-2" points="84.8 50.9 81.9 49.2 81.9 50.2 84.8 51.8 84.8 50.9" />
        <polygon
          class="cls-2"
          points="89.1 55.3 88.2 54.8 88.2 50.4 87.3 49.8 85.8 50 86.2 51.1 87.2 50.9 87.1 54.2 86 53.5 86 54.5 89.1 56.2 89.1 55.3"
        />
        <polygon
          class="cls-2"
          points="93.1 57.6 92.2 57.1 92.2 52.7 91.3 52.1 89.8 52.4 90.2 53.5 91.2 53.3 91.2 56.5 90 55.9 90 56.8 93.1 58.5 93.1 57.6"
        />
        <polygon
          class="cls-2"
          points="101.1 62.3 100.2 61.7 100.2 57.3 99.3 56.8 97.8 57 98.3 58.1 99.2 57.9 99.2 61.2 98 60.5 98 61.4 101.1 63.1 101.1 62.3"
        />
        <path
          class="cls-2"
          d="M152.2,91.2l-2-1.2.9-.4.5-.4a1.3,1.3,0,0,0,.3-.5,1.1,1.1,0,0,0,.1-.5,2.9,2.9,0,0,0-.2-.9c0-.3-.3-.6-.5-.9a3,3,0,0,0-.8-.8l-.9-.3a.9.9,0,0,0-.7.3l.7,1c.1-.2.2-.2.4-.3a.4.4,0,0,1,.4.2c.3.1.3.2.5.5a1.1,1.1,0,0,1,.2.6c0,.2,0,.2-.1.3s-.1.3-.3.3l-.3.3-.6.4-.8.5v.9l3.1,1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155.1,89.9c-.1-.3-.3-.4-.4-.6h-.5c-.2,0-.2.2-.2.4a.8.8,0,0,0,.2.7l.5.6h.4a.5.5,0,0,0,.3-.5A1.1,1.1,0,0,0,155.1,89.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155.1,92.6c-.1-.3-.3-.4-.4-.6s-.4-.2-.5-.1-.2.3-.2.5a1,1,0,0,0,.2.7l.5.6h.4c.2,0,.3-.2.3-.4A.9.9,0,0,0,155.1,92.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="113.1 68.1 112.7 67.8 112.7 66.5 111.8 66 111.6 67.2 110.9 66.7 112 64.3 111 63.4 109.8 66.3 109.8 67.1 111.6 68.2 111.6 69.3 112.7 69.9 112.7 68.7 113.1 69 113.1 68.1"
        />
        <polygon
          class="cls-2"
          points="117.1 71.5 116.3 71 116.3 66.6 115.3 66 113.8 66.3 114.3 67.4 115.3 67.2 115.3 70.4 114.2 69.8 114.2 70.7 117.1 72.4 117.1 71.5"
        />
        <path
          class="cls-2"
          d="M167.2,99.6c-.2-.4-.3-.5-.5-.6s-.4-.2-.5-.1a.8.8,0,0,0-.2.5,1.9,1.9,0,0,0,.2.7l.5.6h.5c.1,0,.2-.2.2-.4A1.4,1.4,0,0,0,167.2,99.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M167.2,96.9a1,1,0,0,0-.5-.6h-.5c-.1,0-.2.2-.2.4a1.4,1.4,0,0,0,.2.7l.5.6h.5a.8.8,0,0,0,.2-.5A1.9,1.9,0,0,0,167.2,96.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M172,98.8a3.6,3.6,0,0,0-1.3-1.4c-.6-.4-.9-.4-1.3,0a2.6,2.6,0,0,0-.4,1.8,7.2,7.2,0,0,0,.4,2.2,3.2,3.2,0,0,0,1.3,1.5,1,1,0,0,0,1.3,0c.3-.3.3-.9.3-1.8A8.5,8.5,0,0,0,172,98.8Zm-2,.9a10.9,10.9,0,0,1,.1-1.3.4.4,0,0,1,.6-.2c.2.1.3.3.4.4s.1.1.1.2l-1.1,2C170.1,100.5,170,100.2,170,99.7Zm1.4.9a3.7,3.7,0,0,1-.1,1.1c-.1.2-.1.4-.2.4s-.2.1-.4,0l-.4-.4,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="129.1 74 125.9 72.2 125.9 73.1 128 74.3 126.3 77.4 127.3 78.4 129.1 74.8 129.1 74"
        />
        <polygon
          class="cls-2"
          points="134.3 77 134.3 82.3 135.4 82.9 135.4 80.8 137 81.8 137 80.9 135.4 80 135.4 78.5 137.2 79.6 137.3 78.8 134.3 77"
        />
        <path
          class="cls-2"
          d="M188.2,109.8a2.4,2.4,0,0,0-.6-1.1,2,2,0,0,0-.9-.9c-.4-.2-.6-.3-.9-.2a.5.5,0,0,0-.6.4,1.3,1.3,0,0,0-.3,1,2.1,2.1,0,0,0,.3,1.2,2.4,2.4,0,0,0,.6,1.1,1.8,1.8,0,0,0,.9.8,1.4,1.4,0,0,0,1,.3.5.5,0,0,0,.5-.3,2,2,0,0,0,.3-1.1A2.7,2.7,0,0,0,188.2,109.8Zm-1,1.4c-.1.2-.2.2-.5.1s-.4-.3-.4-.6a2.7,2.7,0,0,1-.2-1.1c0-.5.1-.7.2-.8s.2-.2.4,0a.8.8,0,0,1,.5.5,2.5,2.5,0,0,1,.2,1A1.4,1.4,0,0,1,187.2,111.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M192.3,111.1l-.4-.2c-.3-.2-.5-.3-.7-.2l-.5.5v-1l-1.3-.7v.7l.5.3v2.4l-.5-.2v.8l2.2,1.2v-.8l-.7-.4v-1.1a1.6,1.6,0,0,1,.4-.7h.5v.8l.6.4.2-1.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M200.8,114.5l-.6-.5-.7-.4c-.3-.1-.5-.3-.8-.3a.5.5,0,0,0-.4.2,1.4,1.4,0,0,0-.2.7v.5l-.8-.4v.9l.8.4v3l1,.6v-3l1.1.7v-.8l-1.1-.7v-.6c0-.2,0-.3.1-.4s.3,0,.5.2l.4.2.4.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M201.4,116.3v2.9a2.3,2.3,0,0,0,.3,1.1,1.3,1.3,0,0,0,.7.8,1,1,0,0,0,.7.2h.4v.4l1,.6-.3-4.1-1-.6v2.9h-.5l-.3-.3c-.1,0-.1-.2-.1-.4v-2.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M208.4,122.2l.2-1.6-.2-.2a.4.4,0,0,0-.4-.2c-.3-.2-.5-.3-.7-.2s-.4.2-.5.5v-1.1l-1.3-.7v.8l.5.3v2.4l-.5-.2v.8l2.2,1.2v-.8l-.7-.4v-1.2c.1-.3.3-.4.4-.6h.5v.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M210,120.5v.8l-.8-.4v.9l.8.4v1.9a2.8,2.8,0,0,0,.3,1.3,2.4,2.4,0,0,0,1,1l.6.4h.5l-.3-1h-.6l-.4-.4a.8.8,0,0,1-.2-.4V123l1,.6v-.8l-1.2-.6.2-1.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M216.4,126.3a3,3,0,0,0-.2-1,1.6,1.6,0,0,0-.7-.7l-.6-.2a.4.4,0,0,0-.4.2v-2.4l-1-.5v5.8l1,.6v-2.8l.2-.2h.5c.1.1.2.2.2.3a1.1,1.1,0,0,1,.1.6v2.6l1,.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M217.9,126.1c-.2.1-.5.3-.5.5a1.4,1.4,0,0,0-.3.9,3.1,3.1,0,0,0,.3,1.3,2.4,2.4,0,0,0,.6,1.1l1,.9.8.3h.6l-.4-.9h-.4l-.5-.2-.4-.3a1.3,1.3,0,0,1-.3-.5,1.1,1.1,0,0,1-.2-.6l2.3,1.3v-.4a5.1,5.1,0,0,0-.2-1.3,3.3,3.3,0,0,0-.6-1,1.9,1.9,0,0,0-.8-.7A1.4,1.4,0,0,0,217.9,126.1Zm.6,1.1c0-.1.2-.1.4,0a.8.8,0,0,1,.5.5,1.9,1.9,0,0,1,.2.8l-1.4-.7C218.2,127.5,218.3,127.2,218.5,127.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M224.4,129.6l-.4-.2c-.3-.2-.5-.3-.7-.2s-.4.2-.4.5l-.2-1.1-1.2-.7v.8l.4.3v2.4l-.4-.2v.8l2.1,1.2v-.8l-.7-.4v-1.2c.1-.3.3-.4.4-.6h.5v.8l.6.4.3-1.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="182.2 109.3 182.2 110.2 185.2 111.9 185.2 111 184.3 110.5 184.3 107.2 182.3 106 182.3 106.8 183.2 107.4 183.2 109.8 182.2 109.3"
        />
        <path
          class="cls-2"
          d="M230.9,132.7c.1.1.3.2.4.1a.5.5,0,0,0,.2-.4,2.1,2.1,0,0,0-.2-.6l-.4-.5h-.5c-.2.1-.2.2-.2.4a2.5,2.5,0,0,0,.2.7A.7.7,0,0,0,230.9,132.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M235.4,140l1,.6v-3a1.7,1.7,0,0,0-.3-1,2.2,2.2,0,0,0-.7-.6l-.6-.3-.5.2v-.6l-1-.5v4.1l1,.6v-2.8l.3-.2h.4l.3.2c.1,0,.1.1.1.2V140Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M239.4,137.5a.6.6,0,0,1,.5.2l.4.2c.2.1.2.3.4.3l.3-.6-.5-.5a1,1,0,0,1-.8-.4l-.8-.3a.5.5,0,0,0-.5.3c-.1.1-.1.4-.1.6v.5l-.8-.3v.8l.8.4v3l1,.6v-3l1,.7.2-.8-1.2-.7v-.6C239.3,137.7,239.4,137.6,239.4,137.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M242,143.8a2.4,2.4,0,0,0,.9.8l.9.3a.8.8,0,0,0,.7-.4,2.5,2.5,0,0,0,.2-1,3.7,3.7,0,0,0-.2-1.2,3.9,3.9,0,0,0-.6-1.1,2.2,2.2,0,0,0-1-.9,1.2,1.2,0,0,0-.9-.3,1,1,0,0,0-.7.4,3.1,3.1,0,0,0-.2,1.1,5,5,0,0,0,.2,1.2A2.6,2.6,0,0,0,242,143.8Zm.4-2.6h.5c.2.2.4.3.5.6s.1.6.1,1a5.5,5.5,0,0,1-.1.9c-.1,0-.3.2-.5,0a1.2,1.2,0,0,1-.5-.5,3.1,3.1,0,0,1-.1-1.1A2,2,0,0,1,242.4,141.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M248.5,143.4h-.4c-.3-.2-.6-.3-.7-.2a.8.8,0,0,0-.5.5l-.2-1-1.2-.7v.7l.5.3v2.4l-.5-.2v.8l2.2,1.2v-.8l-.7-.4v-1.1a1.6,1.6,0,0,1,.4-.7h.4v.7l.7.4.2-1.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M252.7,147.4a1.5,1.5,0,0,0-.1-.7.8.8,0,0,0-.2-.5c-.1-.4-.2-.6-.4-.6s-.3-.2-.4-.1h-.3c-.1-.1-.1-.3-.2-.4l-.3-.4c-.2,0-.4-.1-.4,0a.4.4,0,0,0-.4.2v-.5l-.8-.4v4l.9.6v-3h.3l.2.2v3.2l.7.4v-3h.3l.2.2v3.2l.9.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M255,148.9a2.7,2.7,0,0,0-1.3-.4c-.3.1-.4.4-.4.8a1.5,1.5,0,0,0,.3,1.1,2.4,2.4,0,0,0,.8.9,1.1,1.1,0,0,0,.7.2h.5l.3.5.6.5.2-.7v-2.2a2.8,2.8,0,0,0-.4-1.3,3.4,3.4,0,0,0-1.3-1l-.6-.3-.7-.2.2,1h.6l.5.3.5.4a.7.7,0,0,1,.2.6h0Zm.4,1.6-.3.2h-.3l-.4-.3c0-.2-.1-.3-.1-.5s.1-.3.2-.3l.7.2.2.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M258.5,153.3a2.4,2.4,0,0,0,1,1l.6.3h.5l-.3-.9h-.4l-.3-.2-.4-.3c0-.2-.1-.3-.1-.5v-1.9l1,.7v-.8l-1-.9v-1l-1.1-.5v.9l-.7-.4v.8l.7.4v1.9A2.3,2.3,0,0,0,258.5,153.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M263,151.3c.2.1.3.2.5.1a.6.6,0,0,0,.1-.4,2,2,0,0,0-.1-.7l-.5-.4a.4.4,0,0,0-.5-.1c0,.1-.1.2-.1.4s.1.4.1.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="214.3 127.8 214.3 128.7 217.3 130.4 217.3 129.6 216.4 129 216.4 125.7 214.4 124.5 214.4 125.4 215.3 126 215.3 128.4 214.3 127.8"
        />
        <path
          class="cls-2"
          d="M102,71.4l.9-.5.6-.4c.1-.1.3-.3.3-.4v-.6a2.5,2.5,0,0,0-.1-.8,1.3,1.3,0,0,0-.5-.9,2.4,2.4,0,0,0-.9-.8l-1-.3a.9.9,0,0,0-.6.3l.6.9.4-.2a.6.6,0,0,1,.5.2c.2,0,.3.2.5.4s.1.4.1.7a.4.4,0,0,1-.1.3c0,.1,0,.2-.2.3l-.4.3-.5.4-.8.5v.8l3,1.8.2-.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M107.9,70.9a4.1,4.1,0,0,0-1.4-1.5q-.7-.5-1.2,0c-.4.4-.4,1-.4,1.8a5.3,5.3,0,0,0,.4,2.3,3.1,3.1,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a2.6,2.6,0,0,0,.4-1.8A8,8,0,0,0,107.9,70.9Zm-2.1.9a3.7,3.7,0,0,1,.2-1.4c0-.3.3-.3.5-.2s.3.3.4.4.1.1.1.2l-1.2,2.1A4,4,0,0,1,105.8,71.8Zm1.3.9v1.1c-.1.2-.2.4-.3.4h-.4l-.4-.4,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="65 50.6 64.1 50.1 64.1 45.7 63.2 45.1 61.7 45.4 62.1 46.5 63.1 46.3 63.1 49.5 61.9 48.9 61.9 49.8 65 51.5 65 50.6"
        />
        <polygon
          class="cls-2"
          points="68.8 48.4 65.8 46.6 65.8 47.6 67.8 48.7 66.1 51.9 67 52.8 68.8 49.3 68.8 48.4"
        />
        <polygon class="cls-2" points="72.8 53.1 69.8 51.5 69.8 52.4 72.8 54.1 72.8 53.1" />
        <path
          class="cls-2"
          d="M123.8,80.2a2.8,2.8,0,0,0-1.3-1.5q-.7-.5-1.2,0a2.8,2.8,0,0,0-.4,1.8,5.3,5.3,0,0,0,.4,2.3,3.6,3.6,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a2.6,2.6,0,0,0,.4-1.8A7.3,7.3,0,0,0,123.8,80.2Zm-2,.9a3.7,3.7,0,0,1,.2-1.4c.1-.2.3-.3.5-.1s.4.2.4.4h.1l-1.1,2.1C121.9,81.9,121.8,81.5,121.8,81.1Zm1.4.8a3.1,3.1,0,0,1-.1,1.1l-.2.5h-.4a1,1,0,0,1-.4-.5l1.1-1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="80.9 55.4 77.8 53.6 77.8 54.5 79.8 55.7 78.1 58.9 79.1 59.8 80.9 56.2 80.9 55.4"
        />
        <polygon class="cls-2" points="84.8 60.1 81.9 58.4 81.9 59.4 84.8 61.1 84.8 60.1" />
        <polygon
          class="cls-2"
          points="89 64.5 88.2 64 88.2 59.6 87.2 59 85.7 59.3 86.2 60.4 87.1 60.2 87.1 63.4 86 62.7 86 63.7 89 65.4 89 64.5"
        />
        <polygon
          class="cls-2"
          points="91.3 61.4 89.8 61.6 90.2 62.7 91.1 62.5 91.1 65.7 90 65.1 90 66 93 67.8 93 66.8 92.2 66.4 92.2 62 91.3 61.4"
        />
        <polygon
          class="cls-2"
          points="101 71.5 100.2 71 100.2 66.6 99.3 66 97.8 66.2 98.2 67.3 99.1 67.1 99.1 70.4 98 69.7 98 70.7 101 72.4 101 71.5"
        />
        <path
          class="cls-2"
          d="M150.1,99.2l.9-.4.5-.4c.2-.2.3-.3.3-.5a1.1,1.1,0,0,0,.1-.5c0-.3-.1-.6-.1-.9a2.4,2.4,0,0,0-.6-.9c-.1-.3-.4-.5-.8-.8l-.9-.3a.7.7,0,0,0-.6.3l.6,1c.1-.2.2-.2.4-.3a.6.6,0,0,1,.5.2.7.7,0,0,1,.4.5,1.1,1.1,0,0,1,.2.6c0,.2,0,.2-.1.3s-.1.3-.2.3l-.4.3-.6.4a1.6,1.6,0,0,1-.8.5v.9l3.1,1.8v-.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155.1,99.2a.8.8,0,0,0-.5-.6h-.5a.8.8,0,0,0-.2.5,1.9,1.9,0,0,0,.2.7l.5.6c.2,0,.4.1.5,0s.2-.2.2-.4A1.4,1.4,0,0,0,155.1,99.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155.1,101.8a.8.8,0,0,0-.5-.5c-.2-.1-.4-.2-.5-.1a.6.6,0,0,0-.2.5,2.5,2.5,0,0,0,.2.7l.5.5c.2.1.4.2.5.1a.6.6,0,0,0,.2-.5A2.5,2.5,0,0,0,155.1,101.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="113.1 77.4 112.7 77 112.7 75.8 111.8 75.2 111.6 76.5 110.9 76 112 73.6 111 72.6 109.8 75.5 109.8 76.3 111.6 77.4 111.6 78.5 112.7 79.1 112.7 78 113.1 78.2 113.1 77.4"
        />
        <polygon
          class="cls-2"
          points="117.1 80.7 116.3 80.3 116.3 75.9 115.3 75.3 113.8 75.5 114.3 76.6 115.3 76.4 115.3 79.6 114.1 79 114.1 80 117.1 81.7 117.1 80.7"
        />
        <path
          class="cls-2"
          d="M167.1,108.8a1.3,1.3,0,0,0-.4-.6.7.7,0,0,0-.6-.1.8.8,0,0,0-.2.5,1.9,1.9,0,0,0,.2.7l.5.6h.5c.1,0,.2-.2.2-.4A1.4,1.4,0,0,0,167.1,108.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M167.2,106.1l-.5-.6h-.5c-.1,0-.2.2-.2.4a1.4,1.4,0,0,0,.2.7l.5.6h.5a.8.8,0,0,0,.2-.5A1.9,1.9,0,0,0,167.2,106.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M172,108a3.6,3.6,0,0,0-1.3-1.4c-.6-.4-.9-.4-1.3,0a2.6,2.6,0,0,0-.4,1.8,7.2,7.2,0,0,0,.4,2.2,3.2,3.2,0,0,0,1.3,1.5,1,1,0,0,0,1.3,0c.3-.3.3-.9.3-1.8A8.5,8.5,0,0,0,172,108Zm-2.1.9a2.7,2.7,0,0,1,.2-1.3c0-.3.3-.3.5-.2s.3.3.4.4.1.1.1.2l-1.1,2C170,109.7,169.9,109.4,169.9,108.9Zm1.4.9a3.7,3.7,0,0,1-.1,1.1c0,.2,0,.4-.2.4h-.4c-.1-.1-.2-.3-.4-.4l1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="129.1 83.3 125.9 81.5 125.9 82.3 128 83.5 126.3 86.7 127.3 87.7 129.1 84 129.1 83.3"
        />
        <path
          class="cls-2"
          d="M181.1,112.6V118l.9.5v-3.4a.7.7,0,0,0-.1-.5v-.2l1.1,4.7,1.4.8v-5.3l-1-.6v2.9a1.9,1.9,0,0,0,.1.8,3.5,3.5,0,0,0,.1.6l-1.2-4.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M188.4,120.3v-.2a2.8,2.8,0,0,0-.3-1.3,3.1,3.1,0,0,0-.5-1,2.2,2.2,0,0,0-.9-.7c-.4-.2-.7-.3-.9-.2a.7.7,0,0,0-.6.4,3,3,0,0,0-.2,1,5,5,0,0,0,.2,1.2,2.6,2.6,0,0,0,.7,1.1,4.3,4.3,0,0,0,1,.9c.3.1.5.3.8.3h.6l-.4-.9h-.5l-.4-.2c-.2-.1-.4-.1-.4-.3a.5.5,0,0,1-.3-.5,1.1,1.1,0,0,1-.2-.6l2.3,1.3Zm-2.3-1.8a.8.8,0,0,1,.2-.6.4.4,0,0,1,.5,0l.5.5a2.2,2.2,0,0,1,.1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M189.9,118.1v.9l-.8-.4v.8l.8.4v1.9a2.2,2.2,0,0,0,.3,1.4,2.4,2.4,0,0,0,1,1l.6.3h.5l-.3-.9h-.3c-.1,0-.3-.1-.3-.2l-.4-.3c-.1-.2-.2-.3-.2-.5v-1.9l1,.7v-.8l-1.2-.7.2-1.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M192.9,120.1l1.1.6v3.5a2.1,2.1,0,0,0,.3,1.3,2,2,0,0,0,.9.9.9.9,0,0,0,.6.3h.5l-.2-1h-.5c-.2-.1-.2-.2-.3-.3a.8.8,0,0,1-.2-.4v-4.5l-2.2-1.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M198.7,123.5h.5c.1,0,.2-.2.2-.4l-.2-.6a.8.8,0,0,0-.5-.5h-.4c-.2,0-.2.1-.2.4a2.1,2.1,0,0,0,.2.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="150.1 100 150.1 100.9 153 102.6 153 101.7 152.2 101.2 152.2 97.9 150.1 96.7 150.1 97.6 151.1 98.1 151.1 100.6 150.1 100"
        />
        <path
          class="cls-2"
          d="M204.2,125.5l-.7-.4-.7-.3a.6.6,0,0,0-.5.2,1.4,1.4,0,0,0-.2.7v.5l-.8-.4v.9l.8.4v3l1,.6v-3l1.1.6v-.8l-1.1-.7v-.5c0-.2,0-.3.1-.4a.6.6,0,0,1,.5.2c.2,0,.2.1.4.2l.4.3.3-.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M206.1,132.5l.3.2a.5.5,0,0,1-.2.4h-.9l.2.9.9.3a.8.8,0,0,0,.7-.2l.4-.6,1.1-3.6-1.1-.6-.7,2.9-.7-3.7-1.1-.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M212.4,135.2a.6.6,0,0,1-.1-.4v-1.6a1.6,1.6,0,0,0-.4-1.2,4.3,4.3,0,0,0-1.2-1.1l-.6-.3h-.7l.2.9.5.2.5.2.6.5c.1.1.1.4.1.5v.2l-.5-.3a1.3,1.3,0,0,0-1.2-.4c-.3,0-.5.3-.5.8a2.6,2.6,0,0,0,.3,1.1,3.4,3.4,0,0,0,.9.8l.6.3c.3,0,.4,0,.6-.2s.1.4.3.5a1.2,1.2,0,0,0,.5.5l.3-.7C212.5,135.3,212.4,135.3,212.4,135.2Zm-1.2-1c0,.1-.1.2-.3.2s-.2,0-.3-.1l-.3-.3c-.1-.2-.2-.3-.2-.5a.3.3,0,0,1,.3-.3l.6.2.2.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M215.2,133.5h-1v-.4l-.9-.6v5.8l1,.5v-1.9a2.6,2.6,0,0,0,.9.9c.3.2.5.3.7.2a.8.8,0,0,0,.5-.5c0-.2.1-.6.1-1s-.1-.9-.1-1.2-.3-.8-.4-1.1Zm0,3.2c0,.2-.2.2-.3,0l-.4-.2-.2-.4v-1.7l.2-.2h.4l.3.3a4.3,4.3,0,0,1,.1.5,1.9,1.9,0,0,1,.1.8C215.4,136.4,215.3,136.7,215.2,136.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M219.3,135.9l-.6-.2-.5.2v-.5l-1-.5v5.8l1,.5v-1.9a2.6,2.6,0,0,0,.9.9,1.1,1.1,0,0,0,.7.2l.5-.5a2.8,2.8,0,0,0,.1-1,5.3,5.3,0,0,0-.1-1.3,10.4,10.4,0,0,0-.4-1A1.1,1.1,0,0,0,219.3,135.9Zm0,3.2h-.4l-.4-.2-.2-.4v-1.8h.6l.3.3a.7.7,0,0,1,.1.5,1.5,1.5,0,0,1,.1.7A5.5,5.5,0,0,1,219.3,139.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M225.5,140.5a3,3,0,0,0-.2,1,5.9,5.9,0,0,0,.2,1.3,4.1,4.1,0,0,0,.7,1.1l1,.9.8.3h.5l-.5-1h-.3l-.4-.2-.4-.3a.9.9,0,0,1-.3-.5,2.2,2.2,0,0,1-.1-.8,1.7,1.7,0,0,1,.2-.9.6.6,0,0,1,.6,0l.4.3.3.5.5-.5-.5-.7-.8-.5-1-.3C225.8,140.1,225.7,140.3,225.5,140.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M229.4,145.9l1,.7v-2.9h.7c.2.1.2.1.2.3a1.1,1.1,0,0,1,.1.6v2.6l1,.7v-3a2.2,2.2,0,0,0-.2-1.1,1.6,1.6,0,0,0-.7-.7h-1v-2.3l-1-.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M233.5,148.1a2.3,2.3,0,0,0,.9.8l.6.3c.3,0,.4,0,.6-.2s.1.4.3.6.3.3.6.4l.2-.7-.2-.2v-2a2.8,2.8,0,0,0-.4-1.2l-1.3-1.1c-.2,0-.4-.2-.6-.3h-.7l.2.9.6.2.4.2.6.5c.1.1.1.4.1.5v.2l-.4-.3c-.6-.3-1-.5-1.3-.4s-.5.3-.5.8A2.3,2.3,0,0,0,233.5,148.1Zm.9-1,.6.3h.3v.6l-.3.2c-.1.1-.2,0-.4-.1l-.3-.3a4.3,4.3,0,0,1-.1-.5C234.2,147.2,234.3,147.1,234.4,147.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M237.3,150.4l1,.7v-2.9h1a.4.4,0,0,1,.1.3v3l1,.7v-3a1.8,1.8,0,0,0-1-1.7l-.6-.2h-.5v-.5l-1-.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M244.8,151.1l-.3-1.1h-1l-.6-.3h-.1a1.3,1.3,0,0,0-.8-.3h-.5a.9.9,0,0,0-.3.7,1.9,1.9,0,0,0,.2.8,1.8,1.8,0,0,0,.5.8c-.2,0-.3.1-.3.2s-.1.2-.1.4a2.5,2.5,0,0,0,.2.7,3.5,3.5,0,0,0,.9.7l.5.3.4.3c.1.2.2.2.2.4s0,.2-.1.2h-.2l-.6-.3-.5-.3-.2-.3a.4.4,0,0,1-.1-.3l-.9-.6c0,.3.1.6.1.8a3.3,3.3,0,0,0,.6.8l1,.8a2.6,2.6,0,0,0,1.4.5.8.8,0,0,0,.5-.8,2.5,2.5,0,0,0-.2-.7c0-.2-.2-.4-.4-.7l-.7-.5-.6-.3-.3-.3c-.1,0-.1-.1-.1-.2h.1l.2.2.2.2c.3.1.5.3.8.3l.5-.2c.2-.1.2-.3.2-.6a1.4,1.4,0,0,0-.2-.7c0-.3-.3-.5-.4-.7l.5.3Zm-1.5.7h-.4l-.4-.4a1.4,1.4,0,0,1-.2-.6c0-.3.1-.4.2-.4s.2-.1.4,0l.4.4a1.3,1.3,0,0,1,.1.6A.7.7,0,0,1,243.3,151.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M248.6,155.1v-.3a2.5,2.5,0,0,0-.2-1.2,3.3,3.3,0,0,0-.6-1l-.8-.8a1.3,1.3,0,0,0-1-.2.8.8,0,0,0-.5.5c-.2.2-.2.5-.2.9a3,3,0,0,0,.2,1.3,2.4,2.4,0,0,0,.6,1.1,3.9,3.9,0,0,0,1,.8l.8.4h.7l-.4-1h-1l-.4-.3-.3-.5a1.3,1.3,0,0,1-.1-.6l2.2,1.3Zm-2.3-1.8a1,1,0,0,1,.2-.7h.5c.2.2.4.3.5.6s.1.5.1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M251.4,154.8l-.4-.4-.5-.4a1.1,1.1,0,0,0-.8-.1c-.2.1-.4.2-.4.5a2.5,2.5,0,0,0-.2,1,4.3,4.3,0,0,0,.2,1.2,2.5,2.5,0,0,0,.4,1.1,1.6,1.6,0,0,0,.7.7h1v.4l.9.6v-5.7l-1-.8Zm.1,2.6-.3.2h-.4l-.3-.3a.9.9,0,0,1-.1-.5,1.9,1.9,0,0,1-.1-.8,5.5,5.5,0,0,1,.1-.9h.5l.3.2.3.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M261,158.5l-.5-.5-.8-.4-.8-.3c-.2,0-.4,0-.4.2a1.4,1.4,0,0,0-.2.6v.6l-.8-.4v.9l.8.3v3l1,.7v-3l1,.6.2-.8-1.2-.7v-.5c0-.3.1-.3.2-.4h.4l.4.3c.2,0,.3.2.4.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M261.5,163.6v.8l2.2,1.3v-.8l-.7-.4v-1.2a1.3,1.3,0,0,1,.4-.6h.5v.8l.6.4.2-1.6-.2-.2-.4-.2c-.3-.1-.5-.2-.7-.1a1,1,0,0,0-.5.4v-1l-1.3-.7v.8l.5.2v2.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M102,80.6l.9-.5.6-.4.3-.4v-.6a2.5,2.5,0,0,0-.1-.8,2,2,0,0,0-.6-.9,1.4,1.4,0,0,0-.8-.7,1.4,1.4,0,0,0-1-.3.6.6,0,0,0-.6.3l.6.9.4-.2h.5l.5.5c0,.2.1.4.1.6a.4.4,0,0,1-.1.3c0,.1,0,.2-.2.3l-.4.3-.5.4-.8.5v.8l3,1.8.2-.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M107.8,80.2a3.6,3.6,0,0,0-1.4-1.6q-.7-.4-1.2,0a3,3,0,0,0-.4,1.8,5.5,5.5,0,0,0,.4,2.4,3.6,3.6,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a3.2,3.2,0,0,0,.5-1.8A7.3,7.3,0,0,0,107.8,80.2Zm-2,.9a3.7,3.7,0,0,1,.2-1.4.3.3,0,0,1,.5-.2c.1.2.3.3.3.5h.1l-1.1,2.1A4,4,0,0,1,105.8,81.1Zm1.3.8V83a1.1,1.1,0,0,1-.3.5h-.4L106,83l1.1-1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="64.9 59.8 64 59.4 64.1 55 63.2 54.4 61.7 54.6 62.1 55.7 63 55.5 63 58.7 61.9 58.1 61.9 59 64.9 60.8 64.9 59.8"
        />
        <polygon
          class="cls-2"
          points="68.8 57.7 65.8 55.9 65.8 56.8 67.7 57.9 66 61.2 67 62.1 68.8 58.5 68.8 57.7"
        />
        <polygon class="cls-2" points="72.8 62.3 69.8 60.7 69.8 61.6 72.8 63.3 72.8 62.3" />
        <path
          class="cls-2"
          d="M123.7,89.4a2.6,2.6,0,0,0-1.2-1.5c-.6-.3-1-.3-1.3,0a2.8,2.8,0,0,0-.4,1.8,7.3,7.3,0,0,0,.4,2.3,3.2,3.2,0,0,0,1.3,1.5q.8.4,1.2,0a2.6,2.6,0,0,0,.4-1.8A5.3,5.3,0,0,0,123.7,89.4Zm-1.9,1a4.2,4.2,0,0,1,.1-1.4c.1-.2.3-.3.6-.1l.4.4h0l-1.1,2.1Zm1.4.8a3.1,3.1,0,0,1-.1,1.1l-.2.5a.3.3,0,0,1-.4,0c-.2-.2-.4-.3-.4-.5l1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="80.8 64.6 77.8 62.8 77.8 63.8 79.8 64.9 78.1 68.1 79 69 80.8 65.4 80.8 64.6"
        />
        <polygon class="cls-2" points="84.8 69.3 81.9 67.7 81.9 68.6 84.8 70.3 84.8 69.3" />
        <polygon
          class="cls-2"
          points="89 73.7 88.2 73.3 88.2 68.9 87.2 68.3 85.7 68.5 86.2 69.6 87.1 69.4 87.1 72.6 86 72 86 73 89 74.7 89 73.7"
        />
        <polygon
          class="cls-2"
          points="93 76.1 92.2 75.6 92.2 71.2 91.2 70.6 89.7 70.8 90.2 71.9 91.1 71.8 91.1 75 90 74.3 90 75.2 93 77 93 76.1"
        />
        <polygon
          class="cls-2"
          points="101 80.7 100.2 80.2 100.2 75.8 99.2 75.2 97.7 75.4 98.2 76.5 99.1 76.4 99.1 79.6 98 78.9 98 79.9 101 81.6 101 80.7"
        />
        <path
          class="cls-2"
          d="M150.1,108.5l.9-.5.5-.3a.9.9,0,0,0,.3-.5,1.3,1.3,0,0,0,.1-.6c0-.2-.1-.5-.1-.8a1.8,1.8,0,0,0-.6-.9c-.1-.4-.5-.6-.8-.8l-.9-.3a.7.7,0,0,0-.6.3l.6,1c.1-.2.2-.2.4-.3a.6.6,0,0,1,.5.2.7.7,0,0,1,.4.5.8.8,0,0,1,.2.6.4.4,0,0,1-.1.3l-.2.3-.4.3-.6.4-.8.5v.9l3.1,1.8v-.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155.1,111a1.2,1.2,0,0,0-.5-.5c-.2-.1-.4-.2-.5-.1a.6.6,0,0,0-.2.5,2.5,2.5,0,0,0,.2.7l.5.5c.2.1.4.2.5.1a.6.6,0,0,0,.2-.5A2.5,2.5,0,0,0,155.1,111Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155.1,108.4c-.1-.3-.3-.4-.5-.6h-.5a.8.8,0,0,0-.2.5,1.9,1.9,0,0,0,.2.7l.5.6h.5c.1,0,.2-.2.2-.4A1.4,1.4,0,0,0,155.1,108.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="113.1 86.6 112.7 86.3 112.7 85 111.7 84.5 111.6 85.7 110.8 85.2 111.9 82.8 111 81.9 109.7 84.7 109.7 85.5 111.6 86.6 111.6 87.7 112.7 88.3 112.7 87.2 113.1 87.5 113.1 86.6"
        />
        <polygon
          class="cls-2"
          points="117.1 89.9 116.2 89.5 116.3 85.1 115.3 84.5 113.8 84.7 114.2 85.8 115.2 85.7 115.2 88.9 114.1 88.2 114.1 89.2 117.1 90.9 117.1 89.9"
        />
        <path
          class="cls-2"
          d="M167.1,118a.6.6,0,0,0-.5-.5c-.1-.1-.4-.2-.5-.1a.6.6,0,0,0-.2.5,2.5,2.5,0,0,0,.2.7l.5.5c.2.1.4.2.5.1a.6.6,0,0,0,.2-.5A2.5,2.5,0,0,0,167.1,118Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M167.1,115.4c-.1-.4-.2-.5-.5-.6h-.5a.8.8,0,0,0-.2.5,1.9,1.9,0,0,0,.2.7l.5.6h.5c.1,0,.2-.2.2-.4A1.4,1.4,0,0,0,167.1,115.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M171.9,117.2a2.9,2.9,0,0,0-1.3-1.4q-.7-.6-1.2,0c-.4.3-.4.9-.4,1.8a5.1,5.1,0,0,0,.4,2.2,3.1,3.1,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a2.6,2.6,0,0,0,.4-1.8A8.5,8.5,0,0,0,171.9,117.2Zm-2,1a2.7,2.7,0,0,1,.2-1.3.3.3,0,0,1,.5-.2.8.8,0,0,1,.4.4.1.1,0,0,0,.1.1l-1.1,2.1C170,119,169.9,118.7,169.9,118.2Zm1.4.8a3.7,3.7,0,0,1-.1,1.1c0,.2-.1.4-.2.4h-.4l-.4-.4,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="129 92.5 125.9 90.7 125.9 91.6 128 92.8 126.2 95.9 127.2 96.9 129 93.2 129 92.5"
        />
        <path
          class="cls-2"
          d="M183,127.5h-.4a6,6,0,0,1-1.3-1.3l-.5.4a3,3,0,0,0,.7,1,3.1,3.1,0,0,0,1.1.8,1.6,1.6,0,0,0,1,.4l.6-.2a.8.8,0,0,0,.2-.7,3.8,3.8,0,0,0-.1-1,1.2,1.2,0,0,0-.5-.7,3,3,0,0,0-.8-.8l-.5-.6a.5.5,0,0,1-.3-.4.4.4,0,0,1-.1-.3v-.2h.2l.4.2a.9.9,0,0,1,.5.3,1.8,1.8,0,0,1,.5.7l.6-.4a3.6,3.6,0,0,1-.7-1l-1-.7-.8-.4a.8.8,0,0,0-.7.2,1.4,1.4,0,0,0-.2.7c0,.2.1.6.1.8l.5.8a7.5,7.5,0,0,1,.9.9l.5.6a.5.5,0,0,1,.2.4c.1.1.1.2.1.4a.4.4,0,0,1-.1.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M185.2,128.7a2.6,2.6,0,0,0,.7,1.1,4.3,4.3,0,0,0,1,.9c.3.1.5.3.8.3h.6l-.4-.9h-.5l-.4-.2c-.2-.1-.4-.1-.4-.3a.5.5,0,0,1-.3-.5,1.1,1.1,0,0,1-.2-.6l2.3,1.3v-.4a2.8,2.8,0,0,0-.3-1.3,3.1,3.1,0,0,0-.5-1l-.9-.7c-.4-.2-.7-.3-.9-.2a.7.7,0,0,0-.6.4,3,3,0,0,0-.2,1A5,5,0,0,0,185.2,128.7Zm1.1-1.6h.5l.5.5a2.2,2.2,0,0,1,.1.8l-1.3-.7A.8.8,0,0,1,186.3,127.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M192.3,129.5l-.4-.2c-.3-.2-.5-.3-.7-.2l-.5.5v-1l-1.3-.7v.7l.5.3v2.4l-.5-.2v.8l2.2,1.2v-.8l-.7-.3v-1.2a1.6,1.6,0,0,1,.4-.7h.5v.8l.6.4.2-1.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="148.2 104.8 147.5 107.6 146.8 104 145.7 103.4 146.9 108.1 148.2 108.8 149.3 105.4 148.2 104.8"
        />
        <path
          class="cls-2"
          d="M197,134.5a2.7,2.7,0,0,0,.3,1.2,2.4,2.4,0,0,0,.6,1.1,4.3,4.3,0,0,0,1,.9l.8.3h.6l-.4-.9h-.4l-.5-.2c-.2-.1-.3-.1-.4-.3s-.2-.3-.3-.5a1.1,1.1,0,0,1-.2-.6l2.3,1.3v-.4a5.1,5.1,0,0,0-.2-1.3l-.6-1a2.2,2.2,0,0,0-.9-.7,1.1,1.1,0,0,0-.9-.2c-.2,0-.5.2-.5.4A1.7,1.7,0,0,0,197,134.5Zm1.4-.4h.4a.8.8,0,0,1,.5.5,2.4,2.4,0,0,1,.2.8l-1.4-.7A.6.6,0,0,1,198.4,134.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M204.3,136.5l-.4-.2c-.3-.2-.5-.3-.7-.2s-.4.3-.4.5l-.2-1-1.3-.7v.7l.5.3v2.4l-.5-.2v.8l2.2,1.2v-.8l-.7-.4v-1.1a4.3,4.3,0,0,1,.4-.7h.5v.8l.6.4.3-1.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M211.2,144.5l1.1.7v-3a1.7,1.7,0,0,0-.3-1l-.7-.7-.6-.2h-.5v-.5l-.9-.6v4.1l1,.7v-2.9h1v3.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M216.4,146.7a1,1,0,0,1-.1-.4v-1.5a2.8,2.8,0,0,0-.3-1.3l-1.3-1-.6-.3-.7-.2.2,1h.5l.5.3c.3.1.4.3.6.4a1.3,1.3,0,0,1,.1.6h0l-.4-.3c-.6-.3-1-.5-1.3-.4s-.5.3-.5.8a2.3,2.3,0,0,0,.3,1.1,3.8,3.8,0,0,0,.9.9l.6.2h.6a1.3,1.3,0,0,0,.3.5l.5.5.3-.7C216.5,146.9,216.4,146.8,216.4,146.7Zm-1.2-.9h-.7c-.1-.1-.2-.3-.3-.3a1.1,1.1,0,0,1-.1-.5c0-.3,0-.3.2-.3l.6.2.3.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M217,148l.9.5v-2.9h.5v3.2l.7.4v-3h.3l.2.2v3.2l.9.6v-3c0-.3,0-.6-.1-.7a1.1,1.1,0,0,0-.2-.6.6.6,0,0,0-.3-.5c-.2-.1-.3-.2-.4-.1l-.4.2c-.1-.2-.1-.4-.2-.5a.5.5,0,0,0-.4-.3h-.7v-.4l-.8-.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M224.5,150.4v-.2a5.1,5.1,0,0,0-.2-1.3,3.3,3.3,0,0,0-.6-1,2.7,2.7,0,0,0-.8-.7,1.3,1.3,0,0,0-1-.2c-.2,0-.5.2-.5.4a1.7,1.7,0,0,0-.3,1,2.7,2.7,0,0,0,.3,1.2,2.4,2.4,0,0,0,.6,1.1,2.8,2.8,0,0,0,1,.9l.8.3h.6l-.4-.9h-.4l-.5-.2c-.2,0-.3-.1-.4-.3s-.2-.3-.3-.4a1.4,1.4,0,0,1-.2-.7l2.3,1.4Zm-2.3-1.8c0-.3,0-.5.2-.6h.5a.7.7,0,0,1,.4.5,2.4,2.4,0,0,1,.2.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M229.1,150.2l1,.6v3.5a2.8,2.8,0,0,0,.3,1.3,4.3,4.3,0,0,0,.9,1l.7.2h.4l-.2-1H232l-.3-.2-.3-.3a.6.6,0,0,1-.1-.4v-4.5l-2.1-1.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M233.3,156.6a6,6,0,0,0,.6,1.1l1,.8.9.3a1,1,0,0,0,.7-.4,3.6,3.6,0,0,0,.2-1.1,5,5,0,0,0-.2-1.2,4.1,4.1,0,0,0-.7-1.1l-.9-.9a1.2,1.2,0,0,0-1-.2.7.7,0,0,0-.6.4,2.2,2.2,0,0,0-.2,1A5.1,5.1,0,0,0,233.3,156.6Zm1-1.5c.1-.2.3-.2.5,0l.5.5a3.1,3.1,0,0,1,.1,1c0,.5,0,.8-.1.9s-.3.2-.5.1-.4-.3-.5-.6-.1-.6-.1-1.1A5.4,5.4,0,0,1,234.3,155.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M237.6,159a2.4,2.4,0,0,0,.6,1.1l1,.9.8.3h.5l-.4-1h-.4l-.4-.2-.4-.3-.3-.5a2.2,2.2,0,0,1-.1-.8,1.7,1.7,0,0,1,.2-.9h.6l.4.3.4.5.4-.5-.5-.7-.8-.5-1-.3a.7.7,0,0,0-.6.4,1.7,1.7,0,0,0-.3,1A3.1,3.1,0,0,0,237.6,159Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M244.5,162.9a1,1,0,0,1-.1-.4V161a2.8,2.8,0,0,0-.4-1.3,4.9,4.9,0,0,0-1.3-1l-.6-.3-.7-.2.2,1h.6l.5.2.5.5a.7.7,0,0,1,.2.6h0l-.5-.3c-.6-.3-.9-.5-1.3-.4s-.4.3-.4.8a1.5,1.5,0,0,0,.3,1.1,3.4,3.4,0,0,0,.8.9l.7.2h.5l.3.5.6.5.2-.7A.4.4,0,0,1,244.5,162.9Zm-1.2-.8h-.6c-.2,0-.3-.2-.4-.3s-.1-.3-.1-.4.1-.4.2-.4l.7.3h.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M245.1,159.5l1,.6v3.5a3.1,3.1,0,0,0,.3,1.3,2.8,2.8,0,0,0,1,.9l.6.3h.5l-.3-1h-.4q-.3-.1-.3-.3l-.2-.4v-4.5l-2.1-1.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M252.5,168.6v-3a1.7,1.7,0,0,0-.3-1,1,1,0,0,0-.7-.7l-.5-.2a.6.6,0,0,0-.5.2v-2.4l-1-.5v5.8l1,.6v-2.8l.3-.2h.4l.3.3a1.3,1.3,0,0,1,.1.6V168Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M253.3,168.1a4.1,4.1,0,0,0,.7,1.1,2.4,2.4,0,0,0,.9.8l1,.3a.7.7,0,0,0,.6-.4,2.5,2.5,0,0,0,.2-1,5.1,5.1,0,0,0-.2-1.3c-.2-.3-.3-.7-.6-1.1a3.9,3.9,0,0,0-1-.8,1.3,1.3,0,0,0-.9-.3,1,1,0,0,0-.7.4,3.1,3.1,0,0,0-.2,1.1A5,5,0,0,0,253.3,168.1Zm1.1-1.5h.5a1,1,0,0,1,.5.6,2.8,2.8,0,0,1,.1,1c0,.5,0,.8-.1.9s-.2.2-.5,0a1.2,1.2,0,0,1-.5-.5c0-.2-.1-.6-.1-1.1A7.8,7.8,0,0,1,254.4,166.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M260.5,171.2l-.4-.6-.6-.7c-.3-.2-.4-.4-.6-.4l-.2-.4c-.1,0-.1-.1-.1-.2h.6l.5.4.5.6.4-.5-.7-.7-.9-.7-.9-.3c-.2,0-.4,0-.5.2s-.2.3-.2.5a1.4,1.4,0,0,0,.2.7,2.5,2.5,0,0,0,.4.7l.5.5.6.5.2.3a.3.3,0,0,1,.1.2c0,.2-.1.2-.2.2l-.4-.2-.5-.4-.5-.6-.5.4a2.8,2.8,0,0,0,.7.9,3.5,3.5,0,0,0,.9.7l.9.3a.6.6,0,0,0,.6-.1.6.6,0,0,0,.3-.6A1.9,1.9,0,0,0,260.5,171.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M261.4,170.4l.7.4v1.9a1.9,1.9,0,0,0,.3,1.3,2.4,2.4,0,0,0,1,1l.6.4h.5l-.3-1h-.6c-.2-.1-.4-.3-.4-.4l-.2-.4v-1.9l1,.6v-.8l-1.2-.6.2-1.3-1-.4v.8l-.7-.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M102,89.9l.9-.5.6-.4.3-.5V88a3.1,3.1,0,0,0-.1-.9,2.4,2.4,0,0,0-.6-.8,2,2,0,0,0-.8-.8,1.4,1.4,0,0,0-1-.3.6.6,0,0,0-.6.3l.6.9.4-.2h.5l.5.5c0,.2.1.4.1.6s0,.3-.1.4a.4.4,0,0,1-.2.3l-.4.3-.5.4-.8.5v.8l3,1.8.2-.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M107.8,89.4a3.4,3.4,0,0,0-1.4-1.5q-.7-.5-1.2,0a2.8,2.8,0,0,0-.4,1.8,5.3,5.3,0,0,0,.4,2.3,3.6,3.6,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a3.2,3.2,0,0,0,.5-1.8A7.3,7.3,0,0,0,107.8,89.4Zm-2,.9a3.7,3.7,0,0,1,.2-1.4.3.3,0,0,1,.5-.2.8.8,0,0,1,.4.4c0,.1.1.1.1.2l-1.2,2.1A4,4,0,0,1,105.8,90.3Zm1.3.8v1.1a1.1,1.1,0,0,1-.3.5h-.4a1,1,0,0,1-.4-.5l1.1-1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="64.9 69 64 68.6 64 64.2 63.1 63.6 61.6 63.8 62.1 64.9 63 64.8 63 68 61.9 67.3 61.9 68.2 64.9 70 64.9 69"
        />
        <polygon
          class="cls-2"
          points="68.8 66.9 65.7 65.1 65.7 66 67.7 67.2 66 70.4 67 71.3 68.8 67.7 68.8 66.9"
        />
        <polygon class="cls-2" points="69.8 70 69.8 70.9 72.7 72.6 72.7 71.6 69.8 70" />
        <path
          class="cls-2"
          d="M123.7,98.7a2.6,2.6,0,0,0-1.2-1.5c-.6-.3-1-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,7.3,7.3,0,0,0,.4,2.3,2.7,2.7,0,0,0,1.3,1.5q.8.5,1.2,0a2.8,2.8,0,0,0,.4-1.8A5.3,5.3,0,0,0,123.7,98.7Zm-1.9,2V99.6a4.2,4.2,0,0,1,.1-1.4c.1-.2.3-.3.6-.1l.4.4h0Zm1.4-.3a3.1,3.1,0,0,1-.1,1.1l-.2.5h-.4c-.2-.2-.4-.3-.4-.5l1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="80.8 73.8 77.7 72.1 77.7 73 79.7 74.1 78 77.4 79 78.3 80.8 74.7 80.8 73.8"
        />
        <polygon class="cls-2" points="84.8 78.5 81.9 76.9 81.9 77.8 84.8 79.5 84.8 78.5" />
        <polygon
          class="cls-2"
          points="89 82.9 88.2 82.5 88.2 78.1 87.2 77.5 85.7 77.7 86.1 78.8 87.1 78.7 87 81.8 86 81.2 86 82.2 89 83.9 89 82.9"
        />
        <polygon
          class="cls-2"
          points="93 85.3 92.2 84.8 92.2 80.4 91.2 79.9 89.7 80 90.1 81.1 91.1 81 91.1 84.2 90 83.6 90 84.4 93 86.2 93 85.3"
        />
        <polygon
          class="cls-2"
          points="101 89.9 100.2 89.4 100.2 85 99.2 84.5 97.7 84.7 98.2 85.8 99.1 85.6 99.1 88.8 98 88.2 98 89.1 101 90.9 101 89.9"
        />
        <path
          class="cls-2"
          d="M152.1,118.9l-2-1.2.9-.5.5-.3a.9.9,0,0,0,.3-.5,1.3,1.3,0,0,0,.1-.6c0-.2-.1-.5-.1-.8a1.8,1.8,0,0,0-.6-.9,2,2,0,0,0-.8-.8l-.9-.3a.7.7,0,0,0-.6.3l.6,1c.1-.2.2-.2.4-.3a.6.6,0,0,1,.5.2.7.7,0,0,1,.4.5.8.8,0,0,1,.2.6.4.4,0,0,1-.1.3l-.2.3-.4.3-.6.4-.8.5v.9l3.1,1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155.1,120.2c-.2-.2-.3-.4-.5-.5s-.4-.2-.5-.1a.6.6,0,0,0-.2.5,4.1,4.1,0,0,0,.2.7l.5.5c.2.1.4.2.5.1a.6.6,0,0,0,.2-.5A2.5,2.5,0,0,0,155.1,120.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155.1,117.6l-.5-.6h-.5a.8.8,0,0,0-.2.5,1.9,1.9,0,0,0,.2.7l.5.6h.5c.1,0,.2-.2.2-.4A1.4,1.4,0,0,0,155.1,117.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="113.1 95.8 112.6 95.5 112.6 94.3 111.7 93.7 111.6 95 110.8 94.4 111.9 92.1 110.9 91.1 109.7 94 109.7 94.7 111.6 95.8 111.6 96.9 112.6 97.6 112.6 96.5 113.1 96.7 113.1 95.8"
        />
        <polygon
          class="cls-2"
          points="117.1 99.2 116.2 98.7 116.2 94.3 115.3 93.8 113.8 94 114.2 95.1 115.2 94.9 115.2 98.1 114.1 97.5 114.1 98.4 117.1 100.2 117.1 99.2"
        />
        <path
          class="cls-2"
          d="M167.1,124.6a1,1,0,0,0-.5-.6h-.5a.8.8,0,0,0-.2.5,1.9,1.9,0,0,0,.2.7l.5.6h.5c.1,0,.2-.2.2-.4A1.4,1.4,0,0,0,167.1,124.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M167.1,127.2c-.2-.2-.3-.4-.5-.5s-.4-.2-.5-.1a.6.6,0,0,0-.2.5,2.5,2.5,0,0,0,.2.7l.5.5c.2.1.4.2.5.1a.6.6,0,0,0,.2-.5A2.5,2.5,0,0,0,167.1,127.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M171.9,126.5a2.8,2.8,0,0,0-1.3-1.5q-.7-.4-1.2,0c-.4.3-.4,1-.4,1.8a5.3,5.3,0,0,0,.4,2.3,3.6,3.6,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a2.6,2.6,0,0,0,.4-1.8A7.9,7.9,0,0,0,171.9,126.5Zm-2,.9a2.7,2.7,0,0,1,.2-1.3.3.3,0,0,1,.5-.2.8.8,0,0,1,.4.4.1.1,0,0,0,.1.1l-1.1,2.1C170,128.2,169.9,127.9,169.9,127.4Zm1.4.9a3.7,3.7,0,0,1-.1,1.1.5.5,0,0,1-.2.4h-.4c-.1-.2-.3-.3-.4-.4l1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="129 101.7 125.9 99.9 125.9 100.8 127.9 102 126.2 105.2 127.2 106.1 129 102.5 129 101.7"
        />
        <polygon
          class="cls-2"
          points="133.6 104.3 133.6 105.3 134.9 106.1 134.9 110.5 136 111.1 136 106.7 137.3 107.4 137.3 106.5 133.6 104.3"
        />
        <path
          class="cls-2"
          d="M188.2,140.8v-3a4.3,4.3,0,0,0-.2-1.1l-.7-.7h-1v-2.3l-1-.5v5.7l1,.7v-2.9h.7c.1.1.2.1.2.3a1.1,1.1,0,0,1,.1.6v2.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M189.2,140.3a4.1,4.1,0,0,0,.7,1.1l1,.9c.3.1.5.3.8.3h.6l-.4-1H191l-.4-.3c-.2-.2-.3-.3-.3-.5a1.4,1.4,0,0,1-.2-.6l2.3,1.3v-.5a2.7,2.7,0,0,0-.3-1.2,3.1,3.1,0,0,0-.5-1,7.3,7.3,0,0,0-.9-.8c-.4-.2-.7-.3-.9-.2s-.5.2-.6.5a2,2,0,0,0-.2.9A5.9,5.9,0,0,0,189.2,140.3Zm1.1-1.7h.4a1,1,0,0,1,.5.6,1.9,1.9,0,0,1,.2.8l-1.4-.7C190,138.9,190.1,138.7,190.3,138.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M200.2,143.5l-1-.6v2.9h-.5l-.3-.3v-3.3l-1.1-.6v2.9a2.3,2.3,0,0,0,.3,1.1,1.5,1.5,0,0,0,.8.8c.2.2.3.2.6.2h.5v.4l1,.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M204.3,148l-.4-.6c-.1-.3-.4-.4-.6-.7l-.5-.4-.3-.4c-.1,0-.1-.1-.1-.2h.6l.5.4c.2.2.4.3.5.6l.4-.5-.6-.7-1-.7-.8-.3c-.3,0-.4,0-.6.2a.7.7,0,0,0-.1.5,1.5,1.5,0,0,0,.1.7c.1.3.3.4.4.7l.6.5a2.3,2.3,0,0,0,.5.5l.2.3v.2c0,.2-.1.2-.1.2l-.4-.2-.6-.4-.4-.6-.6.4.7.9,1,.7c.3.1.5.3.8.3a.6.6,0,0,0,.6-.1.6.6,0,0,0,.3-.6A1.9,1.9,0,0,0,204.3,148Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M208.4,150.3v-.2a3.7,3.7,0,0,0-.2-1.2,3.9,3.9,0,0,0-.6-1.1l-.8-.7a1.3,1.3,0,0,0-1-.2c-.2.1-.5.2-.5.5a1.2,1.2,0,0,0-.3.9,3.1,3.1,0,0,0,.3,1.3,3,3,0,0,0,.6,1.1,3.9,3.9,0,0,0,1,.8l.8.3h.6l-.4-1H207l-.4-.4-.3-.4a1.4,1.4,0,0,1-.2-.7l2.3,1.4Zm-2.3-1.8a.6.6,0,0,1,.3-.6h.4a1,1,0,0,1,.5.6,1.4,1.4,0,0,1,.2.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M216.3,153.7a2.4,2.4,0,0,0-.6-1.1,2.3,2.3,0,0,0-.9-.8,1.4,1.4,0,0,0-1-.3c-.2,0-.4.2-.6.4a1.6,1.6,0,0,0-.2,1,2.7,2.7,0,0,0,.2,1.3,3.2,3.2,0,0,0,1.6,1.9l.9.3a.7.7,0,0,0,.6-.4,1.5,1.5,0,0,0,.3-1A2.8,2.8,0,0,0,216.3,153.7Zm-1.1,1.4c0,.2-.3.2-.4.1a.8.8,0,0,1-.5-.5,3.6,3.6,0,0,1-.2-1.1,1.7,1.7,0,0,1,.2-.9h.5c.2.2.4.3.4.6a2.5,2.5,0,0,1,.2,1C215.4,154.8,215.3,155.1,215.2,155.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M220.7,153.7l-.5-.4-.7-.4-.8-.3c-.2,0-.4,0-.5.2s-.1.4-.1.6v.6l-.8-.4v.8l.8.4v3l1,.6v-2.9l1,.6v-.8l-1.2-.7V154c0-.2.1-.3.2-.3h.4l.4.2.4.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M228.4,162.9V161a2.8,2.8,0,0,0-.4-1.3,3.2,3.2,0,0,0-1.3-1l-.6-.3-.7-.2.2,1h.6l.4.2.6.5a1.3,1.3,0,0,1,.1.6h0l-.4-.3c-.6-.3-1-.5-1.3-.4s-.5.3-.5.8a1.7,1.7,0,0,0,.4,1.1,2.3,2.3,0,0,0,.8.9l.6.2h.6l.3.5.6.5.2-.7Zm-1.2-.9h-.6l-.4-.3a4.3,4.3,0,0,0-.1-.5c0-.3.1-.3.2-.3a.7.7,0,0,1,.6.2l.3.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M235.1,166.9l-.4-.2c-.2-.2-.4-.2-.5-.5l-.5-.5-.5.4a1.7,1.7,0,0,0,.7.8,2.2,2.2,0,0,0,.9.7,1.8,1.8,0,0,0,.9.4h.6c.2-.1.2-.3.2-.6a2.2,2.2,0,0,0-.1-.8c-.1-.2-.3-.3-.4-.6l-.6-.6-.6-.5-.2-.3v-.2a.3.3,0,0,1,.1-.2l.4.2c.2,0,.4.2.6.4l.5.5.4-.5-.7-.7-.9-.6a1.6,1.6,0,0,0-.9-.3h-.5a.7.7,0,0,0-.2.6,1.9,1.9,0,0,0,.2.7c0,.2.2.4.4.6s.4.4.5.6l.6.5.2.3c.1,0,.1.1.1.2S235.2,166.9,235.1,166.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M237.4,168.1a3.9,3.9,0,0,0,.6,1.1l1,.9.8.3h.7l-.4-.9h-.5l-.5-.2c-.1-.1-.3-.1-.4-.3l-.3-.5c-.1-.1-.1-.4-.1-.6l2.2,1.3v-.4a2.7,2.7,0,0,0-.2-1.3l-.5-1-.9-.7a1.4,1.4,0,0,0-1-.3,1.2,1.2,0,0,0-.5.5,1.6,1.6,0,0,0-.2,1A2.5,2.5,0,0,0,237.4,168.1Zm1-1.6h.5l.5.5c0,.3.1.5.1.8l-1.3-.7C238.2,166.8,238.3,166.5,238.4,166.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M244.4,168.8H244c-.3-.2-.6-.3-.7-.2a1.2,1.2,0,0,0-.5.5v-1l-1.3-.7v.7l.5.3v2.4l-.5-.2v.8l2.2,1.2v-.8l-.7-.4v-1.1a1.6,1.6,0,0,1,.4-.7h.5v.7l.6.4.2-1.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="200.4 144.2 199.7 147 199 143.4 197.8 142.7 199 147.5 200.3 148.2 201.5 144.8 200.4 144.2"
        />
        <path
          class="cls-2"
          d="M252.6,175.9v-.2a2.8,2.8,0,0,0-.3-1.3,3.1,3.1,0,0,0-.5-1,2.8,2.8,0,0,0-.9-.7,1.3,1.3,0,0,0-.9-.3,1,1,0,0,0-.6.5,3,3,0,0,0-.2,1,5,5,0,0,0,.2,1.2,3.9,3.9,0,0,0,.6,1.1l1.1.9c.3.1.5.3.8.3h.6l-.4-.9h-.5l-.5-.2c-.1-.1-.3-.1-.3-.3l-.4-.5c0-.1-.1-.4-.1-.6l2.3,1.3Zm-2.4-1.9a.8.8,0,0,1,.2-.6h.5a1.2,1.2,0,0,1,.5.5,2.2,2.2,0,0,1,.1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M256.5,175.8h-.4c-.3-.2-.6-.3-.7-.2a.8.8,0,0,0-.5.5v-1l-1.3-.7v.7l.5.3v2.4l-.5-.2v.8l2.2,1.2v-.8l-.7-.4v-1.1a1.2,1.2,0,0,1,.4-.7h.5v.7l.6.4.2-1.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M261.4,182.8l1,.7v-2.9h.9a.4.4,0,0,1,.1.3v3l1,.7v-3a4.3,4.3,0,0,0-.2-1.1l-.7-.6-.6-.2h-.5v-.5l-.9-.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M102,99.1l.8-.4.6-.4.3-.5c.1-.1.1-.4.1-.5a2.9,2.9,0,0,0-.2-.9,4.1,4.1,0,0,0-.5-.9c-.3-.2-.5-.6-.9-.7a1.6,1.6,0,0,0-.9-.4.8.8,0,0,0-.7.4l.7.9c.1-.2.2-.2.3-.2h.5l.5.5a1.3,1.3,0,0,1,.1.6V97c-.1.1-.1.3-.3.4l-.4.3-.5.4-.8.4v.9l3.1,1.8v-.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M107.8,98.6a4.1,4.1,0,0,0-1.4-1.5q-.7-.4-1.2,0a2.8,2.8,0,0,0-.4,1.8,5.3,5.3,0,0,0,.4,2.3,3.6,3.6,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a3.2,3.2,0,0,0,.5-1.8A7.3,7.3,0,0,0,107.8,98.6Zm-2.1.9a3.7,3.7,0,0,1,.2-1.4c.1-.2.2-.2.5-.1s.4.2.4.4h.1l-1.2,2.1Zm1.4.8a3.1,3.1,0,0,1-.1,1.1c-.1.3-.1.4-.2.5h-.4a.7.7,0,0,1-.4-.5l1.1-1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="64.9 78.3 64 77.8 64 73.4 63.1 72.9 61.6 73 62.1 74.1 63 74 63 77.2 61.8 76.6 61.8 77.4 64.9 79.3 64.9 78.3"
        />
        <polygon
          class="cls-2"
          points="66.9 80.6 68.7 77 68.7 76.1 65.7 74.4 65.7 75.2 67.7 76.4 66 79.6 66.9 80.6"
        />
        <polygon class="cls-2" points="72.7 80.8 69.8 79.2 69.8 80.1 72.7 81.8 72.7 80.8" />
        <path
          class="cls-2"
          d="M123.7,107.9a3.1,3.1,0,0,0-1.2-1.5c-.6-.3-1-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,7.3,7.3,0,0,0,.4,2.3,3.2,3.2,0,0,0,1.3,1.5q.8.4,1.2,0a2.8,2.8,0,0,0,.4-1.8A5.3,5.3,0,0,0,123.7,107.9Zm-1.9.9a3.8,3.8,0,0,1,.1-1.3.4.4,0,0,1,.6-.2l.4.4v.2l-1.1,2Zm1.3.8a3.1,3.1,0,0,1-.1,1.1c-.1.3-.1.4-.2.5h-.4l-.4-.5,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="80.8 83.1 77.7 81.3 77.7 82.2 79.7 83.4 78 86.6 79 87.5 80.8 83.9 80.8 83.1"
        />
        <polygon class="cls-2" points="84.7 87.8 81.8 86.1 81.8 87 84.7 88.8 84.7 87.8" />
        <polygon
          class="cls-2"
          points="88.9 92.2 88.1 91.7 88.1 87.3 87.1 86.8 85.6 87 86.1 88.1 87 87.9 87 91.1 86 90.5 86 91.4 88.9 93.2 88.9 92.2"
        />
        <polygon
          class="cls-2"
          points="92.9 94.5 92.1 94 92.1 89.6 91.2 89.1 89.7 89.2 90.1 90.3 91.1 90.2 91.1 93.4 90 92.8 90 93.7 92.9 95.4 92.9 94.5"
        />
        <polygon
          class="cls-2"
          points="101 99.1 100.1 98.7 100.2 94.3 99.2 93.7 97.7 93.9 98.1 95 99.1 94.8 99.1 98 98 97.4 98 98.4 101 100.1 101 99.1"
        />
        <path
          class="cls-2"
          d="M150,126.9a1.9,1.9,0,0,0,.9-.5l.6-.3.3-.5V125a2.5,2.5,0,0,0-.1-.8,1.8,1.8,0,0,0-.6-.9c0-.3-.4-.5-.7-.8l-1-.3a.7.7,0,0,0-.6.3l.6,1,.4-.3a.6.6,0,0,1,.5.2.7.7,0,0,1,.4.5.8.8,0,0,1,.2.6.4.4,0,0,1-.1.3l-.2.3-.4.3c-.2.1-.3.3-.6.4l-.7.5v.9l3,1.8v-.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155,126.8a.8.8,0,0,0-.5-.5c-.1-.1-.4-.2-.5-.1a.6.6,0,0,0-.2.5,1.9,1.9,0,0,0,.2.7l.5.5c.3.1.4.2.5.1a.6.6,0,0,0,.2-.5A2.5,2.5,0,0,0,155,126.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155,129.5c-.1-.3-.2-.5-.5-.5s-.4-.2-.5-.1a.6.6,0,0,0-.2.5,2.5,2.5,0,0,0,.2.7l.5.5c.3.1.4.2.5.1a.6.6,0,0,0,.2-.5A1.9,1.9,0,0,0,155,129.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="113.1 105 112.6 104.7 112.6 103.5 111.7 102.9 111.6 104.2 110.8 103.7 111.9 101.3 110.9 100.3 109.7 103.2 109.7 103.9 111.6 105 111.6 106.2 112.6 106.8 112.6 105.7 113.1 105.9 113.1 105"
        />
        <polygon
          class="cls-2"
          points="117.1 108.4 116.2 108 116.2 103.5 115.3 103 113.8 103.2 114.2 104.3 115.2 104.1 115.2 107.3 114 106.7 114 107.6 117.1 109.4 117.1 108.4"
        />
        <path
          class="cls-2"
          d="M167.3,137.1a2.5,2.5,0,0,0-.2-.7c-.2-.2-.3-.4-.5-.5s-.4-.2-.5-.1a.6.6,0,0,0-.2.5,2.5,2.5,0,0,0,.2.7l.5.5c.2.2.4.2.5.1A.6.6,0,0,0,167.3,137.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M167.1,133.8l-.5-.6h-.5a.8.8,0,0,0-.2.5,1.9,1.9,0,0,0,.2.7l.5.6h.5c.1,0,.2-.2.2-.4A1.4,1.4,0,0,0,167.1,133.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M171.9,135.7a2.8,2.8,0,0,0-1.3-1.5q-.7-.4-1.2,0c-.4.3-.4,1-.4,1.8a5.3,5.3,0,0,0,.4,2.3,3.6,3.6,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a2.6,2.6,0,0,0,.4-1.8A7.9,7.9,0,0,0,171.9,135.7Zm-2.1.9a2.7,2.7,0,0,1,.2-1.3c.1-.3.3-.4.5-.2s.4.2.4.4h.1l-1.1,2.1C169.9,137.4,169.8,137.1,169.8,136.6Zm1.4.9v1.1l-.3.4h-.4c-.1-.1-.2-.3-.4-.4l1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="129 110.9 125.9 109.1 125.9 110 127.9 111.2 126.2 114.4 127.2 115.3 129 111.7 129 110.9"
        />
        <path
          class="cls-2"
          d="M184.3,145.3a1.8,1.8,0,0,0-.5-.8l-.8-.8c-.2-.2-.4-.3-.5-.5l-.3-.4a.4.4,0,0,1-.1-.3c0-.1,0-.2.1-.2s.1-.1.2-.1h.4l.5.4a1.8,1.8,0,0,1,.5.7l.6-.4-.7-1-1-.8-.8-.3a.8.8,0,0,0-.7.2,1.2,1.2,0,0,0-.2.7c0,.2.1.5.1.8l.5.8a7.5,7.5,0,0,1,.9.9l.5.5.2.4a.6.6,0,0,1,.1.4c0,.2,0,.3-.1.3h-.6a2,2,0,0,1-.7-.6c-.3-.2-.4-.5-.6-.7l-.5.4a2.8,2.8,0,0,0,.7.9,2,2,0,0,0,1.1.9,2.6,2.6,0,0,0,1,.4l.6-.2a.8.8,0,0,0,.2-.7A3.1,3.1,0,0,0,184.3,145.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M185.2,147.2a2.4,2.4,0,0,0,.6,1.1l1,.9.8.3h.6l-.4-.9h-.4l-.5-.2-.4-.3a1.3,1.3,0,0,1-.3-.5,1.1,1.1,0,0,1-.2-.6l2.3,1.3v-.4a5.1,5.1,0,0,0-.2-1.3l-.6-1a2.2,2.2,0,0,0-.9-.7,1.2,1.2,0,0,0-.9-.3c-.2.1-.5.3-.5.5a1.4,1.4,0,0,0-.3.9A3.1,3.1,0,0,0,185.2,147.2Zm1.1-1.6h.4a.8.8,0,0,1,.5.5,1.9,1.9,0,0,1,.2.8l-1.4-.7C186,145.9,186.1,145.6,186.3,145.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M192.2,148l-.4-.2c-.3-.2-.5-.3-.7-.2s-.4.2-.4.5l-.2-1.1-1.3-.7v.8l.5.3v2.4l-.5-.2v.7l2.2,1.3v-.8l-.7-.4v-1.2c.1-.3.3-.4.4-.6h.5v.8l.6.4.3-1.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="148.2 123.3 147.5 126 146.8 122.5 145.7 121.8 146.8 126.6 148.1 127.3 149.3 123.9 148.2 123.3"
        />
        <path
          class="cls-2"
          d="M197.3,154.2a2.4,2.4,0,0,0,.6,1.1l1,.9.8.3h.6l-.4-.9h-.4l-.5-.2-.4-.3a1.3,1.3,0,0,1-.3-.5,1.1,1.1,0,0,1-.2-.6l2.3,1.3v-.4a5.1,5.1,0,0,0-.2-1.3l-.6-1a1.6,1.6,0,0,0-.9-.7,1.2,1.2,0,0,0-.9-.3c-.2.1-.5.3-.5.5a1.4,1.4,0,0,0-.3.9A3.1,3.1,0,0,0,197.3,154.2Zm1-1.6h.4a.8.8,0,0,1,.5.5,1.9,1.9,0,0,1,.2.8l-1.4-.7C198,152.9,198.1,152.6,198.3,152.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M201.3,156.6v.7l2.2,1.3v-.8l-.7-.4v-1.2c0-.3.2-.4.3-.6h.5v.8l.6.4.3-1.6-.3-.2c-.1-.2-.2-.2-.3-.2s-.6-.3-.8-.2a1.1,1.1,0,0,0-.4.5l-.2-1.1-1.2-.7v.8l.4.3v2.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M209.2,162.1l1,.6v-2.8l.3-.2h.4l.3.3v3.2l1.1.7v-3a1.7,1.7,0,0,0-.3-1,1,1,0,0,0-.7-.7l-.5-.2a.6.6,0,0,0-.5.2v-2.4l-1-.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M213.9,159.7v.9l-.8-.4v.8l.8.4v1.9a3.2,3.2,0,0,0,.3,1.4l1,1,.7.3h.4l-.3-.9h-.3l-.3-.2-.4-.3a.9.9,0,0,1-.1-.5v-1.9l1,.7v-.8l-1.2-.7v-1.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M217.9,162.1v.8l-.8-.4v.9l.8.4v1.9a2.8,2.8,0,0,0,.3,1.3,3.6,3.6,0,0,0,1.1,1l.6.4h.5l-.4-1h-.6l-.4-.4a.6.6,0,0,1-.1-.4v-1.9l1,.6v-.8l-1.2-.6v-1.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M222.2,169.2a2.5,2.5,0,0,0,.8,1c.3.1.6.2.7.1a.7.7,0,0,0,.5-.4,3.6,3.6,0,0,0,.2-1.1,5,5,0,0,0-.2-1.2,4.9,4.9,0,0,0-.4-1.1l-.6-.7h-1v-.4l-1-.6v5.8l1.1.5Zm0-2.4.3-.2h.3l.3.3a.8.8,0,0,1,.2.5v.8c0,.5,0,.8-.1.8h-.4l-.3-.2-.3-.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M231.4,169.5v3.1c0,.5-.1.8-.1,1s-.3.3-.6.1-.5-.4-.5-.6v-4.3l-1.1-.6v3.5a3.7,3.7,0,0,0,.1,1.1,6,6,0,0,0,.6,1.1,2.2,2.2,0,0,0,.9.7,1.6,1.6,0,0,0,1,.4.7.7,0,0,0,.5-.4c.2-.2.2-.4.2-.8v-3.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M235.7,174.9h.4l.4-.3c0-.2.1-.3.1-.6a2,2,0,0,0-.5-1.5,11.8,11.8,0,0,0-1.5-1.1l-1.4-.8v5.3l1.1.7v-2.1l.3.2,1,2.6,1.2.7Zm-.5-1c-.2.1-.3,0-.6-.1l-.3-.2v-1.5l.3.2a1,1,0,0,1,.6.5c.2.1.2.4.2.7S235.3,173.9,235.2,173.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="190.2 146.3 190.2 151.7 193.2 153.4 193.3 152.5 191.3 151.3 191.3 147 190.2 146.3"
        />
        <path
          class="cls-2"
          d="M248.4,184.7v-3a3,3,0,0,0-.2-1,2.3,2.3,0,0,0-.7-.7l-.6-.2a.6.6,0,0,0-.5.2v-2.4l-1.1-.4v5.7l1.1.6v-2.8l.2-.2h.5a.5.5,0,0,1,.2.4.7.7,0,0,1,.1.5v2.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M252.2,186h-.3l-.4-.2-.4-.3c0-.2-.1-.3-.1-.5v-1.9l1,.7V183l-1.2-.6.2-1.3-1.1-.5v.9l-.7-.4v.9l.7.4v1.8a2.3,2.3,0,0,0,.4,1.4,2.4,2.4,0,0,0,1,1c.2.2.5.2.6.3h.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M254.1,182.9v.9l-.8-.4v.8l.8.4v1.9a2.2,2.2,0,0,0,.3,1.4,2.4,2.4,0,0,0,1,1l.6.3c.2,0,.4.1.5,0l-.3-.9h-.3l-.4-.2-.3-.3c-.1-.2-.2-.3-.2-.5v-1.9l1,.6v-.7l-1.2-.7.2-1.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M258.4,190.1a2.5,2.5,0,0,0,.8,1c.4.1.6.2.7.1s.4-.2.5-.4a3.6,3.6,0,0,0,.2-1.1,5,5,0,0,0-.2-1.2,3,3,0,0,0-.4-1,1,1,0,0,0-.7-.7l-.5-.2-.4.2v-.5l-.9-.6v5.9l1,.4Zm0-2.5.2-.2h.3l.3.2a.8.8,0,0,1,.2.5,1.7,1.7,0,0,1,.1.8,1.3,1.3,0,0,1-.2.8c-.1.3-.2.3-.4.2l-.3-.3c-.1,0-.1-.2-.2-.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M262.9,191.6c-.2-.1-.4-.2-.5-.1s-.3.2-.3.4a1.3,1.3,0,0,0,.3.8l.5.5c.1.1.3.2.4.1a.5.5,0,0,0,.3-.5,1.1,1.1,0,0,0-.3-.7C263.2,191.9,263.1,191.6,262.9,191.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M263.3,189.4a1,1,0,0,0-.4-.5c-.2-.1-.4-.2-.5-.1a.5.5,0,0,0-.3.5,1.3,1.3,0,0,0,.3.7l.5.5c.1.1.3.2.4.1a.5.5,0,0,0,.3-.5A1.3,1.3,0,0,0,263.3,189.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon class="cls-2" points="217.9 168 218 168.2 218 167.8 217.9 168" />
        <path
          class="cls-2"
          d="M102,108.4l.8-.5.6-.4.3-.6a.7.7,0,0,0,.1-.5,3.7,3.7,0,0,0-.2-.9,3.5,3.5,0,0,0-.5-.8,3.1,3.1,0,0,0-.9-.7,1.6,1.6,0,0,0-.9-.4.8.8,0,0,0-.7.4l.7.9c.1-.2.2-.2.3-.2h.5l.5.5a1.3,1.3,0,0,1,.1.6v.3c-.1.1-.1.3-.3.4l-.4.3-.5.4-.8.4v.9l3.1,1.8v-.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M106.4,112q.8.4,1.2,0a3.5,3.5,0,0,0,.5-1.8,7.3,7.3,0,0,0-.4-2.3,3.2,3.2,0,0,0-1.3-1.5c-.6-.3-1-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,7.3,7.3,0,0,0,.4,2.3A3.2,3.2,0,0,0,106.4,112Zm.7-2.4a3.1,3.1,0,0,1-.1,1.1c-.1.3-.2.4-.2.5h-.4c-.2-.2-.4-.3-.4-.5l1.1-1.9Zm-1.4-.8a4.4,4.4,0,0,1,.2-1.5c.1-.2.3-.3.5-.1l.4.5h0l-1.1,2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="63.1 82.1 61.6 82.2 62 83.3 62.9 83.2 62.9 86.4 61.8 85.8 61.8 86.7 64.8 88.5 64.8 87.5 64 87 64 82.6 63.1 82.1"
        />
        <polygon
          class="cls-2"
          points="65.7 84.5 67.6 85.6 65.9 88.8 66.9 89.8 68.7 86.2 68.7 85.4 65.7 83.6 65.7 84.5"
        />
        <polygon class="cls-2" points="72.7 90.1 69.8 88.4 69.8 89.3 72.7 91 72.7 90.1" />
        <path
          class="cls-2"
          d="M123.6,117.2a2.3,2.3,0,0,0-1.2-1.5c-.6-.3-1-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,8.5,8.5,0,0,0,.4,2.3,3.7,3.7,0,0,0,1.3,1.5q.8.5,1.2,0c.4-.4.4-1,.4-1.9A5.1,5.1,0,0,0,123.6,117.2Zm-1.9.8c0-.7.1-1.1.1-1.3a.4.4,0,0,1,.6-.2l.4.4v.2l-1.1,2C121.8,118.8,121.7,118.5,121.7,118Zm1.4.9a3.1,3.1,0,0,1-.1,1.1c-.1.2-.1.4-.2.5h-.4l-.4-.5,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="79 96.7 80.8 93.2 80.8 92.3 77.7 90.5 77.7 91.4 79.7 92.6 78 95.8 79 96.7"
        />
        <polygon class="cls-2" points="84.7 97 81.8 95.4 81.8 96.3 84.7 98 84.7 97" />
        <polygon
          class="cls-2"
          points="88.9 101.4 88.1 101 88.1 96.5 87.1 96 85.6 96.2 86.1 97.3 87 97.1 87 100.3 86 99.7 86 100.6 88.9 102.4 88.9 101.4"
        />
        <polygon
          class="cls-2"
          points="92.9 103.8 92.1 103.2 92.1 98.8 91.1 98.3 89.6 98.5 90.1 99.6 91.1 99.5 91.1 102.7 90 102.1 90 102.9 92.9 104.6 92.9 103.8"
        />
        <polygon
          class="cls-2"
          points="101 108.4 100.1 107.9 100.1 103.5 99.1 102.9 97.7 103.2 98.1 104.3 99.1 104.1 99.1 107.3 98 106.6 98 107.6 101 109.3 101 108.4"
        />
        <path
          class="cls-2"
          d="M150,136.2l.9-.5.6-.4.3-.4v-.6a3.4,3.4,0,0,0-.1-.9,2.1,2.1,0,0,0-.6-.8,1.4,1.4,0,0,0-.7-.8l-1-.3a.7.7,0,0,0-.6.3l.6.9.4-.2a.6.6,0,0,1,.5.2c.2,0,.3.2.4.4a1.4,1.4,0,0,1,.2.7.4.4,0,0,1-.1.3l-.2.3-.4.3-.6.4-.7.5v.8l3,1.8v-.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155,136a.8.8,0,0,0-.5-.5c-.1-.1-.4-.2-.5-.1a.6.6,0,0,0-.2.5,1.9,1.9,0,0,0,.2.7l.5.5c.3.1.4.2.5.1a.6.6,0,0,0,.2-.5A2.5,2.5,0,0,0,155,136Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155,138.7l-.5-.5c-.1-.1-.4-.2-.5-.1a.6.6,0,0,0-.2.5,2.5,2.5,0,0,0,.2.7l.5.5c.3.1.4.2.5.1a.6.6,0,0,0,.2-.5A1.9,1.9,0,0,0,155,138.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="113.1 114.2 112.6 114 112.6 112.7 111.6 112.2 111.6 113.4 110.7 112.9 111.8 110.5 110.9 109.6 109.6 112.4 109.6 113.2 111.6 114.3 111.6 115.4 112.6 116 112.6 114.9 113.1 115.2 113.1 114.2"
        />
        <polygon
          class="cls-2"
          points="117 117.7 116.1 117.2 116.2 112.7 115.3 112.2 113.8 112.4 114.2 113.5 115.1 113.4 115.1 116.6 114 115.9 114 116.8 117 118.6 117 117.7"
        />
        <path
          class="cls-2"
          d="M167,143a.6.6,0,0,0-.5-.5h-.4a.5.5,0,0,0-.3.5,1.1,1.1,0,0,0,.3.7l.4.5c.2.1.4.2.5.1s.2-.2.2-.5A1.1,1.1,0,0,0,167,143Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M167,145.7c-.1-.3-.2-.5-.5-.5h-.4a.5.5,0,0,0-.3.5,1.3,1.3,0,0,0,.3.7l.4.5c.2.2.4.2.5.1s.2-.2.2-.5A1,1,0,0,0,167,145.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M171.8,144.9a3.1,3.1,0,0,0-1.3-1.5q-.7-.5-1.2,0a2.8,2.8,0,0,0-.4,1.8,7.3,7.3,0,0,0,.4,2.3,3.6,3.6,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a2.6,2.6,0,0,0,.4-1.8A7.9,7.9,0,0,0,171.8,144.9Zm-2,1a3.7,3.7,0,0,1,.2-1.4c.1-.2.3-.3.5-.1s.4.2.4.4h.1l-1.1,2.1C169.9,146.7,169.8,146.3,169.8,145.9Zm1.4.8v1.1a1.1,1.1,0,0,1-.3.5h-.4l-.4-.5,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="128.9 120.1 125.9 118.3 125.9 119.3 127.9 120.5 126.1 123.6 127.1 124.5 128.9 121 128.9 120.1"
        />
        <path
          class="cls-2"
          d="M182.1,153.8l.5.3a3.1,3.1,0,0,0,.9.4l.6-.2a1.2,1.2,0,0,0,.3-.9,2.7,2.7,0,0,0-.6-1.6,2.7,2.7,0,0,0-1.3-1.3l-1.5-.9V155l1.1.6Zm0-2.6.4.3.5.3.3.5v1l-.3.2-.4-.2-.5-.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M188.2,154.9l-.4-.2c-.3-.2-.5-.3-.7-.2l-.5.5v-1l-1.3-.7v.7l.5.3v2.4l-.5-.2v.8l2.2,1.2v-.8l-.7-.4v-1.1a4.3,4.3,0,0,1,.4-.7h.5v.8l.6.4.3-1.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M192.1,158.3a5.4,5.4,0,0,0-1.4-2,1.3,1.3,0,0,0-1-.2.6.6,0,0,0-.6.4,1.3,1.3,0,0,0-.3,1,2.8,2.8,0,0,0,.3,1.3,3,3,0,0,0,.6,1.1,4.4,4.4,0,0,0,1,.8,1.9,1.9,0,0,0,.9.3c.2,0,.5-.2.5-.4a2,2,0,0,0,.3-1.1A2.7,2.7,0,0,0,192.1,158.3Zm-1,1.4a.2.2,0,0,1-.4.1,1,1,0,0,1-.5-.6,2.7,2.7,0,0,1-.2-1.1,1.3,1.3,0,0,1,.2-.8c.1-.2.2-.2.5,0a1,1,0,0,1,.4.5,3.6,3.6,0,0,1,.2,1A1.4,1.4,0,0,1,191.1,159.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="148.1 134.4 149.1 133 148 132.4 147.5 133.4 146.9 131.8 145.7 131.1 146.8 133.7 145.6 135.1 146.8 135.8 147.4 134.6 148.1 136.6 149.3 137.3 148.1 134.4"
        />
        <path
          class="cls-2"
          d="M199.4,161.5l-.8,2.9-.7-3.7-1.1-.6,1.1,4.7.4.3-.3.3h-.8v.9l1,.3a.7.7,0,0,0,.6-.2c.2-.1.3-.4.4-.6l1.2-3.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M206.2,169.2a1.8,1.8,0,0,0,.9,1,.8.8,0,0,0,.8.2c.2-.1.4-.2.4-.5a2.5,2.5,0,0,0,.2-1,5.1,5.1,0,0,0-.2-1.3,2.1,2.1,0,0,0-.4-1,1.6,1.6,0,0,0-.7-.7h-.9v-2.2l-1-.5V169l.9.5Zm-.1-2.5.3-.2h.3l.3.3.2.5v.8c0,.5,0,.8-.1.9h-.4l-.3-.3c-.1,0-.2-.2-.3-.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M209.9,171.7l.4.3c-.1.1-.2.2-.2.3h-.4l-.5-.2.2,1,.9.3a.7.7,0,0,0,.6-.3c.2-.1.3-.4.4-.6l1.2-3.5-1.1-.7-.8,2.9-.7-3.7-1.1-.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M220.2,174.5a3,3,0,0,0-.4-1,1.3,1.3,0,0,0-.6-.7,1.1,1.1,0,0,0-.6-.2l-.4.2v-.5l-1-.6v5.9l1.1.4v-1.9a2.5,2.5,0,0,0,.8,1c.3.1.6.2.7.1s.4-.2.5-.4a3.6,3.6,0,0,0,.2-1.1A5,5,0,0,0,220.2,174.5Zm-1,1.5h-.4c-.1-.1-.3-.2-.3-.3l-.3-.3v-1.8h.6l.3.4c.1,0,.2.3.2.4v.8C219.3,175.6,219.3,175.9,219.2,176Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M221.1,177.3a4.1,4.1,0,0,0,.7,1.1,2.4,2.4,0,0,0,.9.8l1,.3a.5.5,0,0,0,.5-.4,1.5,1.5,0,0,0,.2-1,2.7,2.7,0,0,0-.2-1.3c-.2-.3-.3-.7-.6-1.1a1.8,1.8,0,0,0-.9-.8,1.2,1.2,0,0,0-.9-.3,1,1,0,0,0-.7.4,3.1,3.1,0,0,0-.2,1.1A5,5,0,0,0,221.1,177.3Zm1.1-1.5a.4.4,0,0,1,.5,0c.2.2.4.3.5.6a2.8,2.8,0,0,1,.1,1c0,.5,0,.8-.1.9h-.5l-.5-.5c0-.2-.1-.6-.1-1.1A7.8,7.8,0,0,1,222.2,175.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M228.3,178h-.4c-.3-.2-.6-.3-.7-.2a.8.8,0,0,0-.5.5v-1l-1.3-.7v.7l.5.3v2.4l-.5-.2v.8l2.2,1.2v-.8l-.7-.4v-1.1a1.6,1.6,0,0,1,.4-.7h.5v.7l.6.4.2-1.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M229.9,178.3v.8l-.8-.4v.9l.8.4v1.9a2.8,2.8,0,0,0,.3,1.3,3.6,3.6,0,0,0,1.1,1l.6.4h.5l-.3-1h-.7l-.4-.4c0-.1-.1-.3-.1-.4v-1.9l1,.6v-.8l-1.2-.6.2-1.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M101.9,117.6l.8-.5.6-.4a1.3,1.3,0,0,0,.3-.5c.1-.1.1-.4.1-.5a2.9,2.9,0,0,0-.2-.9,4.1,4.1,0,0,0-.5-.9,2.7,2.7,0,0,0-.8-.7c-.4-.2-.7-.4-.9-.3a.9.9,0,0,0-.7.3l.7.9c.1-.2.2-.2.3-.2h.5c.2.1.3.3.5.5a1.3,1.3,0,0,1,.1.6v.3c-.1.1-.1.3-.3.4s-.2.2-.4.3l-.5.4-.8.5v.9l3.1,1.8v-.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M107.7,117.1a3.9,3.9,0,0,0-1.3-1.5c-.6-.3-1-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,7.3,7.3,0,0,0,.4,2.3,3.2,3.2,0,0,0,1.3,1.5q.8.5,1.2,0a3.5,3.5,0,0,0,.5-1.8A5.3,5.3,0,0,0,107.7,117.1Zm-2,.9a4.4,4.4,0,0,1,.2-1.5c.1-.2.3-.3.5-.1s.4.2.4.4a.1.1,0,0,0,.1.1l-1.2,2.2Zm1.4.8a3.1,3.1,0,0,1-.1,1.1c-.1.3-.2.4-.2.5h-.4c-.3-.2-.4-.3-.4-.5l1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="64.8 96.8 64 96.2 64 91.8 63 91.3 61.5 91.5 62 92.6 62.9 92.5 62.9 95.7 61.8 95 61.8 95.9 64.8 97.7 64.8 96.8"
        />
        <polygon
          class="cls-2"
          points="68.7 94.6 65.6 92.8 65.6 93.7 67.6 94.9 65.9 98 66.9 99 68.7 95.4 68.7 94.6"
        />
        <polygon class="cls-2" points="69.8 97.7 69.8 98.6 72.6 100.2 72.6 99.3 69.8 97.7" />
        <path
          class="cls-2"
          d="M123.6,126.4a2.6,2.6,0,0,0-1.2-1.5c-.6-.3-1-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,8.5,8.5,0,0,0,.4,2.3,3.7,3.7,0,0,0,1.3,1.5q.8.5,1.2,0c.4-.4.4-1,.4-1.9A5.1,5.1,0,0,0,123.6,126.4Zm-1.8,1.9c0-.3-.1-.6-.1-1.1s.1-1.1.1-1.3a.4.4,0,0,1,.6-.2l.4.4c0,.1.1.1.1.2Zm1.3-.2a3.1,3.1,0,0,1-.1,1.1c-.1.2-.1.4-.2.5h-.4l-.4-.5,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="80.8 101.6 77.6 99.8 77.6 100.6 79.7 101.8 77.9 105 79 106 80.8 102.4 80.8 101.6"
        />
        <polygon class="cls-2" points="84.7 106.2 81.8 104.6 81.8 105.5 84.7 107.2 84.7 106.2" />
        <polygon
          class="cls-2"
          points="88.9 110.7 88.1 110.2 88.1 105.7 87.1 105.2 85.6 105.4 86 106.5 87 106.4 87 109.6 85.9 108.9 85.9 109.8 88.9 111.6 88.9 110.7"
        />
        <polygon
          class="cls-2"
          points="92.9 113 92.1 112.5 92.1 108.1 91.1 107.6 89.6 107.7 90 108.8 91.1 108.7 91.1 111.9 89.9 111.3 89.9 112.2 92.9 113.9 92.9 113"
        />
        <polygon
          class="cls-2"
          points="101 117.6 100.1 117.2 100.1 112.7 99.1 112.2 97.7 112.4 98.1 113.5 99.1 113.3 99.1 116.5 97.9 115.9 97.9 116.8 101 118.6 101 117.6"
        />
        <path
          class="cls-2"
          d="M150,145.4l.9-.5.6-.4.3-.4v-.6a3.4,3.4,0,0,0-.1-.9,1.6,1.6,0,0,0-.6-.8,1.8,1.8,0,0,0-.7-.8l-1-.3a.7.7,0,0,0-.6.3l.6.9.4-.2a.6.6,0,0,1,.5.2c.2,0,.3.2.4.4a1.4,1.4,0,0,1,.2.7.4.4,0,0,1-.1.3l-.2.3-.4.3-.6.4-.7.5v.8l3,1.8v-.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155,148c-.2-.3-.3-.5-.5-.6H154c-.1,0-.2.2-.2.4a1.4,1.4,0,0,0,.2.7l.5.6h.5a.8.8,0,0,0,.2-.5A1.9,1.9,0,0,0,155,148Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M155,145.3c-.2-.3-.3-.5-.5-.5s-.4-.2-.5-.1a.6.6,0,0,0-.2.5,2.5,2.5,0,0,0,.2.7l.5.5c.3.1.4.2.5.1a.6.6,0,0,0,.2-.5A2.5,2.5,0,0,0,155,145.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="113 123.5 112.5 123.2 112.5 121.9 111.6 121.4 111.5 122.7 110.7 122.2 111.8 119.7 110.9 118.8 109.6 121.6 109.6 122.4 111.5 123.5 111.5 124.7 112.5 125.3 112.5 124.1 113 124.4 113 123.5"
        />
        <polygon
          class="cls-2"
          points="117 126.9 116.1 126.4 116.1 122 115.2 121.5 113.7 121.6 114.2 122.7 115.1 122.6 115.1 125.8 114 125.2 114 126.1 117 127.8 117 126.9"
        />
        <path
          class="cls-2"
          d="M167,154.9a1.2,1.2,0,0,0-.5-.5c-.1-.1-.4-.2-.4-.1a.5.5,0,0,0-.3.5,1.3,1.3,0,0,0,.3.7l.4.5c.2.1.4.2.5.1s.2-.2.2-.5A1,1,0,0,0,167,154.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M167,152.2l-.5-.5h-.4a.5.5,0,0,0-.3.5,1.1,1.1,0,0,0,.3.7l.4.5c.2.1.4.2.5.1s.2-.2.2-.5A1.1,1.1,0,0,0,167,152.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M171.8,154.2a2.8,2.8,0,0,0-1.3-1.5q-.7-.4-1.2,0a2.8,2.8,0,0,0-.4,1.8,7.3,7.3,0,0,0,.4,2.3,3.6,3.6,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a2.8,2.8,0,0,0,.4-1.8A7.3,7.3,0,0,0,171.8,154.2Zm-2,.9a3.7,3.7,0,0,1,.2-1.4c.1-.2.3-.3.5-.1s.4.2.4.4h.1l-1.1,2.1C169.9,155.9,169.8,155.5,169.8,155.1Zm1.4.8V157a1.1,1.1,0,0,1-.3.5h-.4l-.4-.5,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="128.9 129.3 125.8 127.6 125.8 128.5 127.8 129.7 126.1 132.9 127.1 133.8 128.9 130.2 128.9 129.3"
        />
        <path
          class="cls-2"
          d="M182.9,164.5l-.4-.2a1.8,1.8,0,0,1-.7-.5c-.3-.2-.4-.5-.6-.7l-.5.4a2.8,2.8,0,0,0,.7.9,3.3,3.3,0,0,0,1.1.9,2.6,2.6,0,0,0,1,.4.6.6,0,0,0,.6-.3c.2-.1.3-.3.3-.7a2.9,2.9,0,0,0-.2-.9,1.4,1.4,0,0,0-.5-.8l-.7-.8-.6-.5-.3-.4a.5.5,0,0,1-.1-.3.4.4,0,0,1,.1-.3h.6l.6.4.4.6.6-.4-.7-.9a2.5,2.5,0,0,0-1-.8l-.8-.3h-.7a1.5,1.5,0,0,0-.2.8,1.9,1.9,0,0,0,.2.7,1.2,1.2,0,0,0,.4.8l.9,1,.5.5.2.4a.6.6,0,0,1,.1.4c0,.2,0,.2-.1.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M188.2,166.1a1.4,1.4,0,0,0-.5-.8,5,5,0,0,0-.7-.8l-.6-.5c-.1-.2-.2-.4-.3-.4a.6.6,0,0,1-.1-.4V163h.2l.4.2.6.4.4.6.6-.4-.7-.9a2.7,2.7,0,0,0-1-.8l-.8-.3h-.6a.9.9,0,0,0-.3.7,1.9,1.9,0,0,0,.2.8,2,2,0,0,0,.4.8,10,10,0,0,1,.9,1l.5.5c.1.2.2.2.2.4s.1.2.1.4a.4.4,0,0,1-.1.3h-.2l-.4-.2-.7-.5-.6-.7-.5.4c.1.3.5.6.7.9a5.3,5.3,0,0,0,1.1.9,2.6,2.6,0,0,0,1,.4.6.6,0,0,0,.6-.3.8.8,0,0,0,.3-.7A2.9,2.9,0,0,0,188.2,166.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="143.1 141.9 143.1 137.6 142 137 142 142.3 145 144 145.1 143.1 143.1 141.9"
        />
        <polygon
          class="cls-2"
          points="150 146.1 150 147 153 148.7 153 147.8 152.1 147.3 152.1 144 150.1 142.8 150.1 143.7 151 144.2 151 146.6 150 146.1"
        />
        <path
          class="cls-2"
          d="M198.7,169.6c.1.1.3.2.4.1a.5.5,0,0,0,.2-.4,1.4,1.4,0,0,0-.2-.6,1.1,1.1,0,0,0-.4-.5c-.2-.1-.3-.2-.5-.1s-.2.2-.2.4a1.4,1.4,0,0,0,.2.6A.6.6,0,0,0,198.7,169.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M203,176l-.4-.2-.6-.4-.4-.6-.6.4.7.9,1,.7c.3.1.5.3.8.3a.8.8,0,0,0,.7-.1.8.8,0,0,0,.2-.6,1.4,1.4,0,0,0-.2-.7c0-.3-.2-.4-.3-.7l-.7-.6-.5-.5q-.3-.2-.3-.3v-.2c0-.1,0-.2.1-.2l.4.2.6.4.4.5.4-.4c-.1-.3-.4-.5-.6-.7l-.9-.7-.9-.3a.7.7,0,0,0-.6.2.7.7,0,0,0-.1.5c0,.3.1.5.1.7s.3.4.4.7l.6.5.5.5.3.3v.2C203.1,176,203.1,176,203,176Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M212.2,179.1a1.7,1.7,0,0,0-.3-1,1.1,1.1,0,0,0-.7-.6l-.6-.3-.5.2v-.6l-1-.5v4.1l1,.6v-2.8l.3-.2h.4l.3.2v3.3l1,.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M212.9,180.6a5.1,5.1,0,0,0,.2,1.3,2.6,2.6,0,0,0,.7,1.1,3.6,3.6,0,0,0,.9.8l.9.3a1,1,0,0,0,.7-.4,2.5,2.5,0,0,0,.2-1,5.1,5.1,0,0,0-.2-1.3,2.6,2.6,0,0,0-.7-1.1,3.8,3.8,0,0,0-.9-.9c-.4-.2-.6-.3-.9-.2a1,1,0,0,0-.7.4A2.5,2.5,0,0,0,212.9,180.6Zm1.3-.2c.1-.2.3-.2.5,0a1.2,1.2,0,0,1,.5.5c0,.3.1.7.1,1.1a5.4,5.4,0,0,1-.1.8c-.1.2-.3.3-.5.1l-.5-.5a3.7,3.7,0,0,1-.1-1.1C214.1,180.8,214.1,180.5,214.2,180.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M218.2,185.4a2.4,2.4,0,0,0,1,1l.6.4h.5l-.3-1h-.7l-.4-.4c0-.1-.1-.3-.1-.4V183l1,.6v-.8l-1.2-.6.2-1.3-1.1-.4v.8l-.7-.4v.9l.7.4v1.9A2,2,0,0,0,218.2,185.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M227.1,187.5c.2,0,.3.1.4.3s.2.3.4.5l.5-.5-.6-.7-.8-.5-1-.3a.5.5,0,0,0-.6.4,1.3,1.3,0,0,0-.3,1,3.1,3.1,0,0,0,.3,1.3,6,6,0,0,0,.6,1.1,3.9,3.9,0,0,0,1,.8l.8.3h.6l-.5-1.1h-.8l-.4-.3a3.3,3.3,0,0,1-.3-.6,1.9,1.9,0,0,1-.1-.8c0-.4.1-.7.3-.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M232.3,190.7a3.9,3.9,0,0,0-.6-1.1,4.3,4.3,0,0,0-1-.9c-.4-.2-.6-.3-.9-.2a.8.8,0,0,0-.7.4,2.2,2.2,0,0,0-.2,1,5.1,5.1,0,0,0,.2,1.3l.7,1.1a2.2,2.2,0,0,0,.9.7,1.6,1.6,0,0,0,1,.4c.2,0,.4-.2.6-.4a3.6,3.6,0,0,0,.2-1.1A5,5,0,0,0,232.3,190.7Zm-1.1,1.4c-.1.2-.2.2-.5.1s-.4-.3-.5-.6-.1-.6-.1-1.1a5.4,5.4,0,0,1,.1-.8c.1-.2.3-.2.5,0a.8.8,0,0,1,.5.5,3.1,3.1,0,0,1,.1,1C231.3,191.7,231.3,192,231.2,192.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M235.2,195.4l1,.6v-3a3.6,3.6,0,0,0-.2-1l-.7-.6a1,1,0,0,0-.7-.2h-.4v-.5l-.9-.6v4.1l1,.6v-2.8l.2-.2h.5l.2.2a.3.3,0,0,1,.1.2v3.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M240.9,193l-.6-.4-.8-.4-.8-.3c-.2,0-.4,0-.4.2a1.4,1.4,0,0,0-.2.6v.6l-.8-.4v.9l.8.3v3l1,.7v-3l1,.6.2-.8-1.2-.7v-.5c0-.3.1-.4.2-.4h.5l.3.3c.2,0,.3.2.4.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="194.1 171.6 194.1 172.5 197 174.2 197 173.4 196.2 172.8 196.2 169.5 194.1 168.3 194.1 169.2 195.1 169.8 195.1 172.2 194.1 171.6"
        />
        <path
          class="cls-2"
          d="M242.7,195.1h.5a.8.8,0,0,0,.2-.4,2.5,2.5,0,0,0-.2-.7.7.7,0,0,0-.5-.4c-.1-.1-.3-.2-.4-.1a.5.5,0,0,0-.2.4,2.1,2.1,0,0,0,.2.6C242.4,194.9,242.5,194.9,242.7,195.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M248.6,199.7l-.2-1.3h-1l-.7-.3h0l-.8-.3a1.1,1.1,0,0,0-.6.2,1.2,1.2,0,0,0-.2.7,3.1,3.1,0,0,0,.2.8c0,.2.2.4.4.7l-.3.2c-.1.1-.1.2-.1.4a1.1,1.1,0,0,0,.3.7,1.4,1.4,0,0,0,.8.7l.6.3.4.3a.8.8,0,0,1,.1.4v.3h-.3l-.5-.3-.5-.3c-.2-.1-.2-.2-.2-.3a.4.4,0,0,1-.1-.3l-1-.6a1.9,1.9,0,0,0,.2.8,1.8,1.8,0,0,0,.5.8l1.1.8a2.6,2.6,0,0,0,1.4.5.7.7,0,0,0,.5-.7,1.4,1.4,0,0,0-.2-.7,1.8,1.8,0,0,0-.5-.8l-.7-.5-.5-.3q-.3-.2-.3-.3c-.1,0-.1-.1-.1-.2h.2l.2.2.8.3a1.1,1.1,0,0,0,.6-.2c.1-.1.1-.3.1-.6a1.7,1.7,0,0,0-.1-.7l-.5-.7.6.3Zm-1.5.5c0,.1-.2.1-.4-.1s-.3-.2-.3-.4a1.1,1.1,0,0,1-.2-.6.5.5,0,0,1,.2-.4c0-.1.2-.1.3.1s.4.2.4.4a1.1,1.1,0,0,1,.2.5A.6.6,0,0,1,247.1,200.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M252.3,201.4l-1-.6v2.9h-.6l-.3-.2v-3.3l-1.1-.6v2.9a2,2,0,0,0,.3,1.1c.1.3.4.5.8.8l.6.2.5-.2v.5l1,.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M256.4,205.3l.2-1.6-.2-.2-.4-.2c-.3-.1-.5-.2-.7-.1a.8.8,0,0,0-.5.5v-1.1l-1.3-.7v.8l.5.3v2.4l-.5-.2v.7l2.2,1.3v-.8l-.7-.4v-1.2c.1-.3.3-.4.4-.6h.5v.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M257.1,206.2a2.7,2.7,0,0,0,.3,1.2,2.4,2.4,0,0,0,.6,1.1,2.8,2.8,0,0,0,1,.9l.8.3h.6l-.5-.8h-.4l-.5-.2c-.2-.1-.3-.1-.4-.3l-.3-.5a1.1,1.1,0,0,1-.2-.6l2.3,1.3v-.4a5.1,5.1,0,0,0-.2-1.3,3.3,3.3,0,0,0-.6-1c-.1-.4-.4-.6-.8-.8a1.1,1.1,0,0,0-.9-.2c-.2,0-.5.2-.5.4A1.7,1.7,0,0,0,257.1,206.2Zm1.4-.4c.1-.1.2-.1.4,0a.8.8,0,0,1,.5.5,2.4,2.4,0,0,1,.2.8l-1.4-.7A.6.6,0,0,1,258.5,205.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M261.6,210.7a1.5,1.5,0,0,0,.7.7.7.7,0,0,0,.6.2l.4-.2v.5l.9.6v-5.8l-1-.8v2l-.4-.5-.4-.3c-.4-.1-.6-.2-.8-.1s-.4.2-.5.4a3.6,3.6,0,0,0-.2,1.1,5,5,0,0,0,.2,1.2A3,3,0,0,0,261.6,210.7Zm.7-2.5h.5l.3.3.2.4v1.7l-.2.2h-.4l-.3-.4-.2-.4a2.2,2.2,0,0,1-.1-.8A1.4,1.4,0,0,1,262.3,208.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M102,126.8l.8-.4.6-.4.3-.5a1.1,1.1,0,0,0,.1-.5,2.9,2.9,0,0,0-.2-.9,4.1,4.1,0,0,0-.5-.9,2.5,2.5,0,0,0-1-.8l-.9-.3a.9.9,0,0,0-.7.3l.8,1,.3-.3c.2,0,.4,0,.5.2a1.2,1.2,0,0,1,.5.5c.1.1.1.4.1.6v.3c-.1.1-.1.3-.3.3a.4.4,0,0,1-.4.3l-.5.4-.8.5v.9l3.1,1.8V128Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M107.7,126.3a4.9,4.9,0,0,0-1.3-1.5c-.6-.3-1-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,7.3,7.3,0,0,0,.4,2.3,3.2,3.2,0,0,0,1.3,1.5q.8.4,1.2,0a3.5,3.5,0,0,0,.5-1.8A7.3,7.3,0,0,0,107.7,126.3Zm-2,.9a4.9,4.9,0,0,1,.1-1.4c.1-.2.3-.3.6-.1l.4.4h0l-1.1,2.1A4,4,0,0,1,105.7,127.2Zm1.3.9a3.1,3.1,0,0,1-.1,1.1c-.1.2-.1.4-.2.5h-.4l-.4-.5,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="64.8 106 64 105.5 64 101.1 63 100.6 61.5 100.7 62 101.8 62.9 101.7 62.9 104.9 61.8 104.3 61.8 105.2 64.8 106.9 64.8 106"
        />
        <polygon
          class="cls-2"
          points="68.7 103.9 65.6 102.1 65.6 102.9 67.6 104.1 65.9 107.3 66.9 108.3 68.7 104.6 68.7 103.9"
        />
        <polygon class="cls-2" points="72.6 108.5 69.7 106.8 69.7 107.8 72.6 109.4 72.6 108.5" />
        <path
          class="cls-2"
          d="M123.6,135.6a3.1,3.1,0,0,0-1.2-1.5c-.6-.3-1-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,8.5,8.5,0,0,0,.4,2.3,3.7,3.7,0,0,0,1.3,1.5q.8.5,1.2,0c.4-.4.4-1,.4-1.9A5.1,5.1,0,0,0,123.6,135.6Zm-1.9.9a10.9,10.9,0,0,1,.1-1.3c.1-.3.3-.3.6-.2l.4.4v.2l-1.1,2C121.8,137.3,121.7,137,121.7,136.5Zm1.3.8a3.1,3.1,0,0,1-.1,1.1.8.8,0,0,1-.2.5h-.4l-.4-.5,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="80.8 110.8 77.6 109 77.6 109.9 79.7 111.1 77.9 114.2 79 115.2 80.8 111.6 80.8 110.8"
        />
        <polygon class="cls-2" points="84.6 115.5 81.7 113.8 81.7 114.8 84.6 116.4 84.6 115.5" />
        <polygon
          class="cls-2"
          points="88.9 119.9 88 119.4 88 115 87 114.5 85.6 114.6 86 115.7 87 115.6 87 118.8 85.9 118.2 85.9 119.1 88.9 120.8 88.9 119.9"
        />
        <polygon
          class="cls-2"
          points="91.1 116.8 89.6 116.9 90 118 91 117.9 91 121.1 89.9 120.5 89.9 121.4 92.9 123.1 92.9 122.2 92 121.7 92 117.3 91.1 116.8"
        />
        <polygon
          class="cls-2"
          points="100.9 126.8 100 126.4 100.1 121.9 99.1 121.4 97.7 121.6 98 122.7 99 122.6 99 125.7 97.9 125.1 97.9 126 100.9 127.8 100.9 126.8"
        />
        <path
          class="cls-2"
          d="M150,154.7l.8-.5.6-.4.3-.5c.1-.1.1-.4.1-.5a3.7,3.7,0,0,0-.2-.9,2.2,2.2,0,0,0-.5-.8,1.1,1.1,0,0,0-.8-.8,1.4,1.4,0,0,0-1-.3.6.6,0,0,0-.6.3l.6.9.4-.2h.5c.2.1.3.3.5.5s.1.4.1.6,0,.3-.1.4a.4.4,0,0,1-.2.3l-.4.3-.5.4-.8.4v.9l3,1.8v-.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M154.9,154.5a.8.8,0,0,0-.5-.5H154a.5.5,0,0,0-.3.5,1.3,1.3,0,0,0,.3.7l.4.5c.3.1.4.2.5.1s.2-.2.2-.5A1.1,1.1,0,0,0,154.9,154.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M154.9,157.2c-.1-.2-.2-.5-.5-.6H154c-.2,0-.3.2-.3.4a.9.9,0,0,0,.3.7c.1.3.3.4.4.6h.5c.2-.1.2-.3.2-.5A1,1,0,0,0,154.9,157.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="113 132.7 112.5 132.5 112.5 131.1 111.6 130.7 111.5 131.9 110.7 131.4 111.8 128.9 110.9 128.1 109.6 130.8 109.6 131.6 111.5 132.8 111.5 133.9 112.5 134.4 112.5 133.3 113 133.6 113 132.7"
        />
        <polygon
          class="cls-2"
          points="117 136.1 116.1 135.6 116.1 131.2 115.2 130.7 113.7 130.8 114.2 131.9 115.1 131.9 115.1 135 113.9 134.4 113.9 135.3 117 137 117 136.1"
        />
        <path
          class="cls-2"
          d="M167,161.4a1.2,1.2,0,0,0-.5-.5c-.1-.1-.4-.2-.4-.1a.5.5,0,0,0-.3.5,1.1,1.1,0,0,0,.3.7l.4.5c.2.1.4.2.5.1s.2-.2.2-.5A1.1,1.1,0,0,0,167,161.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M167.2,164.8a1,1,0,0,0-.2-.7l-.5-.5h-.4a.5.5,0,0,0-.3.5,1.3,1.3,0,0,0,.3.7l.4.5c.2.1.4.2.5.1S167.2,165.1,167.2,164.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M171.8,163.4a2.8,2.8,0,0,0-1.3-1.5q-.7-.5-1.2,0a2.8,2.8,0,0,0-.4,1.8,7.3,7.3,0,0,0,.4,2.3,3.6,3.6,0,0,0,1.2,1.5c.6.3,1,.3,1.3,0a2.8,2.8,0,0,0,.4-1.8A7.3,7.3,0,0,0,171.8,163.4Zm-2,.9a3.8,3.8,0,0,1,.1-1.3c.1-.2.3-.3.6-.1l.4.3v.2l-1.1,2Zm1.4.8a3.1,3.1,0,0,1-.1,1.1l-.2.5a.3.3,0,0,1-.4,0l-.4-.5,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="128.9 138.6 125.8 136.8 125.8 137.8 127.8 138.9 126.1 142.1 127.1 143 128.9 139.4 128.9 138.6"
        />
        <polygon
          class="cls-2"
          points="137.3 143.4 133.5 141.3 133.5 142.2 134.8 143 134.8 147.3 135.9 148 135.9 143.7 137.2 144.4 137.3 143.4"
        />
        <path
          class="cls-2"
          d="M188.1,174.4a4.1,4.1,0,0,0-.7-1.1c-.1-.4-.4-.6-.8-.9a1.3,1.3,0,0,0-1-.2c-.2,0-.4.2-.6.4a1.5,1.5,0,0,0-.2,1,2.7,2.7,0,0,0,.2,1.3,3.9,3.9,0,0,0,.6,1.1l1,.8.9.3a.8.8,0,0,0,.6-.4,2.5,2.5,0,0,0,.2-1A5.1,5.1,0,0,0,188.1,174.4Zm-1.1,1.4c0,.2-.2.3-.4.1l-.5-.5a3.6,3.6,0,0,1-.2-1.1,1.4,1.4,0,0,1,.2-.9c.1-.2.2-.2.5,0a.7.7,0,0,1,.4.5,3.6,3.6,0,0,1,.2,1.1A1.3,1.3,0,0,1,187,175.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M195,178.1l.4.3.4.5.4-.5c-.1-.2-.4-.4-.5-.7l-.8-.5-1-.3a1,1,0,0,0-.7.4,3,3,0,0,0-.2,1,5.9,5.9,0,0,0,.2,1.3,4.1,4.1,0,0,0,.7,1.1,4.5,4.5,0,0,0,1,.9l.8.3h.5l-.4-1h-.4a.5.5,0,0,1-.4-.2l-.4-.3a.5.5,0,0,1-.3-.5,2.2,2.2,0,0,1-.1-.8,1.7,1.7,0,0,1,.2-.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M200.1,181.3a3.9,3.9,0,0,0-.6-1.1,2.4,2.4,0,0,0-.9-.8,1.3,1.3,0,0,0-1-.3c-.2,0-.4.2-.6.4a3,3,0,0,0-.2,1,5.1,5.1,0,0,0,.2,1.3,3.2,3.2,0,0,0,1.6,1.9l.9.3a.7.7,0,0,0,.6-.4,2.5,2.5,0,0,0,.2-1A5.1,5.1,0,0,0,200.1,181.3Zm-1,1.4c-.1.3-.3.3-.5.1l-.5-.5a3.7,3.7,0,0,1-.1-1.1,2,2,0,0,1,.1-.9.4.4,0,0,1,.5,0c.2.2.4.3.5.6s.1.6.1,1A2.8,2.8,0,0,1,199.1,182.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M201,184.9l1,.7v-2.9h1a.4.4,0,0,1,.1.3v3l1,.7v-3a3,3,0,0,0-.2-1,1.9,1.9,0,0,0-.8-.7l-.6-.2-.5.2v-.6l-1-.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M207.1,183.6c.1,0,.2,0,.4.2l.4.2.4.3.3-.6-.5-.5-.7-.4-.8-.3-.5.2c0,.2-.1.4-.1.7v.5l-.8-.4v.9l.8.4v3l1,.6v-3l1,.6v-.7l-1.2-.7V184A.5.5,0,0,1,207.1,183.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M210.6,185.7c.2.1.3.2.5.1s.1-.2.1-.4a1.5,1.5,0,0,0-.1-.6c-.1-.2-.3-.3-.5-.5h-.5c-.1.1-.1.2-.1.4s.1.4.1.7A1,1,0,0,0,210.6,185.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="161.9 162.3 161.9 163.2 164.9 164.9 164.9 164 164 163.5 164 160.2 162 159 162 159.8 162.9 160.4 162.9 162.8 161.9 162.3"
        />
        <path
          class="cls-2"
          d="M216.5,190.4l-.2-1.3h-1.1l-.6-.3h-.1l-.7-.3-.6.2c-.2.1-.2.4-.2.7a2.5,2.5,0,0,0,.1.8l.5.8h-.3a.6.6,0,0,0-.1.4,1.4,1.4,0,0,0,.2.7,2.2,2.2,0,0,0,.9.7l.6.3.3.4a.5.5,0,0,1,.2.4v.2h-.2l-.6-.2-.5-.4c-.1,0-.2-.2-.2-.3a.4.4,0,0,1-.1-.3l-1-.5a1.9,1.9,0,0,0,.2.7,1.8,1.8,0,0,0,.5.8l1.1.8c.6.4,1.1.6,1.4.5s.4-.3.4-.7a1.5,1.5,0,0,0-.1-.7,1.2,1.2,0,0,0-.5-.7c-.2-.3-.5-.4-.7-.6l-.5-.3-.4-.2v-.3h.3l.2.2.8.3.6-.2c.1-.1.1-.3.1-.6s-.1-.5-.1-.7l-.5-.7.5.3Zm-1.5.5c-.1.1-.2,0-.4-.1l-.4-.3a1.5,1.5,0,0,1-.1-.7c0-.2,0-.3.1-.4h.4a.8.8,0,0,1,.4.4,1.4,1.4,0,0,1,.2.6A.5.5,0,0,1,215,190.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M220.2,192l-1-.6v2.9l-.3.2h-.3l-.2-.3c-.1,0-.1-.2-.1-.4v-2.9l-1-.6v2.9a4.3,4.3,0,0,0,.2,1.1,2,2,0,0,0,.8.8.7.7,0,0,0,.6.2h.5v.5l.9.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M224.5,194.5l-.2-.3-.4-.2a1.2,1.2,0,0,0-.7-.2l-.5.5-.2-1-1.2-.7v.8l.5.2V196l-.5-.2v.8l2.2,1.2v-.7l-.7-.4v-1.2a.9.9,0,0,1,.4-.6h.4v.7l.7.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M228.4,198.9v-.3a2.7,2.7,0,0,0-.3-1.2,3.1,3.1,0,0,0-.5-1l-.9-.8c-.4-.2-.7-.3-.9-.2s-.5.2-.6.5a2,2,0,0,0-.2.9,5.9,5.9,0,0,0,.2,1.3,3.9,3.9,0,0,0,.6,1.1l1.1.8c.3.2.5.4.8.4h.6l-.4-1h-1l-.3-.3-.4-.5c0-.2-.1-.4-.1-.6l2.3,1.3Zm-2.3-1.8a1,1,0,0,1,.2-.7h.5c.2.2.4.3.5.6s.1.5.1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M233.1,203.5l.9.6v-3.4a1.1,1.1,0,0,0-.1-.6h0l1.1,4.7,1.4.8v-5.4l-1-.5v2.9a2.2,2.2,0,0,0,.1.8,1.3,1.3,0,0,1,.1.6l-1.2-5-1.3-.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M237.2,205.1a4.1,4.1,0,0,0,.7,1.1,3.9,3.9,0,0,0,1,.8c.3.2.5.4.8.4h.6l-.4-1H239l-.4-.3a.9.9,0,0,1-.3-.5,1.4,1.4,0,0,1-.2-.6l2.3,1.3v-.5a2.7,2.7,0,0,0-.3-1.2,5.4,5.4,0,0,0-.5-1.1,2.2,2.2,0,0,0-.9-.7c-.4-.2-.7-.3-.9-.2s-.5.2-.6.5a2,2,0,0,0-.2.9A5.9,5.9,0,0,0,237.2,205.1Zm1.1-1.7h.5c.2.2.4.3.5.6a1.7,1.7,0,0,1,.1.8l-1.3-.7A1,1,0,0,1,238.3,203.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M241.2,205l.7.4v1.9a2.8,2.8,0,0,0,.3,1.3,2.4,2.4,0,0,0,1,1l.6.4h.5l-.3-1h-.6c-.2-.1-.3-.3-.4-.4l-.2-.4v-1.9l1,.6V206l-1.2-.6.2-1.3-1-.4v.8l-.7-.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M246.3,211.1a2.6,2.6,0,0,0,.9.9l.6.2h.5l-.2-.9h-.3l-.2-.2-.3-.3a.5.5,0,0,1-.2-.4v-4.5l-2.2-1.1v.8l1.1.7v3.4A2.2,2.2,0,0,0,246.3,211.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M250.8,208.9c.1.1.3.2.4.1a.5.5,0,0,0,.2-.4,2.1,2.1,0,0,0-.2-.6l-.4-.5h-.5a.5.5,0,0,0-.2.4,2.5,2.5,0,0,0,.2.7A.7.7,0,0,0,250.8,208.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="202.1 185.5 202.1 186.3 205 188.1 205 187.2 204.2 186.7 204.2 183.4 202.1 182.2 202.1 183 203.1 183.6 203.1 186 202.1 185.5"
        />
        <path
          class="cls-2"
          d="M255.3,211.4l.5.2a.5.5,0,0,0,.4.2c.1.1.2.3.4.4l.3-.7c-.2-.1-.3-.3-.6-.4l-.8-.4-.7-.4a.5.5,0,0,0-.5.3,1.1,1.1,0,0,0-.2.6v.6l-.8-.4v.8l.8.4v3l1.1.6v-2.9l1,.6v-.8l-1.1-.7v-.6C255.2,211.6,255.2,211.5,255.3,211.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M259.6,214.8l-.8,2.9-.7-3.7-1.1-.7,1.1,4.8.4.2-.3.3h-.3l-.5-.2v1l1,.3.6-.3a1.5,1.5,0,0,0,.4-.6l1.2-3.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M265.2,221.4v-.9c0,.1-.1.2-.1.4A.7.7,0,0,0,265.2,221.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M101.9,136l.8-.4.6-.4a1.3,1.3,0,0,0,.3-.5,1.1,1.1,0,0,0,.1-.5,2.9,2.9,0,0,0-.2-.9,4.1,4.1,0,0,0-.5-.9l-.9-.8-.9-.3a.9.9,0,0,0-.7.3l.7,1c.1-.2.2-.2.4-.3a.4.4,0,0,1,.4.2.8.8,0,0,1,.5.5,1.1,1.1,0,0,1,.2.6c0,.2,0,.2-.1.3s-.1.3-.2.3l-.4.3-.6.4-.8.5v.9l3.1,1.8v-.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M107.6,135.6a3.2,3.2,0,0,0-1.3-1.5c-.6-.3-1-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,8.5,8.5,0,0,0,.4,2.3,3.7,3.7,0,0,0,1.3,1.5q.8.5,1.2,0c.4-.4.4-1,.5-1.9A5.1,5.1,0,0,0,107.6,135.6Zm-1.9.8a4.9,4.9,0,0,1,.1-1.4c.1-.2.3-.3.6-.1s.3.2.4.4h0l-1.1,2.1A4,4,0,0,1,105.7,136.4Zm1.3.9a3.1,3.1,0,0,1-.1,1.1c-.1.2-.1.4-.2.5h-.4l-.4-.5,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="63 109.8 61.5 109.9 61.9 111 62.9 110.9 62.9 114.1 61.8 113.5 61.8 114.4 64.7 116.1 64.7 115.2 63.9 114.7 64 110.3 63 109.8"
        />
        <polygon
          class="cls-2"
          points="68.7 113.1 65.6 111.3 65.6 112.2 67.6 113.4 65.8 116.5 66.9 117.5 68.7 113.8 68.7 113.1"
        />
        <polygon class="cls-2" points="72.6 117.8 69.7 116 69.7 117 72.6 118.7 72.6 117.8" />
        <path
          class="cls-2"
          d="M123.6,144.8a2.6,2.6,0,0,0-1.3-1.4.9.9,0,0,0-1.3,0c-.3.3-.3.9-.3,1.8a7.3,7.3,0,0,0,.3,2.2,3.9,3.9,0,0,0,1.3,1.5c.6.3.9.3,1.3,0a2.6,2.6,0,0,0,.4-1.8A8.5,8.5,0,0,0,123.6,144.8Zm-2,.9a2.7,2.7,0,0,1,.2-1.3c0-.3.3-.3.5-.2l.4.4c0,.1.1.1.1.2l-1.1,2C121.7,146.5,121.6,146.2,121.6,145.7Zm1.4.9a3.7,3.7,0,0,1-.1,1.1c0,.2-.1.4-.2.4h-.4l-.4-.4,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="78.9 124.5 80.7 120.8 80.7 120 77.6 118.3 77.6 119.1 79.7 120.3 77.9 123.5 78.9 124.5"
        />
        <polygon class="cls-2" points="84.6 124.7 81.7 123 81.7 124 84.6 125.6 84.6 124.7" />
        <polygon
          class="cls-2"
          points="88.9 129.1 88 128.6 88 124.2 87 123.7 85.6 123.8 86 124.9 87 124.9 87 128 85.9 127.4 85.9 128.3 88.9 130 88.9 129.1"
        />
        <polygon
          class="cls-2"
          points="92.9 131.5 92 130.9 92 126.5 91.1 126 89.6 126.2 90 127.3 91 127.1 91 130.4 89.9 129.7 89.9 130.6 92.9 132.4 92.9 131.5"
        />
        <polygon
          class="cls-2"
          points="100.9 136.1 100 135.6 100 131.1 99.1 130.7 97.6 130.8 98 131.9 99 131.8 99 135 97.9 134.4 97.9 135.2 100.9 137 100.9 136.1"
        />
        <path
          class="cls-2"
          d="M150,163.9l.8-.5.6-.4.3-.5c.1-.1.1-.4.1-.5a3.7,3.7,0,0,0-.2-.9,2.2,2.2,0,0,0-.5-.8,2,2,0,0,0-.8-.8,1.4,1.4,0,0,0-1-.3.6.6,0,0,0-.6.3l.6.9.4-.2h.5c.2.1.3.3.5.5s.1.4.1.6,0,.3-.1.4a.4.4,0,0,1-.2.3l-.4.3-.5.4-.8.4v.9l3,1.8v-.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M154.9,163.7a.8.8,0,0,0-.5-.5H154a.5.5,0,0,0-.3.5,1.3,1.3,0,0,0,.3.7l.4.5c.3.1.4.2.5.1s.2-.2.2-.5A1.1,1.1,0,0,0,154.9,163.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M154.9,166.4l-.5-.6c-.1,0-.4-.1-.4,0s-.3.2-.3.4a.9.9,0,0,0,.3.7c.1.3.3.4.4.6h.5c.2-.1.2-.3.2-.5A1,1,0,0,0,154.9,166.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="113 141.9 112.5 141.7 112.5 140.4 111.6 139.9 111.5 141.1 110.6 140.6 111.7 138.1 110.9 137.3 109.5 140.1 109.5 140.9 111.5 142 111.5 143.1 112.5 143.7 112.5 142.5 113 142.9 113 141.9"
        />
        <polygon
          class="cls-2"
          points="116.9 145.4 116 144.8 116.1 140.4 115.2 139.9 113.7 140.1 114.1 141.2 115 141.1 115 144.3 113.9 143.7 113.9 144.5 116.9 146.2 116.9 145.4"
        />
        <path
          class="cls-2"
          d="M166.9,170.7c0-.2-.2-.5-.4-.5s-.4-.2-.5-.1-.2.2-.2.5a1.1,1.1,0,0,0,.2.7l.5.5h.4a.5.5,0,0,0,.3-.5A1.3,1.3,0,0,0,166.9,170.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M166.9,173.4a.7.7,0,0,0-.4-.6c-.2,0-.4-.1-.5,0s-.2.2-.2.4a.8.8,0,0,0,.2.7c.1.3.3.4.5.6h.4a.5.5,0,0,0,.3-.5A1.1,1.1,0,0,0,166.9,173.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M171.7,172.7a2.6,2.6,0,0,0-1.2-1.5c-.6-.3-1-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,7.9,7.9,0,0,0,.4,2.3,3.2,3.2,0,0,0,1.3,1.5q.8.4,1.2,0a2.8,2.8,0,0,0,.4-1.8A5.3,5.3,0,0,0,171.7,172.7Zm-1.9.8a3.8,3.8,0,0,1,.1-1.3c.1-.2.3-.3.6-.1l.4.3v.2l-1.1,2Zm1.4.9a3.1,3.1,0,0,1-.1,1.1l-.2.5h-.4c-.2-.3-.4-.3-.4-.5l1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="128.8 147.8 125.8 146 125.8 147 127.8 148.1 126 151.3 127 152.2 128.8 148.7 128.8 147.8"
        />
        <path
          class="cls-2"
          d="M182.9,182.8h-.4l-.6-.5-.4-.6-.6.4a3.1,3.1,0,0,0,.7.9l1,.7a1.3,1.3,0,0,0,.8.3.8.8,0,0,0,.7-.1c.1,0,.2-.3.2-.6a1.9,1.9,0,0,0-.2-.7c0-.2-.2-.4-.4-.6s-.4-.4-.6-.6a2.3,2.3,0,0,0-.5-.5l-.3-.3a.4.4,0,0,1-.1-.3h.6l.5.4c.2.2.4.3.5.6l.4-.5-.6-.7-1-.6-.8-.3h-.6a1.1,1.1,0,0,0-.1.6,2,2,0,0,0,.1.7l.4.6.6.5.5.5.3.3v.3C183,182.8,183,182.8,182.9,182.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M186,185.3l1,1.1.7.3c.1,0,.4.1.4,0l-.3-1h-.6l-.4-.3-.2-.5v-1.9l1.1.6v-.8l-1.1-.6v-1.2l-1-.5v.9l-.8-.4v.8l.8.4V184A2.8,2.8,0,0,0,186,185.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M190.6,185.7c-.6-.4-1-.5-1.3-.4s-.5.3-.5.7a1.5,1.5,0,0,0,.4,1.1,1.8,1.8,0,0,0,.8.9l.7.3a.6.6,0,0,0,.5-.2l.3.5c.2.2.3.4.6.5l.2-.7c-.1-.1-.2-.1-.2-.2v-2a2.8,2.8,0,0,0-.4-1.3,4.9,4.9,0,0,0-1.3-1l-.6-.3h-.7l.2.9.6.2.4.2c.3.1.4.3.6.5s.1.4.1.5v.2Zm.4,1.6-.3.2h-.4l-.3-.3a.9.9,0,0,1-.1-.5c0-.2,0-.3.2-.3l.6.2.3.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M196.2,189l.2-1.5-.2-.3-.4-.2-.7-.2a1.2,1.2,0,0,0-.5.5l-.2-1-1.2-.7v.8l.4.2V189l-.4-.2v.8l2.2,1.2v-.7l-.7-.4v-1.2a.7.7,0,0,1,.4-.6h.4v.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M198,192.3l1.1,1.1.6.3c.1,0,.4.1.5,0l-.4-1h-.6l-.4-.3a1.1,1.1,0,0,1-.1-.5v-1.9l1,.6v-.8l-1.2-.6v-1.2l-1-.5v.9l-.8-.4v.8l.8.4V191A2.8,2.8,0,0,0,198,192.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M202.9,194.5l-.4-.2c-.2-.2-.4-.2-.5-.5l-.5-.5-.6.4a3,3,0,0,0,.8.8,2.2,2.2,0,0,0,.9.7,1.5,1.5,0,0,0,.9.4h.6a.8.8,0,0,0,.2-.6c0-.3-.1-.5-.1-.8s-.3-.3-.4-.6l-.7-.6c-.2-.2-.3-.4-.5-.5s-.2-.2-.2-.3v-.4l.4.2c.2,0,.3.2.6.4l.5.5.3-.5-.6-.7-.9-.6-.9-.3h-.5a.7.7,0,0,0-.2.6,1.9,1.9,0,0,0,.2.7c0,.2.2.4.4.6s.3.4.5.6l.6.5.2.3c.1,0,.1.1.1.2S203,194.5,202.9,194.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="164.5 169.7 164.2 172.8 163.9 169.8 163 169.4 162.6 172 162.4 168.5 161.4 167.9 161.9 172.3 163.1 173 163.4 170.4 163.7 173.3 164.9 174 165.4 170.2 164.5 169.7"
        />
        <path
          class="cls-2"
          d="M216.2,203.1v-3a3,3,0,0,0-.2-1,1.9,1.9,0,0,0-.8-.7l-.5-.2a.6.6,0,0,0-.5.2V196l-1-.4v5.7l1,.6v-2.8l.3-.2h.5a.5.5,0,0,1,.2.4.7.7,0,0,1,.1.5v2.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M220.4,203.5v-.2a2.8,2.8,0,0,0-.3-1.3,3.1,3.1,0,0,0-.5-1,2.8,2.8,0,0,0-.9-.7,1.3,1.3,0,0,0-.9-.3,1,1,0,0,0-.6.5,3,3,0,0,0-.2,1,5,5,0,0,0,.2,1.2,3.9,3.9,0,0,0,.6,1.1,8.7,8.7,0,0,0,1.1.9l.7.3h.7l-.4-.9h-.5l-.5-.2c-.1-.1-.3-.1-.4-.3l-.3-.5c0-.1-.1-.4-.1-.6l2.3,1.3Zm-2.4-1.8c0-.3.1-.6.2-.6h.5a1.2,1.2,0,0,1,.5.5,2.2,2.2,0,0,1,.1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M224.2,204.5a3,3,0,0,0-.2-1l-.7-.6-.7-.3-.4.2v-.6l-1-.5v4.1l1.1.6v-2.8l.2-.2h.5l.2.2c.1.1.1.1.1.2v3.1l1,.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M229.9,205.9v.9l-.8-.4v.9l.8.4v1.9a2.1,2.1,0,0,0,.3,1.3,2.4,2.4,0,0,0,1,1l.6.3c.2,0,.4.1.5,0l-.3-.9h-.3l-.4-.2a.5.5,0,0,1-.3-.3.8.8,0,0,1-.2-.5v-1.8l1,.6v-.8l-1.2-.6.2-1.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M236.3,214.7v-3a3,3,0,0,0-.2-1,1.2,1.2,0,0,0-.7-.7l-.6-.2a.6.6,0,0,0-.5.2v-2.4l-1.1-.5v5.8l1.1.6v-2.8l.2-.2h.5c.1.1.2.2.2.3a1.1,1.1,0,0,1,.1.6V214Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M238.7,211.2c.2.1.3.2.5.1a.5.5,0,0,0,.2-.4,1.4,1.4,0,0,0-.2-.6c-.2-.3-.3-.3-.5-.5s-.3-.2-.4-.1a.5.5,0,0,0-.2.4,1.4,1.4,0,0,0,.2.6A1,1,0,0,0,238.7,211.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="190 187.8 190 188.6 193 190.4 193 189.5 192.2 188.9 192.2 185.6 190.1 184.5 190.1 185.3 191.1 185.9 191.1 188.3 190 187.8"
        />
        <path
          class="cls-2"
          d="M244.3,217.3l-.4-.6-.6-.6-.6-.5-.2-.3v-.2l.2-.2.4.2.5.4.5.5.4-.5-.6-.7-1-.6-.8-.3h-.6a.7.7,0,0,0-.2.6,1.9,1.9,0,0,0,.2.7l.4.6.5.6.6.5c.2.1.2.2.2.3s.1.1.1.2-.1.2-.1.2l-.4-.2c-.3-.2-.4-.2-.6-.5s-.3-.4-.5-.5l-.5.4c.1.3.4.5.7.8a2.2,2.2,0,0,0,.9.7c.4.2.6.4.9.4h.6a.6.6,0,0,0,.3-.6A2.4,2.4,0,0,0,244.3,217.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M252.3,222a1.3,1.3,0,0,0-.4-.6c-.1-.3-.4-.4-.6-.7l-.5-.4-.3-.4c-.1,0-.1-.1-.1-.2l.2-.2.4.2.5.4.5.5.4-.4-.6-.7-1-.7-.8-.3c-.3,0-.4,0-.6.2a.7.7,0,0,0-.1.5,1.5,1.5,0,0,0,.1.7c.1.3.3.4.4.7l.6.5a2.3,2.3,0,0,0,.5.5c.2.1.2.2.2.3v.2c0,.2-.1.2-.1.2l-.4-.2-.6-.4-.4-.6-.6.4.7.9,1,.7c.3.1.5.3.8.3a.6.6,0,0,0,.6-.1.6.6,0,0,0,.3-.6A1.9,1.9,0,0,0,252.3,222Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M255.5,221.7l-.8,2.9-.7-3.7-1.1-.6L254,225l.4.2c-.1.2-.2.2-.3.3h-.3l-.5-.2v1l1,.3.6-.2a1.6,1.6,0,0,0,.4-.7l1.2-3.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M260.5,227.3a2.5,2.5,0,0,0-.2-.7c0-.2-.2-.4-.4-.6a1.7,1.7,0,0,0-.6-.6,2.3,2.3,0,0,0-.5-.5l-.3-.3v-.3a.1.1,0,0,1,.1-.1h.4l.6.4.4.6.4-.5-.6-.7a3.3,3.3,0,0,0-1-.6l-.8-.3h-.6a1.1,1.1,0,0,0-.1.6c0,.2.1.4.1.7l.4.6.6.6.5.4.3.3v.3h-.5l-.6-.5-.4-.5-.6.4.7.8,1,.7a1.3,1.3,0,0,0,.8.3h.7A1.2,1.2,0,0,0,260.5,227.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M261.9,228.1a3.2,3.2,0,0,0,.3,1.4l1,1,.7.3h.4l-.3-1h-.6l-.4-.3a.9.9,0,0,1-.1-.5V227l1,.6v-.7l-1.2-.7V225l-1-.5v.9l-.7-.4v.8l.7.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M265.2,229.9v-1.2a4.3,4.3,0,0,0-.1.5C265.1,229.4,265.2,229.7,265.2,229.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M102.4,143.4l-.4.3-.6.4-.8.5v.9l3.1,1.8v-.9l-1.9-1.2.8-.4.6-.4a1.3,1.3,0,0,0,.3-.5,1.1,1.1,0,0,0,.1-.5,2.9,2.9,0,0,0-.2-.9,4.1,4.1,0,0,0-.5-.9l-.9-.8-.9-.3a.9.9,0,0,0-.7.3l.7,1c.1-.2.2-.2.4-.3a.4.4,0,0,1,.4.2.8.8,0,0,1,.5.5,1.1,1.1,0,0,1,.2.6c0,.2,0,.2-.1.3S102.5,143.4,102.4,143.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M107.6,144.8a3.9,3.9,0,0,0-1.3-1.5c-.6-.3-1-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,8.5,8.5,0,0,0,.4,2.3,3.7,3.7,0,0,0,1.3,1.5q.8.4,1.2,0c.4-.4.4-1,.5-1.9A5.1,5.1,0,0,0,107.6,144.8Zm-1.9.8a4.9,4.9,0,0,1,.1-1.4c.1-.2.3-.3.6-.1l.4.4h0l-1.1,2.1A4,4,0,0,1,105.7,145.6Zm1.3.9a3.1,3.1,0,0,1-.1,1.1c-.1.2-.1.4-.2.5h-.4a.9.9,0,0,1-.4-.5l1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="64.7 124.5 63.9 123.9 63.9 119.5 62.9 119 61.4 119.2 61.9 120.3 62.9 120.1 62.9 123.4 61.8 122.7 61.8 123.6 64.7 125.4 64.7 124.5"
        />
        <polygon
          class="cls-2"
          points="68.7 122.3 65.5 120.5 65.5 121.4 67.6 122.6 65.8 125.8 66.9 126.7 68.7 123.1 68.7 122.3"
        />
        <polygon class="cls-2" points="72.5 127 69.7 125.3 69.7 126.3 72.5 127.9 72.5 127" />
        <path
          class="cls-2"
          d="M123.6,154a2.6,2.6,0,0,0-1.3-1.4.9.9,0,0,0-1.3,0c-.3.3-.3.9-.3,1.8a7.3,7.3,0,0,0,.3,2.2,3.9,3.9,0,0,0,1.3,1.5c.6.3.9.3,1.3,0a2.6,2.6,0,0,0,.4-1.8A8.5,8.5,0,0,0,123.6,154Zm-2,.9a2.7,2.7,0,0,1,.2-1.3c0-.3.3-.3.5-.2s.3.3.4.4v.2l-1.1,2C121.7,155.7,121.6,155.4,121.6,154.9Zm1.4.9a3.7,3.7,0,0,1-.1,1.1c0,.2-.1.4-.2.4h-.4l-.4-.4L123,155Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="80.7 129.3 77.5 127.5 77.5 128.4 79.6 129.5 77.9 132.7 78.9 133.7 80.7 130 80.7 129.3"
        />
        <polygon class="cls-2" points="84.6 134 81.7 132.2 81.7 133.2 84.6 134.9 84.6 134" />
        <polygon
          class="cls-2"
          points="88.9 138.4 88 137.8 88 133.4 87 132.9 85.6 133.1 86 134.2 87 134.1 86.9 137.3 85.8 136.7 85.8 137.5 88.9 139.2 88.9 138.4"
        />
        <polygon
          class="cls-2"
          points="92.9 140.7 92 140.2 92 135.8 91.1 135.2 89.6 135.4 90 136.5 91 136.3 91 139.6 89.8 138.9 89.8 139.9 92.9 141.6 92.9 140.7"
        />
        <polygon
          class="cls-2"
          points="100.9 145.3 100 144.8 100 140.4 99.1 139.9 97.6 140 98 141.1 99 141 99 144.2 97.8 143.6 97.8 144.5 100.9 146.2 100.9 145.3"
        />
        <path
          class="cls-2"
          d="M151.9,174.3l-1.9-1.2.8-.5.6-.4.3-.5c.1-.1.1-.4.1-.5a3.7,3.7,0,0,0-.2-.9,2.2,2.2,0,0,0-.5-.8,2,2,0,0,0-.8-.8,1.4,1.4,0,0,0-1-.3.6.6,0,0,0-.6.3l.6.9.4-.2h.5c.2.1.3.3.5.5s.1.4.1.6,0,.3-.1.4a.4.4,0,0,1-.2.3l-.4.3-.5.4-.8.4v.9l3,1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M154.9,173a1.5,1.5,0,0,0-.5-.6H154c-.2,0-.3.2-.3.4a.9.9,0,0,0,.3.7c.1.3.3.4.4.6s.4.2.5.1.2-.3.2-.5A1,1,0,0,0,154.9,173Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M154.9,175.7a1,1,0,0,0-.5-.6H154a.5.5,0,0,0-.3.5,1.1,1.1,0,0,0,.3.7c.1.3.3.4.4.6h.5c.2,0,.2-.2.2-.4A.8.8,0,0,0,154.9,175.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="112.9 151.2 112.4 150.9 112.4 149.6 111.6 149.1 111.4 150.3 110.6 149.9 111.7 147.4 110.8 146.5 109.5 149.3 109.5 150.1 111.4 151.2 111.4 152.4 112.4 152.9 112.4 151.8 112.9 152.1 112.9 151.2"
        />
        <polygon
          class="cls-2"
          points="116.9 154.6 116 154.1 116 149.7 115.1 149.2 113.6 149.3 114.1 150.4 115 150.3 115 153.5 113.9 152.8 113.9 153.8 116.9 155.5 116.9 154.6"
        />
        <path
          class="cls-2"
          d="M166.9,179.9c0-.2-.3-.4-.4-.5s-.4-.2-.5-.1-.2.2-.2.5a1.1,1.1,0,0,0,.2.7l.5.5h.4a.5.5,0,0,0,.3-.5A1.3,1.3,0,0,0,166.9,179.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M166.9,182.6l-.4-.6H166c-.2,0-.2.2-.2.4a.8.8,0,0,0,.2.7c.1.3.3.4.5.6h.4a.5.5,0,0,0,.3-.5A1.1,1.1,0,0,0,166.9,182.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M171.7,181.9a3.1,3.1,0,0,0-1.2-1.5c-.6-.3-1-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,7.9,7.9,0,0,0,.4,2.3,3.2,3.2,0,0,0,1.3,1.5q.8.5,1.2,0a2.8,2.8,0,0,0,.4-1.8A5.3,5.3,0,0,0,171.7,181.9Zm-1.9.8a3.8,3.8,0,0,1,.1-1.3c.1-.2.3-.3.6-.1l.4.3v.2l-1.1,2Zm1.4.9a3.1,3.1,0,0,1-.1,1.1l-.2.5a.3.3,0,0,1-.4,0c-.2-.2-.4-.3-.4-.5l1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="128.8 157.1 125.7 155.3 125.7 156.2 127.7 157.3 126 160.6 127 161.5 128.8 157.9 128.8 157.1"
        />
        <path
          class="cls-2"
          d="M202.5,200h.6l.4.4c.2.2.4.4.4.6l.6-.5-.6-.8c-.4-.1-.6-.4-.9-.5a1.7,1.7,0,0,0-1.1-.3.9.9,0,0,0-.8.4,2.9,2.9,0,0,0-.3,1.4,8.8,8.8,0,0,0,.2,1.7,4.7,4.7,0,0,0,.8,1.4,5.2,5.2,0,0,0,1.1,1,1.9,1.9,0,0,0,1,.3.7.7,0,0,0,.6-.2l-.5-1h-.4l-.5-.2c-.3-.1-.4-.3-.6-.5s-.3-.5-.4-.8a3.7,3.7,0,0,1-.1-1.1,2.5,2.5,0,0,1,.1-1C202.2,200.1,202.4,200,202.5,200Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M206.6,204.2c.2.2.4.2.5.1a.6.6,0,0,0,.2-.5,1.9,1.9,0,0,0-.2-.7c-.2-.2-.3-.4-.5-.5s-.4-.2-.5-.1a.6.6,0,0,0-.2.5,2.5,2.5,0,0,0,.2.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M206.1,206.3l.5.6h.5a.8.8,0,0,0,.2-.5,1.9,1.9,0,0,0-.2-.7l-.5-.6h-.5c-.1,0-.2.2-.2.4A1.4,1.4,0,0,0,206.1,206.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="162.4 175.5 161.6 175.5 164.4 183.8 165.2 183.8 162.4 175.5"
        />
        <path
          class="cls-2"
          d="M216.3,212.3V207l-1-.6v2.9a1.9,1.9,0,0,0,.1.8c0,.2.1.5.1.6l-1.2-4.9L213,205v5.3l.9.6v-3.4a.7.7,0,0,0-.1-.5v-.2l1.1,4.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M220.3,212.7v-.2a2.8,2.8,0,0,0-.3-1.3,3.1,3.1,0,0,0-.5-1,2.2,2.2,0,0,0-.9-.7,1.3,1.3,0,0,0-.9-.3,1,1,0,0,0-.6.5,3,3,0,0,0-.2,1,5,5,0,0,0,.2,1.2,2.6,2.6,0,0,0,.7,1.1l1,.9c.3.1.5.3.8.3h.6l-.4-.9h-.5l-.4-.2c-.2-.1-.4-.1-.4-.3s-.3-.3-.3-.5a1.1,1.1,0,0,1-.2-.6l2.3,1.3Zm-2.3-1.8c0-.3.1-.6.2-.6a.4.4,0,0,1,.5,0,1.2,1.2,0,0,1,.5.5,2.2,2.2,0,0,1,.1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M223.9,215.9h-.3c-.1,0-.3-.1-.3-.2l-.4-.3c-.1-.2-.2-.3-.2-.5V213l1,.6v-.7l-1.2-.7.2-1.2-1-.5v.9l-.8-.4v.8l.8.4v1.9a2.2,2.2,0,0,0,.3,1.4,2.4,2.4,0,0,0,1,1l.6.3h.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M226.2,217.9a2,2,0,0,0,.9.9l.6.3h.5l-.2-1h-.5l-.3-.3-.2-.4v-4.5l-2.1-1.2v.9l1,.6v3.5A2.2,2.2,0,0,0,226.2,217.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M230.6,214.4h-.4c-.2,0-.2.1-.2.4l.2.6c0,.2.2.3.4.5h.5c.2,0,.2-.2.2-.4l-.2-.6A1.2,1.2,0,0,0,230.6,214.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="184.9 194.1 184.1 193.6 184.1 190.3 182 189.1 182 190 183 190.5 183 193 182 192.4 182 193.3 184.9 195 184.9 194.1"
        />
        <path
          class="cls-2"
          d="M235.1,218.3h.5l.4.3.4.3.3-.6-.6-.5-.7-.4-.8-.3-.4.2a1.4,1.4,0,0,0-.2.7v.5l-.8-.4v.9l.8.4v3l1,.6v-3l1.1.6v-.8l-1.1-.7v-.5C235,218.4,235,218.4,235.1,218.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M237.7,225.5h-.5v.9l1,.3.6-.2.4-.6,1.2-3.6-1.1-.6-.8,2.9-.7-3.7-1.1-.6,1.1,4.7.4.2-.3.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="194.5 194.1 193.7 194.1 196.5 202.4 197.3 202.4 194.5 194.1"
        />
        <path
          class="cls-2"
          d="M248.4,225.5l-.9-.5v3.7c0,.2.1.4.1.6l-1.2-5-1.3-.7v5.3l.9.6v-4h0l1.1,4.7,1.3.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M252.4,231.3V231a5,5,0,0,0-.2-1.2,6,6,0,0,0-.6-1.1l-.8-.7a1.4,1.4,0,0,0-1-.2c-.2.1-.5.2-.5.5a1.2,1.2,0,0,0-.3.9,3.1,3.1,0,0,0,.3,1.3,2.4,2.4,0,0,0,.6,1.1,3.9,3.9,0,0,0,1,.8l.8.4h.6l-.4-1H251l-.4-.3c-.2-.2-.2-.4-.3-.5a1.4,1.4,0,0,1-.2-.6l2.3,1.3Zm-2.4-1.8c0-.4.1-.6.3-.7s.2-.1.5,0a1.3,1.3,0,0,1,.4.6,1.5,1.5,0,0,1,.2.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M256,234.4h-.6l-.4-.4a.8.8,0,0,1-.2-.4v-1.9l1.1.6v-.8l-1.1-.6v-1.3l-1-.4v.8l-.7-.4v.9l.7.4v1.9a3.1,3.1,0,0,0,.3,1.3,3.2,3.2,0,0,0,1,1l.7.4h.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M260.1,236.8c-.1,0-.2,0-.2-.1l-.3-.2q-.2,0-.3-.3c-.1-.1-.1-.2-.1-.4v-4.5l-2.1-1.1v.8l1,.7v3.4a3.2,3.2,0,0,0,.3,1.4,2.6,2.6,0,0,0,.9.9,1,1,0,0,0,.7.2h.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M262.8,234.4c.1.1.3.2.4.1a.5.5,0,0,0,.2-.4,1.4,1.4,0,0,0-.2-.6,1.1,1.1,0,0,0-.4-.5c-.2-.1-.3-.2-.5-.1a.5.5,0,0,0-.2.4,1.4,1.4,0,0,0,.2.6C262.5,234.2,262.5,234.3,262.8,234.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="214.1 210.9 214.1 211.7 217.1 213.5 217.1 212.6 216.2 212.1 216.2 208.8 214.2 207.6 214.2 208.4 215.1 209 215.1 211.4 214.1 210.9"
        />
        <path
          class="cls-2"
          d="M101.5,150.8a.6.6,0,0,1,.5.2,1.1,1.1,0,0,1,.4.5.8.8,0,0,1,.2.6.4.4,0,0,1-.1.3l-.2.3-.4.3-.6.4-.8.5v.9l3.1,1.8.2-.9-2-1.2.9-.5.5-.3a.9.9,0,0,0,.3-.5,1.3,1.3,0,0,0,.1-.6c0-.2-.1-.5-.1-.8l-.6-.9a2.4,2.4,0,0,0-.9-.8l-.9-.3a.7.7,0,0,0-.6.3l.6,1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M106.3,152.6c-.6-.4-1-.4-1.3,0a2.6,2.6,0,0,0-.4,1.8,7.2,7.2,0,0,0,.4,2.2,2.8,2.8,0,0,0,1.3,1.5q.8.5,1.2,0c.4-.3.4-.9.5-1.8a5.9,5.9,0,0,0-.4-2.3A3.6,3.6,0,0,0,106.3,152.6Zm-.7,2.3c0-.7.1-1.2.1-1.4a.4.4,0,0,1,.6-.2l.4.4c0,.1.1.1.1.2l-1.2,2.1A4,4,0,0,1,105.6,154.9Zm1.3.9a3.7,3.7,0,0,1-.1,1.1c0,.2-.1.4-.2.4h-.4l-.4-.4,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="61.7 131.9 61.7 132.9 64.7 134.6 64.7 133.7 63.9 133.2 63.9 128.8 62.9 128.2 61.4 128.4 61.9 129.5 62.9 129.3 62.9 132.6 61.7 131.9"
        />
        <polygon
          class="cls-2"
          points="66.8 135.9 68.6 132.3 68.6 131.5 65.5 129.7 65.5 130.6 67.6 131.8 65.8 135 66.8 135.9"
        />
        <polygon class="cls-2" points="69.6 135.5 72.5 137.2 72.5 136.2 69.6 134.5 69.6 135.5" />
        <path
          class="cls-2"
          d="M122.3,161.8a.9.9,0,0,0-1.3,0c-.3.3-.3.9-.3,1.8a7.3,7.3,0,0,0,.3,2.2,3.9,3.9,0,0,0,1.3,1.5c.6.3.9.3,1.3,0a2.6,2.6,0,0,0,.4-1.8,8.5,8.5,0,0,0-.4-2.3A3.5,3.5,0,0,0,122.3,161.8Zm-.7,2.4a2.7,2.7,0,0,1,.2-1.3.3.3,0,0,1,.5-.2l.4.4h.1l-1.1,2.1C121.7,165,121.6,164.7,121.6,164.2Zm1.3.9v1.1l-.3.4h-.4l-.4-.4,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="78.9 142.9 80.7 139.3 80.7 138.5 77.5 136.7 77.5 137.6 79.6 138.8 77.9 141.9 78.9 142.9"
        />
        <polygon class="cls-2" points="81.6 142.5 84.5 144.1 84.5 143.2 81.6 141.5 81.6 142.5" />
        <polygon
          class="cls-2"
          points="85.8 145.9 85.8 146.8 88.8 148.5 88.8 147.6 87.9 147.1 87.9 142.7 87 142.2 85.5 142.3 86 143.4 86.9 143.3 86.9 146.5 85.8 145.9"
        />
        <polygon
          class="cls-2"
          points="89.8 148.1 89.8 149.1 92.8 150.8 92.8 149.9 91.9 149.4 91.9 145 91.1 144.4 89.6 144.7 90 145.8 90.9 145.6 90.9 148.8 89.8 148.1"
        />
        <polygon
          class="cls-2"
          points="97.8 152.8 97.8 153.7 100.8 155.4 100.8 154.6 99.9 154 100 149.6 99.1 149.1 97.6 149.3 98 150.3 98.9 150.3 98.9 153.5 97.8 152.8"
        />
        <path
          class="cls-2"
          d="M150.4,180.5l-.4.4-.5.4-.8.4v.9l3.1,1.8v-.9l-1.9-1.1.8-.5.6-.4a1.3,1.3,0,0,0,.3-.5c.1-.1.1-.4.1-.5a2.9,2.9,0,0,0-.2-.9c0-.3-.3-.5-.5-.9a1,1,0,0,0-.8-.7,1.6,1.6,0,0,0-.9-.4.8.8,0,0,0-.7.4l.7.9c.1-.2.2-.2.3-.2h.5c.3.1.3.3.5.5s.1.4.1.6v.3C150.6,180.3,150.6,180.5,150.4,180.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M154.8,182.2c0-.2-.2-.4-.4-.6h-.5c-.2,0-.2.2-.2.4a.8.8,0,0,0,.2.7c.1.3.3.4.5.6h.4a.5.5,0,0,0,.3-.5A1.1,1.1,0,0,0,154.8,182.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M154.4,184.3h-.5c-.2.1-.2.3-.2.5a1,1,0,0,0,.2.7c.1.3.3.4.5.6h.4c.2,0,.3-.2.3-.4a.9.9,0,0,0-.3-.7C154.8,184.6,154.6,184.5,154.4,184.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="112.4 162.1 112.4 161 112.9 161.3 112.9 160.4 112.4 160.2 112.4 158.8 111.6 158.4 111.4 159.5 110.6 159.1 111.7 156.6 110.8 155.8 109.5 158.5 109.5 159.4 111.4 160.5 111.4 161.6 112.4 162.1"
        />
        <polygon
          class="cls-2"
          points="113.8 162.1 113.8 163 116.9 164.7 116.9 163.9 116 163.3 116 158.9 115.1 158.4 113.6 158.6 114.1 159.6 115 159.5 115 162.8 113.8 162.1"
        />
        <path
          class="cls-2"
          d="M166.5,191.3H166c-.2.1-.2.3-.2.5a1,1,0,0,0,.2.7c.1.3.3.4.5.6h.4c.2,0,.3-.2.3-.4a.9.9,0,0,0-.3-.7A1.5,1.5,0,0,0,166.5,191.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M166.9,189.2a1.5,1.5,0,0,0-.4-.6H166c-.2,0-.2.2-.2.4a.8.8,0,0,0,.2.7c.1.3.3.4.5.6h.4a.5.5,0,0,0,.3-.5A1.1,1.1,0,0,0,166.9,189.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M170.5,189.6c-.6-.3-1-.3-1.3,0a2.6,2.6,0,0,0-.4,1.8,7.9,7.9,0,0,0,.4,2.3,3.2,3.2,0,0,0,1.3,1.5q.8.5,1.2,0a2.8,2.8,0,0,0,.4-1.8,5.3,5.3,0,0,0-.4-2.3A3.6,3.6,0,0,0,170.5,189.6Zm-.8,2.4a10.9,10.9,0,0,1,.1-1.3.4.4,0,0,1,.6-.2l.4.4v.2l-1.1,2C169.8,192.8,169.7,192.5,169.7,192Zm1.4.9a3.1,3.1,0,0,1-.1,1.1c-.1.2-.1.4-.2.5h-.4l-.4-.5,1.1-1.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="127 170.7 128.8 167.1 128.8 166.3 125.7 164.5 125.7 165.4 127.7 166.6 126 169.8 127 170.7"
        />
        <path
          class="cls-2"
          d="M203,213.7l1,.7v-3a4.3,4.3,0,0,0-.2-1.1l-.7-.6-.7-.2H202v-.5l-1-.6v4.1l1.1.7v-2.9h.9a.4.4,0,0,1,.1.3v3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M208.3,215v-.2a2.8,2.8,0,0,0-.3-1.3,3.1,3.1,0,0,0-.5-1,2.8,2.8,0,0,0-.9-.7q-.6-.5-.9-.3a1,1,0,0,0-.6.5,2,2,0,0,0-.2.9,5.9,5.9,0,0,0,.2,1.3,3.9,3.9,0,0,0,.6,1.1l1.1.9.7.3h.7l-.4-.9h-.5l-.5-.2-.4-.3-.3-.5c0-.1-.1-.4-.1-.6l2.3,1.3Zm-2.4-1.8a1.2,1.2,0,0,1,.2-.7h.5l.5.6a1.9,1.9,0,0,1,.1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M210.1,217.7a3.3,3.3,0,0,0,1,1.1l.6.3h.5l-.3-1h-.7l-.4-.3a4.3,4.3,0,0,0-.1-.5v-1.9l1,.6v-.8l-1.2-.6.2-1.2-1.1-.5v.8l-.7-.3v.8l.7.4v1.9A2,2,0,0,0,210.1,217.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M218.9,222.2h-.4l-.5-.5-.5-.6-.5.4a2.8,2.8,0,0,0,.7.9,3.5,3.5,0,0,0,.9.7l.9.3a.6.6,0,0,0,.6-.1c.2,0,.3-.3.3-.6a1.9,1.9,0,0,0-.2-.7,2.1,2.1,0,0,0-.4-.6l-.6-.7-.6-.4-.2-.3a.4.4,0,0,1-.1-.3h.6l.5.4.5.6.4-.5a4.6,4.6,0,0,0-.7-.7,4.7,4.7,0,0,0-.9-.6,1.8,1.8,0,0,0-.9-.4c-.2,0-.4,0-.5.2s-.2.3-.2.6a2.5,2.5,0,0,0,.2.7,2.1,2.1,0,0,0,.4.6l.5.5.6.5c.1.2.2.2.2.3a.4.4,0,0,1,.1.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M222.1,224.7a2.4,2.4,0,0,0,1,1l.6.3h.5l-.3-.9h-.3l-.3-.2-.4-.3c-.1-.2-.2-.3-.2-.5v-1.9l1,.6v-.7l-1.2-.7.2-1.2-1-.5v.9l-.8-.4v.8l.8.4v1.9A2.2,2.2,0,0,0,222.1,224.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M226.6,225c-.5-.3-.9-.5-1.2-.4s-.5.3-.5.8a2.1,2.1,0,0,0,1.2,1.9l.6.3a.7.7,0,0,0,.6-.2c0,.2.2.4.3.6l.5.4.3-.7-.2-.2c0-.1-.1-.2-.1-.4v-1.6a1.9,1.9,0,0,0-.4-1.2l-1.2-1.1-.7-.3h-.7l.3.9.5.2.5.2.5.5c.2.1.2.4.2.5v.2Zm.4,1.6c-.1.1-.1.2-.3.2h-.3l-.3-.3c-.1-.2-.2-.3-.2-.5a.3.3,0,0,1,.3-.3l.6.2.2.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M232.2,228.3l.2-1.6a.2.2,0,0,0-.2-.2l-.4-.2c-.3-.1-.5-.2-.7-.1a.7.7,0,0,0-.5.4v-1l-1.3-.7v.8l.5.2v2.5l-.5-.3v.8l2.2,1.3v-.8l-.7-.4v-1.2a1.5,1.5,0,0,1,.4-.6h.5v.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M234.1,231.7a3.1,3.1,0,0,0,1,1l.6.3h.5l-.3-1h-.6l-.4-.3c-.1-.2-.2-.3-.2-.5v-1.9l1,.6v-.7l-1.2-.7.2-1.2-1-.5v.9l-.8-.4v.8l.8.4v1.9A3.2,3.2,0,0,0,234.1,231.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M244.3,237.8v-5.4l-.9-.5v3.7c0,.2.1.5.1.6l-1.2-4.9-1.3-.8v5.3l1,.6V233a1.3,1.3,0,0,0-.1-.6h0L243,237Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M248.4,238.2v-.3a5,5,0,0,0-.2-1.2l-.6-1a1.6,1.6,0,0,0-.9-.7.9.9,0,0,0-.9-.3c-.2.1-.5.3-.5.5a1.2,1.2,0,0,0-.3.9,3.1,3.1,0,0,0,.3,1.3,2.4,2.4,0,0,0,.6,1.1l1,.9.8.3h.6l-.4-.9h-.4l-.5-.2-.4-.3-.3-.5a1.1,1.1,0,0,1-.2-.6l2.3,1.3Zm-2.4-1.8a.8.8,0,0,1,.3-.7h.4a1.3,1.3,0,0,1,.5.6,1.9,1.9,0,0,1,.2.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M250.2,240.9a5,5,0,0,0,1,1.1l.7.3h.4l-.3-1h-.6l-.4-.3-.2-.5v-1.9l1.1.6v-.8l-1.1-.6v-1.2l-1-.5v.8l-.7-.3v.8l.7.4v1.9A2.8,2.8,0,0,0,250.2,240.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M254.2,243.4a2.2,2.2,0,0,0,1,.9.7.7,0,0,0,.6.3h.5l-.3-.9h-.5l-.3-.4a1,1,0,0,1-.1-.4v-4.4l-2.1-1.2v.8l1,.7V242A3.2,3.2,0,0,0,254.2,243.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="210 217.8 210 218.7 213 220.4 213 219.5 212.1 219 212.1 215.7 210.1 214.5 210.1 215.4 211 215.9 211 218.4 210 217.8"
        />
        <path
          class="cls-2"
          d="M258.7,241.2a.4.4,0,0,0,.5.1c0-.1.1-.2.1-.4s-.1-.4-.1-.6-.3-.3-.5-.5-.3-.1-.5,0-.1.1-.1.3a2,2,0,0,0,.1.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M263.2,243.8h.5l.4.3c.2,0,.2.2.4.3l.3-.7-.5-.4-.8-.4-.8-.3c-.2,0-.4,0-.5.2a1.3,1.3,0,0,0-.1.6v.6l-.8-.4v.9l.8.3v3l1,.7v-3l1,.6.2-.8-1.2-.7v-.5A.6.6,0,0,1,263.2,243.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon class="cls-2" points="218 219.2 217.7 219 218 220.3 218 219.2" />
      </g>
      <g class="bblock" id="Block_2" data-name="Block 2">
        <polygon class="cls-2" points="159.9 58.3 161.7 59.3 165.8 56.8 164 55.8 159.9 58.3" />
        <path
          class="cls-2"
          d="M212.8,88.3a1.5,1.5,0,0,1,.8.8l4.1-2.6-.3-.5-3.3-1.9L210,86.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M219.1,86.6a2.2,2.2,0,0,0-1.1-1.8l-6.2-3.6a2.1,2.1,0,0,0-1.1,0l-4.9,3.2q-.3.1-.3.3c-.5.1-.6.6-.6,1v3.9a2,2,0,0,0,1,1.8l6.3,3.6c.1.2.4.2.6.2a.4.4,0,0,0,.4-.2h.3l5-3v-.2l.2-.3a3,3,0,0,0,.3-.9Zm-1.7-.6.3.5-4.1,2.6a1.5,1.5,0,0,0-.8-.8L210,86.7l4.1-2.6Zm-3.5,6.8-.5-.9,4.3-2.6.5.9Zm-5-6.8-1.8-1,4.1-2.6,1.8,1.1Zm-2.7-.1,6,3.4a1.9,1.9,0,0,1,.3.8v3.7l-6-3.4a1.9,1.9,0,0,1-.3-.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-3"
          d="M212.5,93.8V90.1a1.9,1.9,0,0,0-.3-.8l-6-3.4v3.7a1.9,1.9,0,0,0,.3.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon class="cls-3" points="171 63.5 170.5 62.6 166.2 65.2 166.7 66.1 171 63.5" />
      </g>
      <g class="bblock" id="Block_3" data-name="Block 3">
        <path
          class="cls-1"
          d="M262.4,110.7,225.9,89.5a.9.9,0,0,0-1,0L220,92.6a.9.9,0,0,0-.4,1c-.1.1-.1.2-.1.4v3.9a2,2,0,0,0,1.1,1.7l36.1,21.2h1.4l4.9-3.2h.2a2.2,2.2,0,0,0,.3-.9h0v-4.1A2.2,2.2,0,0,0,262.4,110.7Zm-4,7.8-.5-.9,4.3-2.6.6.9ZM225.5,90.2c.2-.1.3-.1.4,0l36.2,21.1a1.1,1.1,0,0,1,.6,1h-.4l-4.2,2.5a1.4,1.4,0,0,0-.8-.9L221.2,92.9Zm-4.8,7.7V94.1l35.9,21a1.1,1.1,0,0,1,.3.7v3.8L221,98.6A1.1,1.1,0,0,1,220.7,97.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M257.3,114a1.4,1.4,0,0,1,.8.9l4.2-2.5h.4a1.1,1.1,0,0,0-.6-1L225.9,90.2c-.1-.1-.2-.1-.4,0l-4.3,2.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-3"
          d="M256.9,119.6v-3.8a1.1,1.1,0,0,0-.3-.7l-35.9-21v3.8a1.1,1.1,0,0,0,.3.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon class="cls-3" points="210.7 91 211.2 91.9 215.6 89.2 215 88.3 210.7 91" />
      </g>
      <g class="bblock" id="Block_4" data-name="Block 4">
        <path
          class="cls-2"
          d="M290.1,196.7l-3.8,2.4.5.3a2.9,2.9,0,0,1,1.2,1.8l4-2.3a2.3,2.3,0,0,0-.7-1.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-2"
          points="239.2 167.8 235.3 170.1 237.9 171.7 241.7 169.3 239.3 167.8 239.2 167.8"
        />
        <path
          class="cls-1"
          d="M291.9,196.4l-4.8-3a1.4,1.4,0,0,0-1.5,0l-4.9,2.9a.8.8,0,0,0-.4.6,1.9,1.9,0,0,0-.3,1v19.3a3.4,3.4,0,0,0,1.3,2.7l4.8,3a1,1,0,0,0,.7.2l.6-.2h.5l4.9-3a1.4,1.4,0,0,0,.6-1.4V199.1A3.6,3.6,0,0,0,291.9,196.4Zm-3.6,20-.6-.9,4.4-2.6.5.9Zm-.3-15.2a2.9,2.9,0,0,0-1.2-1.8l-.5-.3,3.8-2.4,1.2.8a2.3,2.3,0,0,1,.7,1.4Zm-2.9-2.8-2.6-1.7,3.9-2.2h.1l2.4,1.5Zm-3.9-.6v-.3h.1l4.8,3a2.6,2.6,0,0,1,.7,1.6v19.3c0,.3,0,.3-.1.3l-4.8-3a2.6,2.6,0,0,1-.7-1.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-3"
          d="M286.7,221.7c.1,0,.1,0,.1-.3V202.1a2.6,2.6,0,0,0-.7-1.6l-4.8-3h-.1v19.6a2.6,2.6,0,0,0,.7,1.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-3"
          points="244.9 186.2 240.5 188.8 241.1 189.7 245.4 187.1 244.9 186.2"
        />
      </g>
      <g class="bblock" id="Block_5" data-name="Block 5">
        <polygon class="cls-2" points="44.7 20.1 40.8 22.4 43.4 24 47.2 21.6 44.8 20.1 44.7 20.1" />
        <path
          class="cls-2"
          d="M95.6,49l-3.8,2.4.5.3a3.1,3.1,0,0,1,1.2,1.7l4-2.4a2,2,0,0,0-.7-1.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M97.3,48.9l-4.8-3a1.4,1.4,0,0,0-1.5,0l-4.9,2.8a1,1,0,0,0-.5.8,1.7,1.7,0,0,0-.1.7V61.8a3.7,3.7,0,0,0,1.3,2.7l4.8,2.9a1,1,0,0,0,.7.2c.3,0,.5,0,.6-.2h.3l5-2.9a1.7,1.7,0,0,0,.6-1.4V51.6A3.5,3.5,0,0,0,97.3,48.9Zm-3.6,12-.5-.9,4.4-2.6.5.9Zm-.2-7.5a3.1,3.1,0,0,0-1.2-1.7l-.5-.3L95.6,49l1.2.8a2,2,0,0,1,.7,1.2Zm-2.9-2.7L88,49l3.9-2.2H92l2.4,1.5Zm-3.9-.6v-.3h.1l4.8,3a2.6,2.6,0,0,1,.7,1.6V66c0,.2,0,.2-.1.2l-4.8-2.9a2.9,2.9,0,0,1-.7-1.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-3"
          d="M92.2,66.2c.1,0,.1,0,.1-.2V54.4a2.6,2.6,0,0,0-.7-1.6l-4.8-3h-.1V61.6a2.9,2.9,0,0,0,.7,1.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon class="cls-3" points="50.4 30.7 46 33.3 46.6 34.2 50.9 31.6 50.4 30.7" />
      </g>
    </g>
    <g id="LadyCorner">
      <g id="Keyboard">
        <path
          class="cls-3"
          d="M277,246.5c0-.2-.3-.3-.3-.3L258.9,236h-1a2.1,2.1,0,0,0-1.4.4l-4.9,2.8c-.3.2-.5.3-.5.5l.3.3,17.8,10a2.9,2.9,0,0,0,2.4-.1l4.9-2.9C276.8,246.8,277,246.6,277,246.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M276.8,245.3l-17.7-10.2a3.8,3.8,0,0,0-3.3.2l-5,2.8a1.6,1.6,0,0,0-.9,1.3,1.4,1.4,0,0,0,.8,1.2l17.8,10.1a2,2,0,0,0,1.5.4,3.7,3.7,0,0,0,1.8-.4l4.9-2.9a1.6,1.6,0,0,0,.9-1.3A1.4,1.4,0,0,0,276.8,245.3Zm-7.6,4.6-17.8-10-.3-.3c0-.2.2-.3.5-.5l4.9-2.8a2.1,2.1,0,0,1,1.4-.4h1l17.8,10.2s.3.1.3.3-.2.3-.5.4l-4.9,2.9A2.9,2.9,0,0,1,269.2,249.9Z"
          transform="translate(-47.2 -26.7)"
        />
      </g>
      <g class="bblock" id="Bubble_1" data-name="Bubble 1">
        <g>
          <path
            class="cls-3"
            d="M277.8,216.3,261,206.6h-1a1.7,1.7,0,0,0-.4,1.1v14.2a4.2,4.2,0,0,0,.4,1.5,3.6,3.6,0,0,0,1,1.1l10.4,6,2.8,1.8,3.5,2.1a1.1,1.1,0,0,0,1,0,1.7,1.7,0,0,0,.4-1.1V219.1A2.8,2.8,0,0,0,277.8,216.3Z"
            transform="translate(-47.2 -26.7)"
          />
          <path
            class="cls-2"
            d="M278.3,215.4l-16.8-9.7h0a2,2,0,0,0-2,.1,2.1,2.1,0,0,0-.9,1.9v14.2a3.6,3.6,0,0,0,.6,2,2.6,2.6,0,0,0,1.3,1.4l10.4,6.1,2.8,1.8,3.5,2,1,.3a2,2,0,0,0,1.1-.3,2.3,2.3,0,0,0,.8-1.9V219.1A3.9,3.9,0,0,0,278.3,215.4Zm.8,3.7v14.2a1.7,1.7,0,0,1-.4,1.1,1.1,1.1,0,0,1-1,0l-3.5-2.1-2.8-1.8-10.4-6a3.6,3.6,0,0,1-1-1.1,4.2,4.2,0,0,1-.4-1.5V207.7a1.7,1.7,0,0,1,.4-1.1h1l16.8,9.7A2.8,2.8,0,0,1,279.1,219.1Z"
            transform="translate(-47.2 -26.7)"
          />
        </g>
        <g>
          <path
            class="cls-2"
            d="M265.5,213.4a1.4,1.4,0,0,0-.2.9v2h0c0,.4-.1.7-.4.7a1.9,1.9,0,0,1-1-.4v1.3a4.5,4.5,0,0,1,1,.9,1.4,1.4,0,0,1,.4,1v2a3.7,3.7,0,0,0,.2,1.2,6.1,6.1,0,0,0,.7,1l1.4,1v-1.3a1.9,1.9,0,0,1-.8-.7,1.4,1.4,0,0,1-.2-.7v-1.9h0a2.6,2.6,0,0,0-1.3-2.1h0c.8.3,1.2,0,1.3-.7v-1.9a.8.8,0,0,1,.2-.6,1.1,1.1,0,0,1,.8.3V214a3.3,3.3,0,0,0-1.4-.6C265.9,213.2,265.7,213.2,265.5,213.4Z"
            transform="translate(-47.2 -26.7)"
          />
          <path
            class="cls-2"
            d="M273.4,221.9a2.1,2.1,0,0,1-.4-1.1h0v-2a2.5,2.5,0,0,0-.5-1.7,5.2,5.2,0,0,0-1.9-1.4v1.2a3,3,0,0,1,.8.7,1.2,1.2,0,0,1,.2.8v1.9a2.7,2.7,0,0,0,1.3,2.1h0a1.5,1.5,0,0,0-.9-.1c-.2.1-.3.4-.3.8h0v1.9c0,.3-.1.5-.2.5s-.4,0-.8-.2v1.3c.9.4,1.5.7,1.9.6s.5-.5.5-1.1v-2a.7.7,0,0,1,.4-.7,1.9,1.9,0,0,1,1,.4v-1.3A2.4,2.4,0,0,1,273.4,221.9Z"
            transform="translate(-47.2 -26.7)"
          />
        </g>
      </g>
      <g class="bblock" id="Bubble_2" data-name="Bubble 2">
        <g>
          <path
            class="cls-3"
            d="M266.8,187.7l-13.9-7.9h0l-.5-.2-.3.2a1,1,0,0,0-.4.8v11.8a3.3,3.3,0,0,0,.4,1.3,1.5,1.5,0,0,0,.8.8l8.6,5,2.3,1.5,2.9,1.7a.8.8,0,0,0,.8,0,1,1,0,0,0,.4-.8V190.1A2.8,2.8,0,0,0,266.8,187.7Z"
            transform="translate(-47.2 -26.7)"
          />
          <path
            class="cls-2"
            d="M267.3,186.9l-13.9-8h0a1.8,1.8,0,0,0-1.9,0,2.1,2.1,0,0,0-.8,1.7v11.8a4.1,4.1,0,0,0,.5,1.8,3.4,3.4,0,0,0,1.2,1.2l8.6,5,2.3,1.5,2.9,1.7a1.8,1.8,0,0,0,1,.2l.9-.3a1.8,1.8,0,0,0,.8-1.6V190.1A3.4,3.4,0,0,0,267.3,186.9Zm.6,3.2v11.8a1,1,0,0,1-.4.8.8.8,0,0,1-.8,0l-2.9-1.7-2.3-1.5-8.6-5a1.5,1.5,0,0,1-.8-.8,3.3,3.3,0,0,1-.4-1.3V180.6a1,1,0,0,1,.4-.8l.3-.2.5.2h0l13.9,7.9A2.8,2.8,0,0,1,267.9,190.1Z"
            transform="translate(-47.2 -26.7)"
          />
        </g>
        <g>
          <path
            class="cls-2"
            d="M253,188l4.3,4.7v-1.1l-3-3.2h3v-1.2H253Z"
            transform="translate(-47.2 -26.7)"
          />
          <path
            class="cls-2"
            d="M257.7,194l1.3.7,2.4-5.9-1.2-.8Z"
            transform="translate(-47.2 -26.7)"
          />
          <path
            class="cls-2"
            d="M261.8,189.9v1.2l3,3.3-3-.3v1.2l4.4.3v-.7Z"
            transform="translate(-47.2 -26.7)"
          />
        </g>
      </g>
      <g id="Shadow_1" data-name="Shadow 1">
        <path class="cls-1" d="M252.5,298.5h1.3l19.5,11.2v.7Z" transform="translate(-47.2 -26.7)" />
        <path
          class="cls-1"
          d="M249.3,298.8l1.2-.2,22.6,13a2.6,2.6,0,0,1-.3.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M246.5,299.4a4.5,4.5,0,0,1,1.1-.3l24.6,14.2-.4.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M244.1,300.1l.9-.3,26.2,15.1-.6.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M241.9,301a3.2,3.2,0,0,1,.9-.3l26.9,15.6-.6.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M240.5,301.8h0l27.2,15.7a1.1,1.1,0,0,1-.7.3l-27.2-15.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M238.3,303.4l.6-.4,26.9,15.5a1.6,1.6,0,0,1-.9.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M236.9,304.7c.2-.1.3-.3.5-.6l26.1,15.2a3.2,3.2,0,0,0-.9.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M235.7,306.2c.2-.1.3-.4.5-.6L261,319.9h-1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M235.1,308c0-.3.2-.4.2-.7l22.7,13-1.2.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M235,309.4l19.6,11.2h-1.5L235,310.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M235.7,312.8a8.3,8.3,0,0,1-.4-1.2l15.2,8.9-1.9-.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M261.5,299.2l3.1.9,5.8,3.4,1.7,1.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M258.2,298.6l14.8,8.5a9.7,9.7,0,0,0,.3,1.1l-16.9-9.7Z"
          transform="translate(-47.2 -26.7)"
        />
      </g>
      <g id="Shadow_2" data-name="Shadow 2">
        <polygon class="cls-1" points="151.9 305.5 131.6 293.8 131 294.3 151.2 305.9 151.9 305.5" />
        <path
          class="cls-1"
          d="M201.2,331.1l9.1,5.2h1.1l-23.5-13.6a1.5,1.5,0,0,0,.2.9l-7.1-4.1-.7.5,20.2,11.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-1"
          points="145.8 309.1 125.6 297.4 124.9 297.7 140.9 307 140.3 307.3 160.4 319 161.2 318.7 145.2 309.4 145.8 309.1"
        />
        <polygon
          class="cls-1"
          points="143.9 310.3 123.5 298.4 122.9 298.9 138.8 308.2 138.2 308.5 158.5 320.2 159.1 319.9 143.3 310.6 143.9 310.3"
        />
        <path
          class="cls-1"
          d="M189.1,338.1l-20.2-11.6a.5.5,0,0,0-.4.6l15.5,9-.6.2,20.4,11.9.7-.5-16.1-9.3C188.7,338.3,189,338.3,189.1,338.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-1"
          points="134.1 310.9 154.5 322.6 155.1 322.3 134.9 310.4 134.1 310.9"
        />
        <polygon
          class="cls-1"
          points="132.2 312.1 152.4 323.8 153.1 323.3 132.9 311.6 132.2 312.1"
        />
        <polygon class="cls-1" points="130.1 313.3 150.4 325 151.2 324.5 130.9 312.8 130.1 313.3" />
        <polygon class="cls-1" points="128.2 314.5 148.3 326.2 149.1 325.7 128.9 314 128.2 314.5" />
        <path
          class="cls-1"
          d="M173.7,342.5l19.7,11.4.9-.3-20.1-11.7A.6.6,0,0,0,173.7,342.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M197,333.2l-20.1-11.7-.8.5,16,9.3c-.1.1-.4.1-.6.3l20,11.5c.3-.2.3-.3.5-.6l-15.6-9Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-1"
          points="147.9 307.9 127.7 296.2 127 296.5 143 305.8 142.2 306.1 162.5 317.9 163.3 317.5 147.3 308.2 147.9 307.9"
        />
        <polygon
          class="cls-1"
          points="141.5 294.7 135.6 291.4 135 291.9 155.2 303.5 155.8 303.1 165.5 308.8 166.3 308.3 142.2 294.4 141.5 294.7"
        />
        <path
          class="cls-1"
          d="M190.8,320.2l-5.9-3.3-.7.4L204.4,329l.7-.4-4.8-2.7,14.8,8.2a3.3,3.3,0,0,1,1.4,0l-25-14.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M222.9,319.4l-6.1-3.7-8-4.7a2.8,2.8,0,0,0-1.6-.1l35.3,20.7.7-.5L223,319.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-1"
          points="157.6 285.3 193.3 305.9 194.1 305.5 158.4 284.8 157.6 285.3"
        />
        <polygon class="cls-1" points="155.7 286.5 191.2 307.1 192 306.7 156.3 286 155.7 286.5" />
        <polygon class="cls-1" points="153.6 287.7 189.3 308.3 190 307.9 154.3 287.2 153.6 287.7" />
        <polygon
          class="cls-1"
          points="151.6 288.7 187.4 309.4 187.9 309.1 152.4 288.4 151.6 288.7"
        />
        <polygon class="cls-1" points="149.5 289.9 185.3 310.6 186 310.3 150.3 289.6 149.5 289.9" />
        <polygon
          class="cls-1"
          points="147.6 291.1 183.3 311.8 183.9 311.5 148.2 290.8 147.6 291.1"
        />
        <path
          class="cls-1"
          d="M192.7,319.1l-5.7-3.3a3.2,3.2,0,0,0-.9.3l20.2,11.7c.3-.1.3-.4.5-.6l21.6,12.4a1.3,1.3,0,0,0,.8-.3l-35.8-20.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M227.4,317a3.2,3.2,0,0,0-.9.3L246.7,329a.9.9,0,0,0,.3-.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-1"
          points="177.2 291.9 197.4 303.5 198.1 303.1 177.9 291.4 177.2 291.9"
        />
      </g>
      <g class="bblock" id="Block">
        <path
          class="cls-3"
          d="M241.9,321.6V292.5l-11.2,6.6a2.9,2.9,0,0,1-1.3.5v29.2l.7-.4Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M197.5,279.6c-.5.3-.5.6-.5.7a1.2,1.2,0,0,0,.5.8l29.9,17.1a3.4,3.4,0,0,0,2.8,0l13.3-7.8a.8.8,0,0,0,.5-.8,1,1,0,0,0-.5-.7l-29.9-17.1a2.7,2.7,0,0,0-1.5-.5,2.4,2.4,0,0,0-1.3.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M245.2,289.5a2.2,2.2,0,0,0-1.1-1.8l-29.9-17.1a4.5,4.5,0,0,0-4.2,0l-13.3,7.8a2,2,0,0,0-1,1.8v30.4a1.8,1.8,0,0,0,1,1.6l29.9,17.1a3.2,3.2,0,0,0,2.1.6h.8a2.1,2.1,0,0,0,1.3-.5l11.1-6.5h0l2.2-1.4a2.4,2.4,0,0,0,1.1-1.5V289.8a.1.1,0,0,0-.1-.1Zm-33.1-18.2a2.7,2.7,0,0,1,1.5.5l29.9,17.1a1,1,0,0,1,.5.7.8.8,0,0,1-.5.8l-13.3,7.8a3.4,3.4,0,0,1-2.8,0l-29.9-17.1a1.2,1.2,0,0,1-.5-.8c0-.1,0-.4.5-.7l13.3-7.8A2.4,2.4,0,0,1,212.1,271.3Zm17.4,28.3a2.9,2.9,0,0,0,1.3-.5l11.2-6.6v29.1l-11.7,6.8-.7.4Z"
          transform="translate(-47.2 -26.7)"
        />
      </g>
      <g id="Lady">
        <path
          class="cls-5"
          d="M244.3,307.9l4.3,1,4.6-1.8-.6-1-1.5-.5s-1.9-.3-2.2-1.3-3.1,0-3.1,0l-2,1.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M248.6,309.5l5.5-2.1-1-1.9-1.8-.6c-.6-.2-1.7-.5-1.8-.9s-.3-.6-.6-.7-2.8.1-3.3.2v.2l-2.3,1.9.6,2.9Zm3.7-2.7-3.9,1.5-3.7-.9-.3-1.2,1.5-1.3a4.2,4.2,0,0,1,2.3-.3c.2,1.2,2.2,1.6,2.6,1.6l1.2.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M229.3,283.3s8.7-2.8,11.1-4.9c0,0-1.5,3.1.3,8.4s2.1,13.6,2.5,17.1a2.2,2.2,0,0,0,1.7,1.6h.7c.9,0,2.8-.7,2.8-1.7.2-7.1.8-30.9-.8-33.1s-8.3-5.1-11.4-4.5l-12.4,2.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M245.8,306.1a3.9,3.9,0,0,0,2.6-1.1,1.9,1.9,0,0,0,.8-1.3c.3-11.5.6-31.3-1.1-33.4s-8.6-5.4-11.9-4.8l-12.4,2.1-.8.2,5.9,16.4h.6c.3-.2,6.4-2.1,9.7-4.1a14.7,14.7,0,0,0,.7,7.1c1.1,3,1.8,9.4,2.3,13.6.1,1.4.3,2.6.4,3.4a2.4,2.4,0,0,0,2.3,2.1l.7.2C245.6,306.1,245.6,306.1,245.8,306.1Zm-8.4-39.4c3.1,0,8.2,2.1,9.9,4.4s1.1,14,.7,32.6c0,.2-.1.3-.3.4a3.1,3.1,0,0,1-1.9.8l-.8-.2a.9.9,0,0,1-1-1c-.2-.7-.3-1.9-.5-3.3-.4-4.5-1-10.8-2.2-13.9-1.8-4.8-.5-7.8-.3-7.8l1.3-2.9-2.4,2.1c-1.9,1.7-8.2,3.9-10.3,4.7l-4.9-13.8,11.6-1.9A2.6,2.6,0,0,1,237.4,266.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M254.1,306.1a2.4,2.4,0,0,0-2.8-.6h.1c.6.5,0,1.2-.9,1.7a4.1,4.1,0,0,1-5.3-.9l-.2-.3v-.3a16.6,16.6,0,0,0-1.3-1.4.7.7,0,0,0-1.2.3,6.5,6.5,0,0,0,.1,4.4l.3,3.4a1.1,1.1,0,0,0,.3.6.2.2,0,0,1,.2.2h.9a7,7,0,0,0,1.2-.3c.1,0,.3-.3.3-.5l-.2-1.6c0-.3.2-.5.5-.3l.4.3a2.6,2.6,0,0,0,1.5.4,2.7,2.7,0,0,0,1.6-.3C252.2,309.5,255.2,307.7,254.1,306.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M243.8,313.6a1.1,1.1,0,0,0,.8-.2l1.2-.3a1,1,0,0,0,.6-.9v-1a3.5,3.5,0,0,0,1.6.6l2-.3c3-1.5,4.3-2.7,4.8-3.9a1.9,1.9,0,0,0-.2-1.5c-.4-.8-1.3-1.4-3.4-.8l-1.1.3.9.6a.2.2,0,0,1,.2.2c0,.1-.2.4-.9.9s-3.7.6-4.6-.8h-.2v-.5h-.1l-1.4-1.4a1,1,0,0,0-1-.3c-.5.2-.8.3-.9.8a7.1,7.1,0,0,0,.1,4.6l.3,3.3a1.4,1.4,0,0,0,.5.9c.1.2.1.2.3.2A.4.4,0,0,1,243.8,313.6Zm2.3-3.8a.6.6,0,0,0-.5.2.5.5,0,0,0-.3.7l.2,1.7-1.1.3h-.1c-.2,0-.3.1-.5,0a1,1,0,0,1-.1-.3l-.5-3.5a5.3,5.3,0,0,1-.1-4c0-.2.1-.2.1-.2h.2l1.2,1.2v.8c1.2,1.8,3.7,2.2,6,1,.4-.3,1.3-.7,1.5-1.5v-.3c.6,0,1.3,0,1.6.5a1,1,0,0,1,.2.7q-.5,1.3-4.2,3.3a3.5,3.5,0,0,1-1.4.3,1.5,1.5,0,0,1-1.1-.4l-.5-.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path class="cls-3" d="M246.2,307.8l.3,1.9h-1l-.3-1.9Z" transform="translate(-47.2 -26.7)" />
        <path
          class="cls-5"
          d="M250.1,242.6l2.5-1.7a4.5,4.5,0,0,1,3.2-.7c1.5.1,2.4.4,3.1,1.8l.2.6-2.6.9v.4l.7.5s-.7,2.7-5.2,1.9S250.1,242.6,250.1,242.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M253.4,246.9c3.7,0,4.5-2.4,4.5-2.5v-.5h-.3l2-.8-.2-1.3a3.7,3.7,0,0,0-3.6-2.1,5.9,5.9,0,0,0-3.6.9l-2.7,1.8a2.9,2.9,0,0,0-.6,2.8c.3.9,1.4,1.5,2.9,1.7Zm3-2.5c-.5.6-1.7,1.5-4.4,1-.7-.1-1.6-.3-1.9-.9a2,2,0,0,1,.3-1.5l2.4-1.6a4.7,4.7,0,0,1,2.7-.8c1.2.2,1.9.3,2.5,1.4l-2.4.7-.3,1.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M247.7,243.5l1.5-.9a.5.5,0,0,1,.7,0,5.5,5.5,0,0,1,1.8,2.7.7.7,0,0,1-.3.9l-1.6.7c-.3.2-.6,0-.8-.3l-1.3-2.2A.5.5,0,0,1,247.7,243.5Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M249.3,247.7l.6-.2,1.7-.7a1.5,1.5,0,0,0,.7-1.7,11.1,11.1,0,0,0-1.9-3,1.4,1.4,0,0,0-1.5-.1l-1.5.9a.9.9,0,0,0-.6.9,1.2,1.2,0,0,0,.2,1l1.3,2.3A1.4,1.4,0,0,0,249.3,247.7Zm.2-4.5a5.4,5.4,0,0,1,1.6,2.4h0l-1.6.8-1.3-2.3h0Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-5"
          d="M230.7,241.8c.4,1.1-.5-1.5,0,0,1.5,3.9,3.3,8.3,3.3,8.3a68.7,68.7,0,0,1,7.3-3.2,22.5,22.5,0,0,0,5.5-3h.2a3.5,3.5,0,0,1,2.3,3.2v.3c-1,1-10.8,9.7-17.9,11.4a25.3,25.3,0,0,1-6.3-11C223.2,240.5,229.9,239.1,230.7,241.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M231.3,259.2h.3c7.3-1.6,17.1-10.5,18.2-11.5a1.9,1.9,0,0,0,.3-.8,4.1,4.1,0,0,0-2.8-3.7c-.3-.2-.6,0-.8.1a23.2,23.2,0,0,1-5.4,3c-2.4.9-5.5,2.3-6.8,2.9-.6-1.4-1.8-4.5-3-7.5a.2.2,0,0,0-.2-.2,1.1,1.1,0,0,0-.3-.6,2.9,2.9,0,0,0-3.4-.7c-2.4.7-4.2,3.4-2.9,7.8a24.7,24.7,0,0,0,6.5,11.2Zm17.6-12.4c-1.5,1.3-10.5,9.3-17.2,11.1a26.4,26.4,0,0,1-5.8-10.4c-1.1-3.7.4-5.7,2.1-6.1s1.8-.2,2.1.4a.7.7,0,0,0,.3.6l3.1,7.8.3.6.6-.3a65.3,65.3,0,0,1,7.3-3.1,22.1,22.1,0,0,0,5.6-3A3.6,3.6,0,0,1,248.9,246.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-5"
          d="M262.8,304a4.3,4.3,0,0,0,2.8,1.3,3.5,3.5,0,0,1,2.7,1.5l-2.2,2.9-4.6-.2-2.6-1.8-.7-3,2.8-1.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M266.4,310.1l2.8-3.4-.3-.5a4.2,4.2,0,0,0-3.1-1.8,3.7,3.7,0,0,1-2.4-1h-.2l-2-.9-3.6,1.6.9,3.7,2.8,2.1Zm1.2-3.4-1.8,2.2h-4l-2.1-1.5-.5-2.3,2.1-.9,1.2.5a5.1,5.1,0,0,0,3.3,1.3A2.5,2.5,0,0,1,267.6,306.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M214.4,281.4s11,18.9,38.7-2.3c.1-.1.3,0,.3.2a12.9,12.9,0,0,0,.6,8.7c1.8,3.9,3.4,12.6,4.2,15.9a1.7,1.7,0,0,0,1.6,1.4h.8c.9,0,2.2-.9,2.2-1.9-.3-7-1.3-30.9-3-32.8s-8.8-2.8-11.9-2.1l-20.8,5.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M260.6,305.9a3.4,3.4,0,0,0,2.2-1,2,2,0,0,0,.6-1.6V303c-.9-21.3-1.8-31.4-3.1-32.8-2.9-3.3-9.3-3.2-12.6-2.3l-20.8,5.8h-.1l-13.2,7.4.3.6a18.2,18.2,0,0,0,11.7,7.6c7.8,1.5,16.9-1.5,27-9a14.3,14.3,0,0,0,.9,7.8c1.7,3.6,3.2,11.3,3.9,15l.2.8a2.4,2.4,0,0,0,2.2,1.9Zm-8.3-37.2c2.7,0,5.6.6,7.1,2.4s1.8,7,2.8,32v.3a1.5,1.5,0,0,1-.3.7,2.2,2.2,0,0,1-1.3.6h-.8a1,1,0,0,1-1-.8l-.2-.8c-.7-3.7-2.4-11.5-4-15.3a11.9,11.9,0,0,1-.5-8.2c.2-.5,0-.8-.3-.9a.8.8,0,0,0-.9,0c-10.3,7.8-19.2,10.9-27,9.4a17.1,17.1,0,0,1-10.5-6.6l12-6.7,20.7-5.7A17.1,17.1,0,0,1,252.3,268.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M269.8,307c-.4-1.7-1.9-2-4-1.7a3,3,0,0,1,1.3.9c.6.6,0,1.2-1.2,1.7s-4.4.3-5.5-1.5a.7.7,0,0,0-.3-.3l-.3-.5h-.1a8.8,8.8,0,0,0-1.2-1.5.9.9,0,0,0-1.4.1,6.5,6.5,0,0,0-.1,4.5v3.6a.6.6,0,0,0,.3.6.4.4,0,0,0,.4.2,3.9,3.9,0,0,0,1.7-.2c.1,0,.3-.3.4-.4l.2-1.8c0-.2.1-.3.3-.2l.3.3,1,.8a3.6,3.6,0,0,0,2.5,0C266.8,310.7,270.3,309.2,269.8,307Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M258.2,313.7h1.3c.5-.2.8-.5.8-.9v-1.4a3,3,0,0,0,1.1.6,3.6,3.6,0,0,0,2.9.2c2-.8,6.8-2.4,6-5.3s-3.6-2.2-4.5-2.1l-2.4.3,2.4.8a2.1,2.1,0,0,1,1.1.7v.2c0,.1-.3.4-1,.7s-4.1.3-4.9-1.2h0l-.3-.3-.3-.5-.5.2.5-.3c-.3-.3-.6-.9-1.2-1.5a1.7,1.7,0,0,0-1.2-.4,1.2,1.2,0,0,0-1.1.7,7.3,7.3,0,0,0-.1,4.8v3.6a1.1,1.1,0,0,0,.4.9l.6.3C257.7,313.7,257.9,313.7,258.2,313.7Zm1.9-3.6h-.3c-.3.2-.4.3-.4.6l-.2,1.8-1.3.2h-.3s-.2-.2-.2-.3v-3.8a7.4,7.4,0,0,1,.2-4.2.3.3,0,0,1,.3-.3l.3.2c.4.6.9,1,1.2,1.5l.4.6.3.3c1.2,1.9,3.6,2.5,6,1.6a2,2,0,0,0,1.6-1.5,1.3,1.3,0,0,0-.3-1v-.2c1.5.2,1.8.8,1.9,1.4s-2.8,3.3-5.4,4.2a2.8,2.8,0,0,1-2.2,0l-.9-.6-.3-.3C260.4,310.1,260.3,310.1,260.1,310.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path class="cls-3" d="M259.2,307.6h1.1V310h-1.1Z" transform="translate(-47.2 -26.7)" />
        <path
          class="cls-1"
          d="M254,279.4a3.9,3.9,0,0,1,1.3-2.5l-.7-1.1a6.3,6.3,0,0,0-1.8,3.3l1.2.3h0Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M212.9,250.7s-2.4,15.3-3.6,23.5,9.4,12.7,16.3,13.5,14-2.9,16.3-6.5a14,14,0,0,1,5.5-5.2s-8.8-6.1-11.2-21.9S225,235.9,224.4,236,212.9,250.7,212.9,250.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M227.5,288.6c6.5,0,12.7-3.5,14.8-6.9a16.9,16.9,0,0,1,5.3-5.1l.8-.5-.8-.6c-.2,0-8.6-6.1-11.1-21.4-2.7-16.9-12.3-18.7-12.4-18.7s-.8,0-12,14.8v.2h0s-2.4,15.3-3.6,23.5a8.6,8.6,0,0,0,1.8,6.9c3.1,4.2,9.9,6.8,15.1,7.4A6.4,6.4,0,0,0,227.5,288.6ZM246.2,276a15.9,15.9,0,0,0-4.9,4.9c-2,3.2-8.8,7.1-15.7,6.2-5-.6-11.4-3-14.2-6.9a7.9,7.9,0,0,1-1.7-6c1.2-7.8,3.3-21.7,3.6-23.4,3.8-5.1,9.9-12.9,11.1-14.2,1.2.3,8.7,3.3,10.9,17.7S244,274.2,246.2,276Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-3"
          d="M244.1,277.3l.6-.7c-7-4.7-10.3-15.4-10.4-15.6l-.9.3C233.5,261.8,236.9,272.5,244.1,277.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-5"
          d="M259.8,246.9a9.2,9.2,0,0,1,2.1-3.4c.9-.8,1.5,0,1.8.4a.4.4,0,0,0,.4.2l2.6-1.5a.6.6,0,0,1,.9.1,3.4,3.4,0,0,1,.1,3.5c-1,2.7-5.5,3.6-5.5,3.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M262,250.5h.5c.1,0,4.8-1.1,6-4.1a4.4,4.4,0,0,0-.3-4,1.3,1.3,0,0,0-1.7-.5l-2.4,1.4c-.3-.3-.7-.8-1.2-.8a1.8,1.8,0,0,0-1.3.5,10.2,10.2,0,0,0-2.2,3.7l-.2.3Zm5-7.3c.4.4.7,1.3.1,2.8s-3.3,2.9-4.6,3.2l-1.9-2.4a8.5,8.5,0,0,1,1.7-2.9h.3a.6.6,0,0,1,.6.4.8.8,0,0,0,1.2.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-5"
          d="M231.6,243.9a2.1,2.1,0,0,1,2.1-.9,3.3,3.3,0,0,1,1,.6,33.8,33.8,0,0,1,4,5c2.4,3.7,7.7,10.5,7.7,10.5s3.7-3.3,6.4-5.4a29.9,29.9,0,0,0,4.8-4.7h.1a3.2,3.2,0,0,1,3.2,2.4v.3c-.8,1.2-7.7,12.1-14.2,16.3a1.2,1.2,0,0,1-1.4-.1c-2.1-1.8-8.4-7.7-11.5-12.9S230.7,245.4,231.6,243.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M246.1,268.7a3.2,3.2,0,0,0,.9-.3c6.5-4.2,13.6-15.3,14.3-16.5s1.4-2.1,1.4-2.2c-.6-2.1-2-3.1-3.3-3.1s-1.7,2.3-1.8,2.4a30.1,30.1,0,0,1-5.3,4.1c-2.2,1.6-4.9,4-5.9,4.9a118.4,118.4,0,0,1-7.2-9.9,26.3,26.3,0,0,0-4.1-4.9,5.7,5.7,0,0,0-1.3-.8,3.1,3.1,0,0,0-2.8,1.2c-1.5,2.6-.8,6.3,2.2,11.4s9.7,11.4,11.7,13.1A1.4,1.4,0,0,0,246.1,268.7Zm14.2-17.4c-1.1,1.6-7.7,12-13.9,16-.2.2-.5.2-.6,0-2-1.6-8.3-7.5-11.4-12.7s-3.4-8.1-2.2-10.2l-.5-.3.6.3a1.3,1.3,0,0,1,1.5-.6.7.7,0,0,1,.7.4,26.3,26.3,0,0,1,3.9,4.8c2.4,3.8,7.7,10.5,7.7,10.7l.4.6.5-.5s3.7-3.3,6.4-5.4a31,31,0,0,0,4.8-4.6C258.5,249.5,259.7,249.8,260.3,251.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-6"
          d="M260.9,246.1l-3,4.1,2,1.5,2.9-2.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M247.1,262.1a9,9,0,0,0-.1-3.2l-1.2.3a6.4,6.4,0,0,1,.1,2.7Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-3"
          d="M230.4,234.1s-1.2,3.7-.2,5.5-3.6,1.3-3.6,1.3l-4.6-3.2a10.5,10.5,0,0,0,1.3-4.2c-.1-2-.3-2.1.2-2S230.4,234.1,230.4,234.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M227.8,241.5c1.1,0,2.4-.1,2.9-.9a1.4,1.4,0,0,0,0-1.3c-.8-1.4-.2-4,.1-5.1l.2-.6h-.6l-7.1-2.7a.6.6,0,0,0-.7.1c-.3.3-.3.6-.3,1.2a8.2,8.2,0,0,0,.1,1.4c.2,1.6-1.2,3.9-1.2,3.9l-.3.4,5.3,3.7h1.6Zm1.8-7.1c-.3,1.2-.7,3.8,0,5.5h0c-.1.3-1.6.3-2.8.3l-4.1-2.9a8.3,8.3,0,0,0,1.1-4.1,2.3,2.3,0,0,0-.2-1.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M229.9,215.6s5.7-.3,7.6,4.7-1.9,8.7-1.9,8.7-4.9-1.5-5.7-3.8S229.9,215.6,229.9,215.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M235.7,229.7l.3-.3a8.9,8.9,0,0,0,2.1-9.4c-1.9-5.3-8.2-5.1-8.2-5.1h-.6v.6c0,.3-.9,7.5,0,9.9s5.5,4,6.1,4.2Zm-5.2-13.5c1.4.2,5.1.6,6.4,4.4a7.8,7.8,0,0,1-1.5,7.8c-1.4-.5-4.3-1.8-4.9-3.3S230.2,218.5,230.5,216.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-5"
          d="M226.6,216.2s-4-3.3-5.5,5c-1,5.8,1.2,9.3,5.5,12.6a4.4,4.4,0,0,0,4.2.7,5.9,5.9,0,0,0,3.6-4.2,21.3,21.3,0,0,0,.6-10c.7-3.5-1.5-3-5.5-4.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M229.5,235.6l1.5-.3a6.5,6.5,0,0,0,4-4.7,22.3,22.3,0,0,0,.6-10.2,3.3,3.3,0,0,0-.2-2.5c-.6-.9-1.7-1.2-3.4-1.5l-2.4-.6h-.1l-2.7-.2a3.2,3.2,0,0,0-3-.4c-1.7.6-2.7,2.5-3.4,6-1.1,5.5.5,9.3,5.6,13.2A7.3,7.3,0,0,0,229.5,235.6Zm-.2-18.6,2.4.6c1.4.3,2.4.4,2.7,1a5.1,5.1,0,0,1,0,1.8v.2h0a19.7,19.7,0,0,1-.6,9.6,5.6,5.6,0,0,1-3.1,3.8,3.7,3.7,0,0,1-3.6-.8c-3.9-3-6.3-6.3-5.3-12,.8-3.6,1.8-4.8,2.6-5.1a2.2,2.2,0,0,1,1.9.5h.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-5"
          d="M229.3,243.6c1.8.3,4.8-2.1,3.3-3.3h-.1c-1.2-.8-5,.3-7.2-1.2s-1.8-2.2-1.7-2.8a.9.9,0,0,0-.3-1.1,1.4,1.4,0,0,0-1-.3,2.4,2.4,0,0,0-1.7,3.3,8.5,8.5,0,0,0,4.8,4.5A9,9,0,0,0,229.3,243.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M229.6,244.4a4.7,4.7,0,0,0,3.9-2.4,1.8,1.8,0,0,0-.4-2.1l-.3-.2a6.4,6.4,0,0,0-2.9-.4,8.7,8.7,0,0,1-4.3-.7c-1.5-.9-1.5-1.8-1.4-2.1a1.5,1.5,0,0,0-.6-1.7,3.4,3.4,0,0,0-1.5-.4,2.2,2.2,0,0,0-1.9,1.2,3.2,3.2,0,0,0-.3,3,9.8,9.8,0,0,0,5.1,4.9,19.5,19.5,0,0,0,4,1C229.3,244.2,229.5,244.4,229.6,244.4Zm.8-3.9h1.8s.1,0,.1.2a.4.4,0,0,1,.2.6,3.4,3.4,0,0,1-3,1.6,22.3,22.3,0,0,1-3.9-.9,8,8,0,0,1-4.4-4,2.8,2.8,0,0,1,.2-1.8c.3-.3.6-.6.9-.6s.4,0,.6.2.1.3.1.4-.1,2.1,2,3.4,3.4.9,4.9.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M228.1,212.9c3.2.5,6.9,3,7.5,5.1s.4,4.1-2.2,3.8c-1.1-.2-2,2.7-2.3,3.7s-1.2,1.1-1.5.9-1.9,1.1-2.1,2.3a3.4,3.4,0,0,0,.9,2.7c-1.8,4.2,6.6,8.8-1.6,12.1-.2.1,5.7,8.2-2,12.7s-19.1,2.4-22.1-4.9c-4.9-12.8,12.6-15.1,13.3-26.1C216.8,217,223,212.3,228.1,212.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M216.3,259.1a18.8,18.8,0,0,0,8.8-2.1c3.2-2,6.3-5.7,2.6-13.1a5.9,5.9,0,0,0,3.3-2.8c.6-1.7-.2-3.3-.9-4.9s-1.5-3-.9-4.4v-.4l-.4-.3a3.1,3.1,0,0,1-.6-2.1,2.1,2.1,0,0,1,.7-1.5l.6-.3a2.3,2.3,0,0,0,2.1-1.4c0-.1.2-.3.2-.6.7-2.2,1.2-2.8,1.5-2.8s2.2-.2,2.6-.8.6-1.9.2-3.9-4.6-5.1-8.1-5.5a10.4,10.4,0,0,0-7.5,2.4,15.5,15.5,0,0,0-5.2,10.8c-.3,4.5-3.7,7.5-7,10.5s-9.1,8.2-6.1,15.7c1,2.8,3.6,4.9,7.1,6.3A17.6,17.6,0,0,0,216.3,259.1Zm11.4-27.3c-.5,1.8.3,3.5,1,5s1.4,2.8.9,3.8-1.3,1.7-3.1,2.4l-.3.2-.2.3c-.1.3,0,.4.3,1,2.9,5.3,2.1,9-1.9,11.4s-9.9,2.6-14.7.9c-2.2-.7-5.2-2.4-6.4-5.5-2.7-6.8,1.5-10.5,5.8-14.4s7.2-6.3,7.5-11.4a14,14,0,0,1,4.8-9.9,8.9,8.9,0,0,1,6.6-2.1c2.8.3,6.4,2.7,7,4.7s.3,2.4.1,2.7-1,.4-1.6.3-2.2,2.1-2.8,3.6l-.2.4a1.1,1.1,0,0,1-.9.6,2.6,2.6,0,0,0-1.5.6,3.8,3.8,0,0,0-1.3,2.4A5.6,5.6,0,0,0,227.7,231.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M234.1,221.9c.4-3.3-1.3-5.1-2.5-5.5l-.5,1.2c.2,0,2.3,1,1.8,4.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M226.2,243.9l1.2-.4a10.3,10.3,0,0,0-2-3.6l-.9.9A11,11,0,0,1,226.2,243.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M219.6,225.2a11.4,11.4,0,0,1,2.7-6.4l-.9-.9c-.2.1-2.7,2.4-3.1,7.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M209.4,254.3l.6-1.1a6.2,6.2,0,0,1-3.2-4.9h-1.2A7.7,7.7,0,0,0,209.4,254.3Z"
          transform="translate(-47.2 -26.7)"
        />
      </g>
      <g class="bblock" id="Block_2-2" data-name="Block 2">
        <path
          class="cls-3"
          d="M205.3,322.7V308.3l-11.1,6.5a2.9,2.9,0,0,1-1.3.5v14.5l.7-.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M207.9,317.3v-9.4h.8v-2.6h0a2.2,2.2,0,0,0-1.1-1.8L194,295.6a4.3,4.3,0,0,0-4.1,0l-13.3,7.8a2.1,2.1,0,0,0-1.1,1.8,1.9,1.9,0,0,0,.2.7v14.9h0a1.8,1.8,0,0,0,1,1.7l13.5,7.8a3.5,3.5,0,0,0,2.1.6h.7a2.9,2.9,0,0,0,1.3-.5l11-6.4h0l2.2-1.4.5-.4a2.1,2.1,0,0,0,.7-1.2v-3.8Zm-14.5-20.5,13.6,7.8a1,1,0,0,1,.5.7.8.8,0,0,1-.5.8l-13.3,7.8a3.4,3.4,0,0,1-2.8,0l-13.6-7.8a1,1,0,0,1-.4-.8.8.8,0,0,1,.4-.7l13.3-7.8a2.7,2.7,0,0,1,2.8,0Zm-.4,18.5a2.9,2.9,0,0,0,1.3-.5l11.1-6.5v14.4l-11.6,6.8-.7.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M177.3,304.6a.8.8,0,0,0-.4.7,1,1,0,0,0,.4.8l13.6,7.8a3.4,3.4,0,0,0,2.8,0l13.3-7.8a.8.8,0,0,0,.5-.8,1,1,0,0,0-.5-.7l-13.6-7.8a2.7,2.7,0,0,0-2.8,0Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon
          class="cls-3"
          points="161.8 281.2 161.5 281.2 160.7 281.2 160.7 290.7 161.5 290.7 161.8 290.7 161.8 281.2"
        />
      </g>
      <g class="bblock" id="Block_3-2" data-name="Block 3">
        <path
          class="cls-2"
          d="M191.5,298.1a3.4,3.4,0,0,1,1.2-1.6l5.7-3.3-6.7-4.2-6.5,3.8a2.3,2.3,0,0,0-.7.9Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-3"
          d="M199.6,294.1v-.3l-6.5,3.8a1.8,1.8,0,0,0-.7,1.3V305a.4.4,0,0,0,.2.3l6.2-3.7a1.6,1.6,0,0,0,.8-1.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M200.5,292.8h-.8l-7.6-4.7a1.1,1.1,0,0,0-1.3,0l-6.5,3.7a3.3,3.3,0,0,0-1.3,2.6v6.1a3.1,3.1,0,0,0,.4,1.2l.2.2,7.8,4.7h.6c.1.2.4.2.6.2a1,1,0,0,0,.7-.2l6.4-3.7a2.9,2.9,0,0,0,1.4-2.5v-6.2C201.1,293.5,200.8,292.9,200.5,292.8Zm-1.7,8.8-6.2,3.7a.4.4,0,0,1-.2-.3v-6.1a1.8,1.8,0,0,1,.7-1.3l6.5-3.8v6.5A1.6,1.6,0,0,1,198.8,301.6Zm-13.6-8.8,6.5-3.8,6.7,4.2-5.7,3.3a3.4,3.4,0,0,0-1.2,1.6l-7-4.4A2.3,2.3,0,0,1,185.2,292.8Zm-.5,4.9,6.8,4.1-.5.9-6.8-4.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon class="cls-3" points="137 271.9 143.8 276 144.3 275.1 137.5 271 137 271.9" />
      </g>
      <g class="bblock" id="Block_4-2" data-name="Block 4">
        <path
          class="cls-3"
          d="M196.4,280.2a7.3,7.3,0,0,1-7,0l-.3-.2,1.1,10.2c0,.5.4.9,1.6,1.2a3.7,3.7,0,0,0,2.1,0c1.2-.3,1.6-.7,1.6-1.2l1.1-10.1Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-3"
          d="M194.4,279.6l1.3-.5a1.7,1.7,0,0,0,1-1.3c0-.5-.4-.9-1-1.4a5.3,5.3,0,0,0-1.9-.6Z"
          transform="translate(-47.2 -26.7)"
        />
        <path class="cls-3" d="M192.7,278.2l-.4-2.5-1,.2Z" transform="translate(-47.2 -26.7)" />
        <path
          class="cls-3"
          d="M188.8,277.8c0,.4.5.9,1.1,1.3a3.1,3.1,0,0,0,1.9.6l-1.9-3.3h0C189.1,276.9,188.8,277.3,188.8,277.8Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M198.1,277.8a2.9,2.9,0,0,0-1.7-2.4,6.6,6.6,0,0,0-2.8-.9l-.6-3.3-1.5.3.6,3-1.4.3-4.2-6.9-1.3.8,4.1,6.8a2.9,2.9,0,0,0-1.5,2.2c-.1.2-.2.3-.2.5l1.2,12.2c0,1,.9,1.9,2.6,2.4h2.8c1.6-.5,2.5-1.4,2.5-2.4l1.2-11.8A2.4,2.4,0,0,0,198.1,277.8Zm-4.2,13.6a3.7,3.7,0,0,1-2.1,0c-1.2-.3-1.6-.7-1.6-1.2L189.1,280l.3.2a7.3,7.3,0,0,0,7,0h.2l-1.1,10.1C195.5,290.7,195.1,291.1,193.9,291.4Zm-4-15,1.9,3.3a3.1,3.1,0,0,1-1.9-.6c-.6-.4-1.1-.9-1.1-1.3s.3-.9,1.1-1.4Zm6.8,1.4a1.7,1.7,0,0,1-1,1.3l-1.3.5-.6-3.8a5.3,5.3,0,0,1,1.9.6C196.3,276.9,196.7,277.3,196.7,277.8Zm-4,.4-1.4-2.3,1-.2Z"
          transform="translate(-47.2 -26.7)"
        />
      </g>
      <g class="bblock" id="Block_5-2" data-name="Block 5">
        <path
          class="cls-3"
          d="M208.7,338.9v-5.5l-11.2,6.5a3.1,3.1,0,0,1-1.3.6v5.6l.7-.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-2"
          d="M180.7,329.9a.9.9,0,0,0-.4.8c0,.1.1.6.4.7l13.6,7.8a3.7,3.7,0,0,0,2.9,0l13.3-7.8a.8.8,0,0,0,.4-.7,1,1,0,0,0-.4-.8l-13.6-7.8a3.1,3.1,0,0,0-1.5-.4c-.5,0-1.1,0-1.4.4Zm16.3,5.3-5.3-3.2,8.2-4.8,5.4,3.2Z"
          transform="translate(-47.2 -26.7)"
        />
        <path
          class="cls-1"
          d="M212,330.4a2.2,2.2,0,0,0-1.1-1.8l-13.6-7.8a4,4,0,0,0-4.2,0l-13.3,7.8a2,2,0,0,0-1,1.8v6.8a2.1,2.1,0,0,0,1,1.7l13.5,7.8a3.2,3.2,0,0,0,2.2.7h.8a3.1,3.1,0,0,0,1.3-.6l11.1-6.4h0l2.2-1.4a2.4,2.4,0,0,0,1.1-1.5h0v-6.8h0Zm-15.1-8.3,13.6,7.8a1,1,0,0,1,.4.8.8.8,0,0,1-.4.7l-13.3,7.8a3.7,3.7,0,0,1-2.9,0l-13.6-7.8c-.3-.1-.4-.6-.4-.7a.9.9,0,0,1,.4-.8l13.3-7.8c.3-.4.9-.4,1.4-.4A3.1,3.1,0,0,1,196.9,322.1Zm-.6,18.4a3.1,3.1,0,0,0,1.3-.6l11.2-6.5v5.5L197,345.8l-.7.3Z"
          transform="translate(-47.2 -26.7)"
        />
        <polygon class="cls-2" points="149.7 307 155.5 303.7 152.5 302 146.8 305.3 149.7 307" />
        <path
          class="cls-1"
          d="M191.7,332l5.3,3.2,8.3-4.8-5.4-3.2Zm2.3,0,5.7-3.3,3,1.7-5.8,3.3Z"
          transform="translate(-47.2 -26.7)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    auditLogs() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-auditlogs",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 0.5,
          },
        })
        .add("audit")
        .from("#blackboard-words path, #blackboard-words polygon", {
          opacity: 0,
          stagger: 0.005,
          ease: "sine",
        })
        .from(
          ".bblock",
          {
            opacity: 0,
            rotation: -30,
            transformOrigin: "50% 50%",
            stagger: 0.1,
            ease: "back",
          },
          "audit"
        );
    },
  },
  mounted() {
    this.auditLogs();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: #0e1e25;
}

.cls-2 {
  fill: #fff;
}

.cls-3 {
  fill: #ffad43;
}

.cls-4 {
  fill: none;
}

.cls-5 {
  fill: #caa677;
}

.cls-6 {
  fill: #caa577;
}
</style>
